"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * finance
 * Home to various finance-related functions
 *
 * The version of the OpenAPI document: 1.80.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingCycleApiFp = exports.BillingCycleApiAxiosParamCreator = exports.AccountSettlementApi = exports.AccountSettlementApiFactory = exports.AccountSettlementApiFp = exports.AccountSettlementApiAxiosParamCreator = exports.AccountDeactivationApi = exports.AccountDeactivationApiFactory = exports.AccountDeactivationApiFp = exports.AccountDeactivationApiAxiosParamCreator = exports.AccountAdjustmentApi = exports.AccountAdjustmentApiFactory = exports.AccountAdjustmentApiFp = exports.AccountAdjustmentApiAxiosParamCreator = exports.AccountApi = exports.AccountApiFactory = exports.AccountApiFp = exports.AccountApiAxiosParamCreator = exports.TransformerType = exports.TermUnit = exports.SupplySubAccountIntegrationType = exports.SubAccountType = exports.SaasSubscriptionStatus = exports.SaasPlanPaymentCadence = exports.SaasFeeReason = exports.ReportingApiCallStatus = exports.ReconciliationType = exports.ProductType = exports.ProductSubType = exports.Order = exports.OnboardingContractType = exports.LifeInsuranceTermUnit = exports.LedgerItemType = exports.LedgerItemReason = exports.LedgerItemEventType = exports.FileType = exports.ExtractorType = exports.ExternalDemandEventType = exports.DemandSubAccountOfferFirmness = exports.DemandPlatformFeePercentOf = exports.DemandDataImportStatusErrorType = exports.DemandDataImportStatus = exports.DemandDataImportSource = exports.DemandDataImportLineErrorType = exports.DemandDataFileSource = exports.AdjustmentReason = exports.AccountTierTypeCreateData = exports.AccountTierType = exports.AccountSettlementStatus = exports.AccountSettlementSort = void 0;
exports.LedgerItemReconciliationApi = exports.LedgerItemReconciliationApiFactory = exports.LedgerItemReconciliationApiFp = exports.LedgerItemReconciliationApiAxiosParamCreator = exports.LedgerItemPostBackApi = exports.LedgerItemPostBackApiFactory = exports.LedgerItemPostBackApiFp = exports.LedgerItemPostBackApiAxiosParamCreator = exports.LedgerItemApi = exports.LedgerItemApiFactory = exports.LedgerItemApiFp = exports.LedgerItemApiAxiosParamCreator = exports.ExternalDemandEventApi = exports.ExternalDemandEventApiFactory = exports.ExternalDemandEventApiFp = exports.ExternalDemandEventApiAxiosParamCreator = exports.ExpectedEarningsShareApi = exports.ExpectedEarningsShareApiFactory = exports.ExpectedEarningsShareApiFp = exports.ExpectedEarningsShareApiAxiosParamCreator = exports.DemandSubAccountOwnerApi = exports.DemandSubAccountOwnerApiFactory = exports.DemandSubAccountOwnerApiFp = exports.DemandSubAccountOwnerApiAxiosParamCreator = exports.DemandSubAccountDeactivationApi = exports.DemandSubAccountDeactivationApiFactory = exports.DemandSubAccountDeactivationApiFp = exports.DemandSubAccountDeactivationApiAxiosParamCreator = exports.DemandSubAccountApi = exports.DemandSubAccountApiFactory = exports.DemandSubAccountApiFp = exports.DemandSubAccountApiAxiosParamCreator = exports.DemandDataImportConfigurationApi = exports.DemandDataImportConfigurationApiFactory = exports.DemandDataImportConfigurationApiFp = exports.DemandDataImportConfigurationApiAxiosParamCreator = exports.DemandDataImportApi = exports.DemandDataImportApiFactory = exports.DemandDataImportApiFp = exports.DemandDataImportApiAxiosParamCreator = exports.DemandDataFileApi = exports.DemandDataFileApiFactory = exports.DemandDataFileApiFp = exports.DemandDataFileApiAxiosParamCreator = exports.ContractApi = exports.ContractApiFactory = exports.ContractApiFp = exports.ContractApiAxiosParamCreator = exports.BillingCycleApi = exports.BillingCycleApiFactory = void 0;
exports.SubAccountExternalDemandEventApiFp = exports.SubAccountExternalDemandEventApiAxiosParamCreator = exports.SubAccountApi = exports.SubAccountApiFactory = exports.SubAccountApiFp = exports.SubAccountApiAxiosParamCreator = exports.SaasTrialApi = exports.SaasTrialApiFactory = exports.SaasTrialApiFp = exports.SaasTrialApiAxiosParamCreator = exports.SaasSubscriptionApi = exports.SaasSubscriptionApiFactory = exports.SaasSubscriptionApiFp = exports.SaasSubscriptionApiAxiosParamCreator = exports.SaasPlanApi = exports.SaasPlanApiFactory = exports.SaasPlanApiFp = exports.SaasPlanApiAxiosParamCreator = exports.SaasMigrationSettingApi = exports.SaasMigrationSettingApiFactory = exports.SaasMigrationSettingApiFp = exports.SaasMigrationSettingApiAxiosParamCreator = exports.SaasMigrationApi = exports.SaasMigrationApiFactory = exports.SaasMigrationApiFp = exports.SaasMigrationApiAxiosParamCreator = exports.SaasFeeCouponApi = exports.SaasFeeCouponApiFactory = exports.SaasFeeCouponApiFp = exports.SaasFeeCouponApiAxiosParamCreator = exports.SaasFeeApi = exports.SaasFeeApiFactory = exports.SaasFeeApiFp = exports.SaasFeeApiAxiosParamCreator = exports.ReportingAPICallsApi = exports.ReportingAPICallsApiFactory = exports.ReportingAPICallsApiFp = exports.ReportingAPICallsApiAxiosParamCreator = exports.RecurlyTokenApi = exports.RecurlyTokenApiFactory = exports.RecurlyTokenApiFp = exports.RecurlyTokenApiAxiosParamCreator = exports.OnboardingContractSignatureApi = exports.OnboardingContractSignatureApiFactory = exports.OnboardingContractSignatureApiFp = exports.OnboardingContractSignatureApiAxiosParamCreator = exports.OnboardingContractApi = exports.OnboardingContractApiFactory = exports.OnboardingContractApiFp = exports.OnboardingContractApiAxiosParamCreator = void 0;
exports.SupplySubAccountOwnerApi = exports.SupplySubAccountOwnerApiFactory = exports.SupplySubAccountOwnerApiFp = exports.SupplySubAccountOwnerApiAxiosParamCreator = exports.SupplySubAccountDeactivationApi = exports.SupplySubAccountDeactivationApiFactory = exports.SupplySubAccountDeactivationApiFp = exports.SupplySubAccountDeactivationApiAxiosParamCreator = exports.SupplySubAccountApi = exports.SupplySubAccountApiFactory = exports.SupplySubAccountApiFp = exports.SupplySubAccountApiAxiosParamCreator = exports.SupplyEmbedUrlApi = exports.SupplyEmbedUrlApiFactory = exports.SupplyEmbedUrlApiFp = exports.SupplyEmbedUrlApiAxiosParamCreator = exports.SupplyEmbedDomainApi = exports.SupplyEmbedDomainApiFactory = exports.SupplyEmbedDomainApiFp = exports.SupplyEmbedDomainApiAxiosParamCreator = exports.SubAccountOwnerApi = exports.SubAccountOwnerApiFactory = exports.SubAccountOwnerApiFp = exports.SubAccountOwnerApiAxiosParamCreator = exports.SubAccountExternalDemandEventApi = exports.SubAccountExternalDemandEventApiFactory = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.AccountSettlementSort = {
    Id: 'id',
    AccountId: 'accountId',
    Status: 'status',
    CreatedAt: 'createdAt',
    StartedAt: 'startedAt',
    CompletedAt: 'completedAt'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.AccountSettlementStatus = {
    Pending: 'pending',
    Started: 'started',
    Success: 'success',
    Skipped: 'skipped',
    Error: 'error'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.AccountTierType = {
    Growth: 'growth',
    Internal: 'internal',
    Legacy: 'legacy',
    Scale: 'scale',
    Starter: 'starter',
    StarterLegacy: 'starter_legacy',
    Trial: 'trial'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.AccountTierTypeCreateData = {
    Starter: 'starter',
    Growth: 'growth',
    Scale: 'scale'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.AdjustmentReason = {
    MonthlyTenPercent: 'monthly_ten_percent',
    CustomerReporting: 'customer_reporting',
    SavingsRevenue: 'savings_revenue',
    CreditCardRevenue: 'credit_card_revenue',
    EmailRevenue: 'email_revenue',
    PreReported: 'pre_reported',
    Promotional: 'promotional',
    LeadTestingAdjustment: 'lead_testing_adjustment',
    Other: 'other'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.DemandDataFileSource = {
    Admin: 'admin',
    Api: 'api',
    Email: 'email',
    EvenFtp: 'even_ftp',
    ExternalFtp: 'external_ftp',
    Portal: 'portal',
    Unknown: 'unknown'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.DemandDataImportLineErrorType = {
    ExternalDemandEventError: 'external_demand_event_error',
    ExtractorFailed: 'extractor_failed',
    MissingRequiredField: 'missing_required_field',
    TransformerFailed: 'transformer_failed',
    UnknownLeadUuid: 'unknown_lead_uuid',
    UnparsableField: 'unparsable_field',
    DemandDataImportLineInsertionError: 'demand_data_import_line_insertion_error',
    LeadLookupFailed: 'lead_lookup_failed',
    MissingLeadUuidForRevenue: 'missing_lead_uuid_for_revenue',
    MissingAmountForRevenue: 'missing_amount_for_revenue'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.DemandDataImportSource = {
    ManualUpload: 'manualUpload',
    Sftp: 'sftp'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.DemandDataImportStatus = {
    Started: 'started',
    Completed: 'completed',
    Failed: 'failed'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.DemandDataImportStatusErrorType = {
    MalformedHeaders: 'malformed_headers',
    UnparsableFile: 'unparsable_file',
    MetadataError: 'metadata_error',
    ProcessingError: 'processing_error'
};
/**
 * An enumeration which indicates whether a percentage value for demand platform fees is relative to the gross revenue or the financial product monetary value, e.g. the loan amount.
 * @export
 * @enum {string}
 */
exports.DemandPlatformFeePercentOf = {
    NetworkPayout: 'networkPayout',
    FinancialProductMonetaryValue: 'financialProductMonetaryValue'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.DemandSubAccountOfferFirmness = {
    PreSelected: 'preSelected',
    PreApproved: 'preApproved',
    PreQualified: 'preQualified'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ExternalDemandEventType = {
    CreditCardApplied: 'credit_card/applied',
    CreditCardApproved: 'credit_card/approved',
    CreditCardFunded: 'credit_card/funded',
    CreditCardOpened: 'credit_card/opened',
    CreditCardRejected: 'credit_card/rejected',
    CreditCardIssuerPreQualificationApplication: 'credit_card/issuer_pre_qualification_application',
    CreditCardIssuerPreQualificationApplicationApproval: 'credit_card/issuer_pre_qualification_application_approval',
    GenericConversion: 'generic/conversion',
    GenericIsContacted: 'generic/is_contacted',
    GenericFirstPayment: 'generic/first_payment',
    GenericSalesQualified: 'generic/sales_qualified',
    LifeInsuranceApplied: 'life_insurance/applied',
    LifeInsuranceApproved: 'life_insurance/approved',
    LifeInsuranceApplicationAbandoned: 'life_insurance/application_abandoned',
    LifeInsuranceApplicationDeclined: 'life_insurance/application_declined',
    LifeInsuranceApplicationLost: 'life_insurance/application_lost',
    LifeInsurancePolicyChargeBack: 'life_insurance/policy_charge_back',
    LifeInsurancePolicyInForce: 'life_insurance/policy_in_force',
    LifeInsurancePolicyPayment: 'life_insurance/policy_payment',
    LoanApplied: 'loan/applied',
    LoanApproved: 'loan/approved',
    LoanFunded: 'loan/funded',
    LoanLenderQualifiedLead: 'loan/lender_qualified_lead',
    LoanListed: 'loan/listed',
    LoanListingNotFunded: 'loan/listing_not_funded',
    LoanRejected: 'loan/rejected',
    MortgageApplied: 'mortgage/applied',
    MortgageApproved: 'mortgage/approved',
    MortgageFunded: 'mortgage/funded',
    MortgageRejected: 'mortgage/rejected',
    OtherConversion: 'other/conversion',
    OtherIsContacted: 'other/is_contacted',
    OtherFirstPayment: 'other/first_payment',
    OtherSalesQualified: 'other/sales_qualified',
    SavingsApplied: 'savings/applied',
    SavingsFunded: 'savings/funded',
    SavingsMobileApplicationInstalled: 'savings/mobile_application_installed',
    SavingsMobileApplicationBankLinked: 'savings/mobile_application_bank_linked',
    SavingsOfferClicked: 'savings/offer_clicked',
    SavingsOpened: 'savings/opened'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ExtractorType = {
    ConditionalTwoColumnValueEqualNot: 'conditional_two_column_value_equal_not',
    ConditionalColumnValue: 'conditional_column_value',
    ConditionalColumnValueInSet: 'conditional_column_value_in_set',
    DoubleConditionalColumnValue: 'double_conditional_column_value',
    TripleConditionalColumnValue: 'triple_conditional_column_value',
    JsonString: 'json_string',
    PrefixedKeyValue: 'prefixed_key_value',
    NoOp: 'no_op',
    SimpleColumn: 'simple_column'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.FileType = {
    Csv: 'csv',
    Json: 'json',
    Xlsx: 'xlsx'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.LedgerItemEventType = {
    Created: 'created',
    StatusChanged: 'statusChanged',
    AdjustmentAdded: 'adjustmentAdded',
    MemoChanged: 'memoChanged'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.LedgerItemReason = {
    Standard: 'standard',
    Settlement: 'settlement',
    OneOff: 'oneOff'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.LedgerItemType = {
    Payable: 'payable',
    Receivable: 'receivable'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.LifeInsuranceTermUnit = {
    Monthly: 'monthly',
    Quarterly: 'quarterly',
    Yearly: 'yearly'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.OnboardingContractType = {
    TermsOfService: 'termsOfService',
    PricingContract: 'pricingContract',
    PrivacyPolicy: 'privacyPolicy'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.Order = {
    Asc: 'asc',
    Desc: 'desc'
};
/**
 * A type of financial product
 * @export
 * @enum {string}
 */
exports.ProductSubType = {
    CreditCard: 'credit_card',
    SecuredCard: 'secured_card',
    StudentCard: 'student_card',
    PersonalLoan: 'personal_loan',
    SecuredLoan: 'secured_loan',
    StudentLoanRefinance: 'student_loan_refinance',
    CoApplicantLoan: 'co_applicant_loan',
    LineOfCredit: 'line_of_credit',
    AutomobileRefinance: 'automobile_refinance',
    HomeEquityLineOfCredit: 'home_equity_line_of_credit',
    Purchase: 'purchase',
    Refinance: 'refinance',
    SavingsAccount: 'savings_account',
    MoneyMarketAccount: 'money_market_account',
    CertificateOfDeposit: 'certificate_of_deposit',
    IndividualRetirementAccount: 'individual_retirement_account',
    CashManagementAccount: 'cash_management_account',
    HighInterestChecking: 'high_interest_checking',
    Checking: 'checking',
    AccidentalDeathBenefits: 'accidental_death_benefits',
    TermLife: 'term_life',
    TermLifeInstant: 'term_life_instant',
    WholeLife: 'whole_life',
    DebtRelief: 'debt_relief',
    InstallmentLoans: 'installment_loans',
    CreditBuilder: 'credit_builder',
    CashAdvance: 'cash_advance',
    CreditRepair: 'credit_repair',
    EducationOffers: 'education_offers',
    EmploymentOpportunity: 'employment_opportunity',
    FinancialWellness: 'financial_wellness',
    DirectAffiliate: 'direct_affiliate',
    OverdraftProtection: 'overdraft_protection',
    RevenueBasedFinancing: 'revenue_based_financing',
    InstallmentLoanMoreOffers: 'installment_loan_more_offers',
    CreditCardMoreOffers: 'credit_card_more_offers',
    CreditRepairMoreOffers: 'credit_repair_more_offers',
    StudentLoan: 'student_loan',
    Health: 'health',
    AutoAndVehicle: 'auto_and_vehicle',
    Games: 'games',
    Home: 'home',
    Rewards: 'rewards',
    LifeInsurance: 'life_insurance',
    AutoInsurance: 'auto_insurance',
    SpecialtyVehicleInsurance: 'specialty_vehicle_insurance',
    HomeOwnersInsurance: 'home_owners_insurance',
    RentersInsurance: 'renters_insurance',
    Uncategorized: 'uncategorized',
    CashAdvanceMoneylion: 'cash_advance_moneylion',
    Unknown: 'unknown'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ProductType = {
    CreditCard: 'credit_card',
    Generic: 'generic',
    AutoInsurance: 'auto_insurance',
    Insurance: 'insurance',
    LifeInsurance: 'life_insurance',
    Loan: 'loan',
    Mortgage: 'mortgage',
    Savings: 'savings',
    Other: 'other',
    Unknown: 'unknown'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ReconciliationType = {
    Paid: 'paid',
    Ignored: 'ignored',
    Unpaid: 'unpaid',
    Overdue: 'overdue',
    Scheduled: 'scheduled'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.ReportingApiCallStatus = {
    Success: 'success',
    Failure: 'failure'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.SaasFeeReason = {
    PartnerPageImplementation: 'partnerPageImplementation',
    EmbedImplementation: 'embedImplementation',
    NativeImplementation: 'nativeImplementation'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.SaasPlanPaymentCadence = {
    Upfront: 'upfront',
    Monthly: 'monthly'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.SaasSubscriptionStatus = {
    Inactive: 'inactive',
    Active: 'active',
    Canceled: 'canceled',
    Overdue: 'overdue'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.SubAccountType = {
    SupplySource: 'supply_source',
    DemandSource: 'demand_source'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.SupplySubAccountIntegrationType = {
    AffiliateLinks: 'affiliate_links',
    ApiCherryPick: 'api_cherry_pick',
    ApiMobile: 'api_mobile',
    ApiOfferWall: 'api_offer_wall',
    CreditComEmbed: 'credit_com_embed',
    MpsEmbedEven: 'mps_embed_even',
    MpsEmbedFiona: 'mps_embed_fiona',
    ThreeStepMpsEmbedEven: 'three_step_mps_embed_even',
    ThreeStepMpsEmbedFiona: 'three_step_mps_embed_fiona',
    MobileSdk: 'mobile_sdk',
    MpsPartnerPageEven: 'mps_partner_page_even',
    MpsPartnerPageFiona: 'mps_partner_page_fiona',
    Cla: 'cla',
    Pls: 'pls'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.TermUnit = {
    Week: 'week',
    BiMonthly: 'bi_monthly',
    Month: 'month',
    Unkown: 'unkown'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.TransformerType = {
    AddIntToValue: 'add_int_to_value',
    ExcelTimestamp: 'excel_timestamp',
    NoOp: 'no_op',
    StripPrefix: 'strip_prefix',
    StripSuffix: 'strip_suffix',
    Timestamp: 'timestamp',
    Uuid: 'uuid',
    IsNotNull: 'is_not_null'
};
/**
 * AccountApi - axios parameter creator
 * @export
 */
var AccountApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create a account
         * @summary Create a account
         * @param {AccountWriteData} [accountWriteData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount: function (accountWriteData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accountWriteData_1], args_1, true), void 0, function (accountWriteData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/accounts";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accountWriteData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete an account
         * @summary Delete an account
         * @param {number} id Supply Sub Account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteAccount', 'id', id);
                            localVarPath = "/accounts/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete an account owner
         * @summary Delete an account owner
         * @param {number} id Account Owner id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountOwner: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteAccountOwner', 'id', id);
                            localVarPath = "/accounts/owners/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Return a list of account owners based on request parameters
         * @summary Get account owners
         * @param {Array<number>} [accountOwnerId]
         * @param {Array<number>} [accountOwnerAccountId]
         * @param {Array<string>} [accountOwnerSupplyPartnerManager]
         * @param {Array<string>} [accountOwnerDemandPartnerManager]
         * @param {Array<string>} [accountOwnerSupplyYieldManager]
         * @param {Array<string>} [accountOwnerDemandYieldManager]
         * @param {Date} [accountOwnerCreatedAtMin]
         * @param {Date} [accountOwnerCreatedAtMax]
         * @param {Array<string>} [accountOwnerCreatedBy]
         * @param {Date} [accountOwnerDeletedAtMin]
         * @param {Date} [accountOwnerDeletedAtMax]
         * @param {boolean} [accountOwnerIsDeleted]
         * @param {Array<string>} [accountOwnerDeletedBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountOwners: function (accountOwnerId_1, accountOwnerAccountId_1, accountOwnerSupplyPartnerManager_1, accountOwnerDemandPartnerManager_1, accountOwnerSupplyYieldManager_1, accountOwnerDemandYieldManager_1, accountOwnerCreatedAtMin_1, accountOwnerCreatedAtMax_1, accountOwnerCreatedBy_1, accountOwnerDeletedAtMin_1, accountOwnerDeletedAtMax_1, accountOwnerIsDeleted_1, accountOwnerDeletedBy_1) {
            var args_1 = [];
            for (var _i = 13; _i < arguments.length; _i++) {
                args_1[_i - 13] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accountOwnerId_1, accountOwnerAccountId_1, accountOwnerSupplyPartnerManager_1, accountOwnerDemandPartnerManager_1, accountOwnerSupplyYieldManager_1, accountOwnerDemandYieldManager_1, accountOwnerCreatedAtMin_1, accountOwnerCreatedAtMax_1, accountOwnerCreatedBy_1, accountOwnerDeletedAtMin_1, accountOwnerDeletedAtMax_1, accountOwnerIsDeleted_1, accountOwnerDeletedBy_1], args_1, true), void 0, function (accountOwnerId, accountOwnerAccountId, accountOwnerSupplyPartnerManager, accountOwnerDemandPartnerManager, accountOwnerSupplyYieldManager, accountOwnerDemandYieldManager, accountOwnerCreatedAtMin, accountOwnerCreatedAtMax, accountOwnerCreatedBy, accountOwnerDeletedAtMin, accountOwnerDeletedAtMax, accountOwnerIsDeleted, accountOwnerDeletedBy, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/accounts/owners";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (accountOwnerId) {
                                localVarQueryParameter['accountOwnerId'] = accountOwnerId;
                            }
                            if (accountOwnerAccountId) {
                                localVarQueryParameter['accountOwnerAccountId'] = accountOwnerAccountId;
                            }
                            if (accountOwnerSupplyPartnerManager) {
                                localVarQueryParameter['accountOwnerSupplyPartnerManager'] = accountOwnerSupplyPartnerManager;
                            }
                            if (accountOwnerDemandPartnerManager) {
                                localVarQueryParameter['accountOwnerDemandPartnerManager'] = accountOwnerDemandPartnerManager;
                            }
                            if (accountOwnerSupplyYieldManager) {
                                localVarQueryParameter['accountOwnerSupplyYieldManager'] = accountOwnerSupplyYieldManager;
                            }
                            if (accountOwnerDemandYieldManager) {
                                localVarQueryParameter['accountOwnerDemandYieldManager'] = accountOwnerDemandYieldManager;
                            }
                            if (accountOwnerCreatedAtMin !== undefined) {
                                localVarQueryParameter['accountOwnerCreatedAtMin'] = (accountOwnerCreatedAtMin instanceof Date) ?
                                    accountOwnerCreatedAtMin.toISOString() :
                                    accountOwnerCreatedAtMin;
                            }
                            if (accountOwnerCreatedAtMax !== undefined) {
                                localVarQueryParameter['accountOwnerCreatedAtMax'] = (accountOwnerCreatedAtMax instanceof Date) ?
                                    accountOwnerCreatedAtMax.toISOString() :
                                    accountOwnerCreatedAtMax;
                            }
                            if (accountOwnerCreatedBy) {
                                localVarQueryParameter['accountOwnerCreatedBy'] = accountOwnerCreatedBy;
                            }
                            if (accountOwnerDeletedAtMin !== undefined) {
                                localVarQueryParameter['accountOwnerDeletedAtMin'] = (accountOwnerDeletedAtMin instanceof Date) ?
                                    accountOwnerDeletedAtMin.toISOString() :
                                    accountOwnerDeletedAtMin;
                            }
                            if (accountOwnerDeletedAtMax !== undefined) {
                                localVarQueryParameter['accountOwnerDeletedAtMax'] = (accountOwnerDeletedAtMax instanceof Date) ?
                                    accountOwnerDeletedAtMax.toISOString() :
                                    accountOwnerDeletedAtMax;
                            }
                            if (accountOwnerIsDeleted !== undefined) {
                                localVarQueryParameter['accountOwnerIsDeleted'] = accountOwnerIsDeleted;
                            }
                            if (accountOwnerDeletedBy) {
                                localVarQueryParameter['accountOwnerDeletedBy'] = accountOwnerDeletedBy;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Return accounts based upon request parameters
         * @summary Get accounts
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id]
         * @param {Array<string>} [uuid]
         * @param {Array<string>} [name]
         * @param {Array<string>} [email]
         * @param {Array<string>} [address1]
         * @param {Array<string>} [address2]
         * @param {Array<string>} [address3]
         * @param {Array<string>} [city]
         * @param {Array<string>} [state]
         * @param {Array<string>} [zipcode]
         * @param {Array<string>} [country]
         * @param {Array<string>} [phoneNumber]
         * @param {Array<string>} [billingName]
         * @param {Array<string>} [receivableBillingName]
         * @param {Array<string>} [billingSetup]
         * @param {boolean} [hasPaymentAccount]
         * @param {string} [trialEndDateMin]
         * @param {string} [trialEndDateMax]
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {Array<string>} [createdBy]
         * @param {Date} [deletedAtMin]
         * @param {Date} [deletedAtMax]
         * @param {boolean} [isDeleted]
         * @param {Array<string>} [deletedBy]
         * @param {boolean} [includeDeactivated] include deactivated items, default false
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {string} [sortBy] The attribute with which to sort the resources.
         * @param {string} [order] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccounts: function (limit_1, id_1, uuid_1, name_1, email_1, address1_1, address2_1, address3_1, city_1, state_1, zipcode_1, country_1, phoneNumber_1, billingName_1, receivableBillingName_1, billingSetup_1, hasPaymentAccount_1, trialEndDateMin_1, trialEndDateMax_1, createdAtMin_1, createdAtMax_1, createdBy_1, deletedAtMin_1, deletedAtMax_1, isDeleted_1, deletedBy_1, includeDeactivated_1, offset_1, sortBy_1, order_1) {
            var args_1 = [];
            for (var _i = 30; _i < arguments.length; _i++) {
                args_1[_i - 30] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, uuid_1, name_1, email_1, address1_1, address2_1, address3_1, city_1, state_1, zipcode_1, country_1, phoneNumber_1, billingName_1, receivableBillingName_1, billingSetup_1, hasPaymentAccount_1, trialEndDateMin_1, trialEndDateMax_1, createdAtMin_1, createdAtMax_1, createdBy_1, deletedAtMin_1, deletedAtMax_1, isDeleted_1, deletedBy_1, includeDeactivated_1, offset_1, sortBy_1, order_1], args_1, true), void 0, function (limit, id, uuid, name, email, address1, address2, address3, city, state, zipcode, country, phoneNumber, billingName, receivableBillingName, billingSetup, hasPaymentAccount, trialEndDateMin, trialEndDateMax, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, deletedBy, includeDeactivated, offset, sortBy, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getAccounts', 'limit', limit);
                            localVarPath = "/accounts";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (uuid) {
                                localVarQueryParameter['uuid'] = uuid;
                            }
                            if (name) {
                                localVarQueryParameter['name'] = name;
                            }
                            if (email) {
                                localVarQueryParameter['email'] = email;
                            }
                            if (address1) {
                                localVarQueryParameter['address1'] = address1;
                            }
                            if (address2) {
                                localVarQueryParameter['address2'] = address2;
                            }
                            if (address3) {
                                localVarQueryParameter['address3'] = address3;
                            }
                            if (city) {
                                localVarQueryParameter['city'] = city;
                            }
                            if (state) {
                                localVarQueryParameter['state'] = state;
                            }
                            if (zipcode) {
                                localVarQueryParameter['zipcode'] = zipcode;
                            }
                            if (country) {
                                localVarQueryParameter['country'] = country;
                            }
                            if (phoneNumber) {
                                localVarQueryParameter['phoneNumber'] = phoneNumber;
                            }
                            if (billingName) {
                                localVarQueryParameter['billingName'] = billingName;
                            }
                            if (receivableBillingName) {
                                localVarQueryParameter['receivableBillingName'] = receivableBillingName;
                            }
                            if (billingSetup) {
                                localVarQueryParameter['billingSetup'] = billingSetup;
                            }
                            if (hasPaymentAccount !== undefined) {
                                localVarQueryParameter['hasPaymentAccount'] = hasPaymentAccount;
                            }
                            if (trialEndDateMin !== undefined) {
                                localVarQueryParameter['trialEndDateMin'] = (trialEndDateMin instanceof Date) ?
                                    trialEndDateMin.toISOString().substring(0, 10) :
                                    trialEndDateMin;
                            }
                            if (trialEndDateMax !== undefined) {
                                localVarQueryParameter['trialEndDateMax'] = (trialEndDateMax instanceof Date) ?
                                    trialEndDateMax.toISOString().substring(0, 10) :
                                    trialEndDateMax;
                            }
                            if (createdAtMin !== undefined) {
                                localVarQueryParameter['createdAtMin'] = (createdAtMin instanceof Date) ?
                                    createdAtMin.toISOString() :
                                    createdAtMin;
                            }
                            if (createdAtMax !== undefined) {
                                localVarQueryParameter['createdAtMax'] = (createdAtMax instanceof Date) ?
                                    createdAtMax.toISOString() :
                                    createdAtMax;
                            }
                            if (createdBy) {
                                localVarQueryParameter['createdBy'] = createdBy;
                            }
                            if (deletedAtMin !== undefined) {
                                localVarQueryParameter['deletedAtMin'] = (deletedAtMin instanceof Date) ?
                                    deletedAtMin.toISOString() :
                                    deletedAtMin;
                            }
                            if (deletedAtMax !== undefined) {
                                localVarQueryParameter['deletedAtMax'] = (deletedAtMax instanceof Date) ?
                                    deletedAtMax.toISOString() :
                                    deletedAtMax;
                            }
                            if (isDeleted !== undefined) {
                                localVarQueryParameter['isDeleted'] = isDeleted;
                            }
                            if (deletedBy) {
                                localVarQueryParameter['deletedBy'] = deletedBy;
                            }
                            if (includeDeactivated !== undefined) {
                                localVarQueryParameter['includeDeactivated'] = includeDeactivated;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Updates the fields of an Account that corresponds to the id in the URL path, if on exists
         * @summary Update an account
         * @param {number} id Supply Sub Account id
         * @param {AccountWriteData} accountWriteData Update fields for Account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccount: function (id_1, accountWriteData_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, accountWriteData_1], args_1, true), void 0, function (id, accountWriteData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('updateAccount', 'id', id);
                            // verify required parameter 'accountWriteData' is not null or undefined
                            (0, common_1.assertParamExists)('updateAccount', 'accountWriteData', accountWriteData);
                            localVarPath = "/accounts/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accountWriteData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.AccountApiAxiosParamCreator = AccountApiAxiosParamCreator;
/**
 * AccountApi - functional programming interface
 * @export
 */
var AccountApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AccountApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create a account
         * @summary Create a account
         * @param {AccountWriteData} [accountWriteData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount: function (accountWriteData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createAccount(accountWriteData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.createAccount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete an account
         * @summary Delete an account
         * @param {number} id Supply Sub Account id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteAccount(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.deleteAccount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete an account owner
         * @summary Delete an account owner
         * @param {number} id Account Owner id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountOwner: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteAccountOwner(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.deleteAccountOwner']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Return a list of account owners based on request parameters
         * @summary Get account owners
         * @param {Array<number>} [accountOwnerId]
         * @param {Array<number>} [accountOwnerAccountId]
         * @param {Array<string>} [accountOwnerSupplyPartnerManager]
         * @param {Array<string>} [accountOwnerDemandPartnerManager]
         * @param {Array<string>} [accountOwnerSupplyYieldManager]
         * @param {Array<string>} [accountOwnerDemandYieldManager]
         * @param {Date} [accountOwnerCreatedAtMin]
         * @param {Date} [accountOwnerCreatedAtMax]
         * @param {Array<string>} [accountOwnerCreatedBy]
         * @param {Date} [accountOwnerDeletedAtMin]
         * @param {Date} [accountOwnerDeletedAtMax]
         * @param {boolean} [accountOwnerIsDeleted]
         * @param {Array<string>} [accountOwnerDeletedBy]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountOwners: function (accountOwnerId, accountOwnerAccountId, accountOwnerSupplyPartnerManager, accountOwnerDemandPartnerManager, accountOwnerSupplyYieldManager, accountOwnerDemandYieldManager, accountOwnerCreatedAtMin, accountOwnerCreatedAtMax, accountOwnerCreatedBy, accountOwnerDeletedAtMin, accountOwnerDeletedAtMax, accountOwnerIsDeleted, accountOwnerDeletedBy, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAccountOwners(accountOwnerId, accountOwnerAccountId, accountOwnerSupplyPartnerManager, accountOwnerDemandPartnerManager, accountOwnerSupplyYieldManager, accountOwnerDemandYieldManager, accountOwnerCreatedAtMin, accountOwnerCreatedAtMax, accountOwnerCreatedBy, accountOwnerDeletedAtMin, accountOwnerDeletedAtMax, accountOwnerIsDeleted, accountOwnerDeletedBy, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.getAccountOwners']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Return accounts based upon request parameters
         * @summary Get accounts
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id]
         * @param {Array<string>} [uuid]
         * @param {Array<string>} [name]
         * @param {Array<string>} [email]
         * @param {Array<string>} [address1]
         * @param {Array<string>} [address2]
         * @param {Array<string>} [address3]
         * @param {Array<string>} [city]
         * @param {Array<string>} [state]
         * @param {Array<string>} [zipcode]
         * @param {Array<string>} [country]
         * @param {Array<string>} [phoneNumber]
         * @param {Array<string>} [billingName]
         * @param {Array<string>} [receivableBillingName]
         * @param {Array<string>} [billingSetup]
         * @param {boolean} [hasPaymentAccount]
         * @param {string} [trialEndDateMin]
         * @param {string} [trialEndDateMax]
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {Array<string>} [createdBy]
         * @param {Date} [deletedAtMin]
         * @param {Date} [deletedAtMax]
         * @param {boolean} [isDeleted]
         * @param {Array<string>} [deletedBy]
         * @param {boolean} [includeDeactivated] include deactivated items, default false
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {string} [sortBy] The attribute with which to sort the resources.
         * @param {string} [order] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccounts: function (limit, id, uuid, name, email, address1, address2, address3, city, state, zipcode, country, phoneNumber, billingName, receivableBillingName, billingSetup, hasPaymentAccount, trialEndDateMin, trialEndDateMax, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, deletedBy, includeDeactivated, offset, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAccounts(limit, id, uuid, name, email, address1, address2, address3, city, state, zipcode, country, phoneNumber, billingName, receivableBillingName, billingSetup, hasPaymentAccount, trialEndDateMin, trialEndDateMax, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, deletedBy, includeDeactivated, offset, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.getAccounts']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Updates the fields of an Account that corresponds to the id in the URL path, if on exists
         * @summary Update an account
         * @param {number} id Supply Sub Account id
         * @param {AccountWriteData} accountWriteData Update fields for Account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccount: function (id, accountWriteData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateAccount(id, accountWriteData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountApi.updateAccount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.AccountApiFp = AccountApiFp;
/**
 * AccountApi - factory interface
 * @export
 */
var AccountApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AccountApiFp)(configuration);
    return {
        /**
         * Create a account
         * @summary Create a account
         * @param {AccountApiCreateAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccount: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createAccount(requestParameters.accountWriteData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete an account
         * @summary Delete an account
         * @param {AccountApiDeleteAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount: function (requestParameters, options) {
            return localVarFp.deleteAccount(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete an account owner
         * @summary Delete an account owner
         * @param {AccountApiDeleteAccountOwnerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountOwner: function (requestParameters, options) {
            return localVarFp.deleteAccountOwner(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return a list of account owners based on request parameters
         * @summary Get account owners
         * @param {AccountApiGetAccountOwnersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountOwners: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.getAccountOwners(requestParameters.accountOwnerId, requestParameters.accountOwnerAccountId, requestParameters.accountOwnerSupplyPartnerManager, requestParameters.accountOwnerDemandPartnerManager, requestParameters.accountOwnerSupplyYieldManager, requestParameters.accountOwnerDemandYieldManager, requestParameters.accountOwnerCreatedAtMin, requestParameters.accountOwnerCreatedAtMax, requestParameters.accountOwnerCreatedBy, requestParameters.accountOwnerDeletedAtMin, requestParameters.accountOwnerDeletedAtMax, requestParameters.accountOwnerIsDeleted, requestParameters.accountOwnerDeletedBy, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return accounts based upon request parameters
         * @summary Get accounts
         * @param {AccountApiGetAccountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccounts: function (requestParameters, options) {
            return localVarFp.getAccounts(requestParameters.limit, requestParameters.id, requestParameters.uuid, requestParameters.name, requestParameters.email, requestParameters.address1, requestParameters.address2, requestParameters.address3, requestParameters.city, requestParameters.state, requestParameters.zipcode, requestParameters.country, requestParameters.phoneNumber, requestParameters.billingName, requestParameters.receivableBillingName, requestParameters.billingSetup, requestParameters.hasPaymentAccount, requestParameters.trialEndDateMin, requestParameters.trialEndDateMax, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.isDeleted, requestParameters.deletedBy, requestParameters.includeDeactivated, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates the fields of an Account that corresponds to the id in the URL path, if on exists
         * @summary Update an account
         * @param {AccountApiUpdateAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAccount: function (requestParameters, options) {
            return localVarFp.updateAccount(requestParameters.id, requestParameters.accountWriteData, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AccountApiFactory = AccountApiFactory;
/**
 * AccountApi - object-oriented interface
 * @export
 * @class AccountApi
 * @extends {BaseAPI}
 */
var AccountApi = /** @class */ (function (_super) {
    __extends(AccountApi, _super);
    function AccountApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a account
     * @summary Create a account
     * @param {AccountApiCreateAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    AccountApi.prototype.createAccount = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.AccountApiFp)(this.configuration).createAccount(requestParameters.accountWriteData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete an account
     * @summary Delete an account
     * @param {AccountApiDeleteAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    AccountApi.prototype.deleteAccount = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AccountApiFp)(this.configuration).deleteAccount(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete an account owner
     * @summary Delete an account owner
     * @param {AccountApiDeleteAccountOwnerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    AccountApi.prototype.deleteAccountOwner = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AccountApiFp)(this.configuration).deleteAccountOwner(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return a list of account owners based on request parameters
     * @summary Get account owners
     * @param {AccountApiGetAccountOwnersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    AccountApi.prototype.getAccountOwners = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.AccountApiFp)(this.configuration).getAccountOwners(requestParameters.accountOwnerId, requestParameters.accountOwnerAccountId, requestParameters.accountOwnerSupplyPartnerManager, requestParameters.accountOwnerDemandPartnerManager, requestParameters.accountOwnerSupplyYieldManager, requestParameters.accountOwnerDemandYieldManager, requestParameters.accountOwnerCreatedAtMin, requestParameters.accountOwnerCreatedAtMax, requestParameters.accountOwnerCreatedBy, requestParameters.accountOwnerDeletedAtMin, requestParameters.accountOwnerDeletedAtMax, requestParameters.accountOwnerIsDeleted, requestParameters.accountOwnerDeletedBy, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return accounts based upon request parameters
     * @summary Get accounts
     * @param {AccountApiGetAccountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    AccountApi.prototype.getAccounts = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AccountApiFp)(this.configuration).getAccounts(requestParameters.limit, requestParameters.id, requestParameters.uuid, requestParameters.name, requestParameters.email, requestParameters.address1, requestParameters.address2, requestParameters.address3, requestParameters.city, requestParameters.state, requestParameters.zipcode, requestParameters.country, requestParameters.phoneNumber, requestParameters.billingName, requestParameters.receivableBillingName, requestParameters.billingSetup, requestParameters.hasPaymentAccount, requestParameters.trialEndDateMin, requestParameters.trialEndDateMax, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.isDeleted, requestParameters.deletedBy, requestParameters.includeDeactivated, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates the fields of an Account that corresponds to the id in the URL path, if on exists
     * @summary Update an account
     * @param {AccountApiUpdateAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    AccountApi.prototype.updateAccount = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AccountApiFp)(this.configuration).updateAccount(requestParameters.id, requestParameters.accountWriteData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AccountApi;
}(base_1.BaseAPI));
exports.AccountApi = AccountApi;
/**
 * AccountAdjustmentApi - axios parameter creator
 * @export
 */
var AccountAdjustmentApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Create an account adjustment
         * @param {AccountAdjustmentCreateData} [accountAdjustmentCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountAdjustment: function (accountAdjustmentCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accountAdjustmentCreateData_1], args_1, true), void 0, function (accountAdjustmentCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/accountAdjustments";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accountAdjustmentCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Soft delete the account adjustment corresponding to the specified ID in URL path, if one exists
         * @summary Delete an account adjustment
         * @param {number} id account adjustment id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountAdjustment: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteAccountAdjustment', 'id', id);
                            localVarPath = "/accountAdjustments/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns a list of account adjustments that match the specified criteria
         * @summary Get account adjustments
         * @param {number} limit limit the results, default 100
         * @param {Array<number>} [id] A comma separated list of adjustment ids
         * @param {Array<number>} [accountId] A comma separated list of Account ids
         * @param {Array<LedgerItemType>} [ledgerItemTypes] A comma separated list of ledger item types
         * @param {Array<number>} [ledgerItemId] A comma separated list of Ledger Item ids
         * @param {Array<AdjustmentReason>} [adjustmentReason] Reason for account adjustment based on a defined enum
         * @param {Array<string>} [q] Fuzzy search parameter
         * @param {Date} [createdAtStart] beginning of the createdAt range
         * @param {Date} [createdAtEnd] end of the createdAt range
         * @param {Array<string>} [createdByUuids] comma separated list of uuids
         * @param {Date} [deletedAtStart] beginning of range for deletedAt
         * @param {Date} [deletedAtEnd] end of range for deletedAt
         * @param {Array<string>} [deletedByUuids] comma separated list of uuids
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {boolean} [excludeDeleted] ignored deleted items, default true
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountAdjustments: function (limit_1, id_1, accountId_1, ledgerItemTypes_1, ledgerItemId_1, adjustmentReason_1, q_1, createdAtStart_1, createdAtEnd_1, createdByUuids_1, deletedAtStart_1, deletedAtEnd_1, deletedByUuids_1, offset_1, sortBy_1, order_1, excludeDeleted_1) {
            var args_1 = [];
            for (var _i = 17; _i < arguments.length; _i++) {
                args_1[_i - 17] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, accountId_1, ledgerItemTypes_1, ledgerItemId_1, adjustmentReason_1, q_1, createdAtStart_1, createdAtEnd_1, createdByUuids_1, deletedAtStart_1, deletedAtEnd_1, deletedByUuids_1, offset_1, sortBy_1, order_1, excludeDeleted_1], args_1, true), void 0, function (limit, id, accountId, ledgerItemTypes, ledgerItemId, adjustmentReason, q, createdAtStart, createdAtEnd, createdByUuids, deletedAtStart, deletedAtEnd, deletedByUuids, offset, sortBy, order, excludeDeleted, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getAccountAdjustments', 'limit', limit);
                            localVarPath = "/accountAdjustments";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (accountId) {
                                localVarQueryParameter['accountId'] = accountId;
                            }
                            if (ledgerItemTypes) {
                                localVarQueryParameter['ledgerItemTypes'] = ledgerItemTypes;
                            }
                            if (ledgerItemId) {
                                localVarQueryParameter['ledgerItemId'] = ledgerItemId;
                            }
                            if (adjustmentReason) {
                                localVarQueryParameter['adjustmentReason'] = adjustmentReason;
                            }
                            if (q) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (createdAtStart !== undefined) {
                                localVarQueryParameter['createdAtStart'] = (createdAtStart instanceof Date) ?
                                    createdAtStart.toISOString() :
                                    createdAtStart;
                            }
                            if (createdAtEnd !== undefined) {
                                localVarQueryParameter['createdAtEnd'] = (createdAtEnd instanceof Date) ?
                                    createdAtEnd.toISOString() :
                                    createdAtEnd;
                            }
                            if (createdByUuids) {
                                localVarQueryParameter['createdByUuids'] = createdByUuids;
                            }
                            if (deletedAtStart !== undefined) {
                                localVarQueryParameter['deletedAtStart'] = (deletedAtStart instanceof Date) ?
                                    deletedAtStart.toISOString() :
                                    deletedAtStart;
                            }
                            if (deletedAtEnd !== undefined) {
                                localVarQueryParameter['deletedAtEnd'] = (deletedAtEnd instanceof Date) ?
                                    deletedAtEnd.toISOString() :
                                    deletedAtEnd;
                            }
                            if (deletedByUuids) {
                                localVarQueryParameter['deletedByUuids'] = deletedByUuids;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (excludeDeleted !== undefined) {
                                localVarQueryParameter['excludeDeleted'] = excludeDeleted;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get valid account adjustment reasons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdjustmentReasons: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/adjustmentReasons";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.AccountAdjustmentApiAxiosParamCreator = AccountAdjustmentApiAxiosParamCreator;
/**
 * AccountAdjustmentApi - functional programming interface
 * @export
 */
var AccountAdjustmentApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AccountAdjustmentApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Create an account adjustment
         * @param {AccountAdjustmentCreateData} [accountAdjustmentCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountAdjustment: function (accountAdjustmentCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createAccountAdjustment(accountAdjustmentCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountAdjustmentApi.createAccountAdjustment']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Soft delete the account adjustment corresponding to the specified ID in URL path, if one exists
         * @summary Delete an account adjustment
         * @param {number} id account adjustment id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountAdjustment: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteAccountAdjustment(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountAdjustmentApi.deleteAccountAdjustment']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Returns a list of account adjustments that match the specified criteria
         * @summary Get account adjustments
         * @param {number} limit limit the results, default 100
         * @param {Array<number>} [id] A comma separated list of adjustment ids
         * @param {Array<number>} [accountId] A comma separated list of Account ids
         * @param {Array<LedgerItemType>} [ledgerItemTypes] A comma separated list of ledger item types
         * @param {Array<number>} [ledgerItemId] A comma separated list of Ledger Item ids
         * @param {Array<AdjustmentReason>} [adjustmentReason] Reason for account adjustment based on a defined enum
         * @param {Array<string>} [q] Fuzzy search parameter
         * @param {Date} [createdAtStart] beginning of the createdAt range
         * @param {Date} [createdAtEnd] end of the createdAt range
         * @param {Array<string>} [createdByUuids] comma separated list of uuids
         * @param {Date} [deletedAtStart] beginning of range for deletedAt
         * @param {Date} [deletedAtEnd] end of range for deletedAt
         * @param {Array<string>} [deletedByUuids] comma separated list of uuids
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {boolean} [excludeDeleted] ignored deleted items, default true
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountAdjustments: function (limit, id, accountId, ledgerItemTypes, ledgerItemId, adjustmentReason, q, createdAtStart, createdAtEnd, createdByUuids, deletedAtStart, deletedAtEnd, deletedByUuids, offset, sortBy, order, excludeDeleted, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAccountAdjustments(limit, id, accountId, ledgerItemTypes, ledgerItemId, adjustmentReason, q, createdAtStart, createdAtEnd, createdByUuids, deletedAtStart, deletedAtEnd, deletedByUuids, offset, sortBy, order, excludeDeleted, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountAdjustmentApi.getAccountAdjustments']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get valid account adjustment reasons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdjustmentReasons: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAdjustmentReasons(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountAdjustmentApi.getAdjustmentReasons']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.AccountAdjustmentApiFp = AccountAdjustmentApiFp;
/**
 * AccountAdjustmentApi - factory interface
 * @export
 */
var AccountAdjustmentApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AccountAdjustmentApiFp)(configuration);
    return {
        /**
         *
         * @summary Create an account adjustment
         * @param {AccountAdjustmentApiCreateAccountAdjustmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountAdjustment: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createAccountAdjustment(requestParameters.accountAdjustmentCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Soft delete the account adjustment corresponding to the specified ID in URL path, if one exists
         * @summary Delete an account adjustment
         * @param {AccountAdjustmentApiDeleteAccountAdjustmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountAdjustment: function (requestParameters, options) {
            return localVarFp.deleteAccountAdjustment(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a list of account adjustments that match the specified criteria
         * @summary Get account adjustments
         * @param {AccountAdjustmentApiGetAccountAdjustmentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountAdjustments: function (requestParameters, options) {
            return localVarFp.getAccountAdjustments(requestParameters.limit, requestParameters.id, requestParameters.accountId, requestParameters.ledgerItemTypes, requestParameters.ledgerItemId, requestParameters.adjustmentReason, requestParameters.q, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.createdByUuids, requestParameters.deletedAtStart, requestParameters.deletedAtEnd, requestParameters.deletedByUuids, requestParameters.offset, requestParameters.sortBy, requestParameters.order, requestParameters.excludeDeleted, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get valid account adjustment reasons
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdjustmentReasons: function (options) {
            return localVarFp.getAdjustmentReasons(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AccountAdjustmentApiFactory = AccountAdjustmentApiFactory;
/**
 * AccountAdjustmentApi - object-oriented interface
 * @export
 * @class AccountAdjustmentApi
 * @extends {BaseAPI}
 */
var AccountAdjustmentApi = /** @class */ (function (_super) {
    __extends(AccountAdjustmentApi, _super);
    function AccountAdjustmentApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create an account adjustment
     * @param {AccountAdjustmentApiCreateAccountAdjustmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountAdjustmentApi
     */
    AccountAdjustmentApi.prototype.createAccountAdjustment = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.AccountAdjustmentApiFp)(this.configuration).createAccountAdjustment(requestParameters.accountAdjustmentCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Soft delete the account adjustment corresponding to the specified ID in URL path, if one exists
     * @summary Delete an account adjustment
     * @param {AccountAdjustmentApiDeleteAccountAdjustmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountAdjustmentApi
     */
    AccountAdjustmentApi.prototype.deleteAccountAdjustment = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AccountAdjustmentApiFp)(this.configuration).deleteAccountAdjustment(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a list of account adjustments that match the specified criteria
     * @summary Get account adjustments
     * @param {AccountAdjustmentApiGetAccountAdjustmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountAdjustmentApi
     */
    AccountAdjustmentApi.prototype.getAccountAdjustments = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AccountAdjustmentApiFp)(this.configuration).getAccountAdjustments(requestParameters.limit, requestParameters.id, requestParameters.accountId, requestParameters.ledgerItemTypes, requestParameters.ledgerItemId, requestParameters.adjustmentReason, requestParameters.q, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.createdByUuids, requestParameters.deletedAtStart, requestParameters.deletedAtEnd, requestParameters.deletedByUuids, requestParameters.offset, requestParameters.sortBy, requestParameters.order, requestParameters.excludeDeleted, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get valid account adjustment reasons
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountAdjustmentApi
     */
    AccountAdjustmentApi.prototype.getAdjustmentReasons = function (options) {
        var _this = this;
        return (0, exports.AccountAdjustmentApiFp)(this.configuration).getAdjustmentReasons(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AccountAdjustmentApi;
}(base_1.BaseAPI));
exports.AccountAdjustmentApi = AccountAdjustmentApi;
/**
 * AccountDeactivationApi - axios parameter creator
 * @export
 */
var AccountDeactivationApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create account deactivations
         * @summary Create account deactivations
         * @param {AccountDeactivationCreateData} [accountDeactivationCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountDeactivation: function (accountDeactivationCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accountDeactivationCreateData_1], args_1, true), void 0, function (accountDeactivationCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/accountDeactivations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accountDeactivationCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a account deactivation
         * @summary Delete a account deactivation
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountDeactivation: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteAccountDeactivation', 'id', id);
                            localVarPath = "/accountDeactivations/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Return account deactivations based upon request parameters
         * @summary Get account deactivations
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id]
         * @param {Array<number>} [accountId]
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {Array<string>} [createdBy]
         * @param {Date} [deletedAtMin]
         * @param {Date} [deletedAtMax]
         * @param {boolean} [isDeleted]
         * @param {Array<string>} [deletedBy]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {string} [sortBy] The attribute with which to sort the resources.
         * @param {string} [order] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountDeactivations: function (limit_1, id_1, accountId_1, createdAtMin_1, createdAtMax_1, createdBy_1, deletedAtMin_1, deletedAtMax_1, isDeleted_1, deletedBy_1, offset_1, sortBy_1, order_1) {
            var args_1 = [];
            for (var _i = 13; _i < arguments.length; _i++) {
                args_1[_i - 13] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, accountId_1, createdAtMin_1, createdAtMax_1, createdBy_1, deletedAtMin_1, deletedAtMax_1, isDeleted_1, deletedBy_1, offset_1, sortBy_1, order_1], args_1, true), void 0, function (limit, id, accountId, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, deletedBy, offset, sortBy, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getAccountDeactivations', 'limit', limit);
                            localVarPath = "/accountDeactivations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (accountId) {
                                localVarQueryParameter['accountId'] = accountId;
                            }
                            if (createdAtMin !== undefined) {
                                localVarQueryParameter['createdAtMin'] = (createdAtMin instanceof Date) ?
                                    createdAtMin.toISOString() :
                                    createdAtMin;
                            }
                            if (createdAtMax !== undefined) {
                                localVarQueryParameter['createdAtMax'] = (createdAtMax instanceof Date) ?
                                    createdAtMax.toISOString() :
                                    createdAtMax;
                            }
                            if (createdBy) {
                                localVarQueryParameter['createdBy'] = createdBy;
                            }
                            if (deletedAtMin !== undefined) {
                                localVarQueryParameter['deletedAtMin'] = (deletedAtMin instanceof Date) ?
                                    deletedAtMin.toISOString() :
                                    deletedAtMin;
                            }
                            if (deletedAtMax !== undefined) {
                                localVarQueryParameter['deletedAtMax'] = (deletedAtMax instanceof Date) ?
                                    deletedAtMax.toISOString() :
                                    deletedAtMax;
                            }
                            if (isDeleted !== undefined) {
                                localVarQueryParameter['isDeleted'] = isDeleted;
                            }
                            if (deletedBy) {
                                localVarQueryParameter['deletedBy'] = deletedBy;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.AccountDeactivationApiAxiosParamCreator = AccountDeactivationApiAxiosParamCreator;
/**
 * AccountDeactivationApi - functional programming interface
 * @export
 */
var AccountDeactivationApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AccountDeactivationApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create account deactivations
         * @summary Create account deactivations
         * @param {AccountDeactivationCreateData} [accountDeactivationCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountDeactivation: function (accountDeactivationCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createAccountDeactivation(accountDeactivationCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountDeactivationApi.createAccountDeactivation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete a account deactivation
         * @summary Delete a account deactivation
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountDeactivation: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteAccountDeactivation(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountDeactivationApi.deleteAccountDeactivation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Return account deactivations based upon request parameters
         * @summary Get account deactivations
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id]
         * @param {Array<number>} [accountId]
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {Array<string>} [createdBy]
         * @param {Date} [deletedAtMin]
         * @param {Date} [deletedAtMax]
         * @param {boolean} [isDeleted]
         * @param {Array<string>} [deletedBy]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {string} [sortBy] The attribute with which to sort the resources.
         * @param {string} [order] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountDeactivations: function (limit, id, accountId, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, deletedBy, offset, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAccountDeactivations(limit, id, accountId, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, deletedBy, offset, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountDeactivationApi.getAccountDeactivations']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.AccountDeactivationApiFp = AccountDeactivationApiFp;
/**
 * AccountDeactivationApi - factory interface
 * @export
 */
var AccountDeactivationApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AccountDeactivationApiFp)(configuration);
    return {
        /**
         * Create account deactivations
         * @summary Create account deactivations
         * @param {AccountDeactivationApiCreateAccountDeactivationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountDeactivation: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createAccountDeactivation(requestParameters.accountDeactivationCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a account deactivation
         * @summary Delete a account deactivation
         * @param {AccountDeactivationApiDeleteAccountDeactivationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccountDeactivation: function (requestParameters, options) {
            return localVarFp.deleteAccountDeactivation(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return account deactivations based upon request parameters
         * @summary Get account deactivations
         * @param {AccountDeactivationApiGetAccountDeactivationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountDeactivations: function (requestParameters, options) {
            return localVarFp.getAccountDeactivations(requestParameters.limit, requestParameters.id, requestParameters.accountId, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.isDeleted, requestParameters.deletedBy, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AccountDeactivationApiFactory = AccountDeactivationApiFactory;
/**
 * AccountDeactivationApi - object-oriented interface
 * @export
 * @class AccountDeactivationApi
 * @extends {BaseAPI}
 */
var AccountDeactivationApi = /** @class */ (function (_super) {
    __extends(AccountDeactivationApi, _super);
    function AccountDeactivationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create account deactivations
     * @summary Create account deactivations
     * @param {AccountDeactivationApiCreateAccountDeactivationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountDeactivationApi
     */
    AccountDeactivationApi.prototype.createAccountDeactivation = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.AccountDeactivationApiFp)(this.configuration).createAccountDeactivation(requestParameters.accountDeactivationCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a account deactivation
     * @summary Delete a account deactivation
     * @param {AccountDeactivationApiDeleteAccountDeactivationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountDeactivationApi
     */
    AccountDeactivationApi.prototype.deleteAccountDeactivation = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AccountDeactivationApiFp)(this.configuration).deleteAccountDeactivation(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return account deactivations based upon request parameters
     * @summary Get account deactivations
     * @param {AccountDeactivationApiGetAccountDeactivationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountDeactivationApi
     */
    AccountDeactivationApi.prototype.getAccountDeactivations = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AccountDeactivationApiFp)(this.configuration).getAccountDeactivations(requestParameters.limit, requestParameters.id, requestParameters.accountId, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.isDeleted, requestParameters.deletedBy, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AccountDeactivationApi;
}(base_1.BaseAPI));
exports.AccountDeactivationApi = AccountDeactivationApi;
/**
 * AccountSettlementApi - axios parameter creator
 * @export
 */
var AccountSettlementApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Complete an AccountSettlement by specifying additional due payable amounts
         * @summary Complete an AccountSettlement
         * @param {number} id
         * @param {AccountSettlementCompletionData} accountSettlementCompletionData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeAccountSettlement: function (id_1, accountSettlementCompletionData_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, accountSettlementCompletionData_1], args_1, true), void 0, function (id, accountSettlementCompletionData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('completeAccountSettlement', 'id', id);
                            // verify required parameter 'accountSettlementCompletionData' is not null or undefined
                            (0, common_1.assertParamExists)('completeAccountSettlement', 'accountSettlementCompletionData', accountSettlementCompletionData);
                            localVarPath = "/accountSettlements/{id}/completion"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accountSettlementCompletionData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create account settlements
         * @summary Create account settlements
         * @param {AccountSettlementCreateData} [accountSettlementCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountSettlements: function (accountSettlementCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accountSettlementCreateData_1], args_1, true), void 0, function (accountSettlementCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/accountSettlements";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accountSettlementCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Return account settlements based upon request parameters
         * @summary Get account settlements
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id]
         * @param {Array<number>} [accountId]
         * @param {Array<AccountSettlementStatus>} [status]
         * @param {Date} [startedAtMin]
         * @param {Date} [startedAtMax]
         * @param {Date} [completedAtMin]
         * @param {Date} [completedAtMax]
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {Array<string>} [createdBy]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {AccountSettlementSort} [sortBy] The attribute with which to sort the resources.
         * @param {Order} [order] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountSettlements: function (limit_1, id_1, accountId_1, status_1, startedAtMin_1, startedAtMax_1, completedAtMin_1, completedAtMax_1, createdAtMin_1, createdAtMax_1, createdBy_1, offset_1, sortBy_1, order_1) {
            var args_1 = [];
            for (var _i = 14; _i < arguments.length; _i++) {
                args_1[_i - 14] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, accountId_1, status_1, startedAtMin_1, startedAtMax_1, completedAtMin_1, completedAtMax_1, createdAtMin_1, createdAtMax_1, createdBy_1, offset_1, sortBy_1, order_1], args_1, true), void 0, function (limit, id, accountId, status, startedAtMin, startedAtMax, completedAtMin, completedAtMax, createdAtMin, createdAtMax, createdBy, offset, sortBy, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getAccountSettlements', 'limit', limit);
                            localVarPath = "/accountSettlements";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (accountId) {
                                localVarQueryParameter['accountId'] = accountId;
                            }
                            if (status) {
                                localVarQueryParameter['status'] = status;
                            }
                            if (startedAtMin !== undefined) {
                                localVarQueryParameter['startedAtMin'] = (startedAtMin instanceof Date) ?
                                    startedAtMin.toISOString() :
                                    startedAtMin;
                            }
                            if (startedAtMax !== undefined) {
                                localVarQueryParameter['startedAtMax'] = (startedAtMax instanceof Date) ?
                                    startedAtMax.toISOString() :
                                    startedAtMax;
                            }
                            if (completedAtMin !== undefined) {
                                localVarQueryParameter['completedAtMin'] = (completedAtMin instanceof Date) ?
                                    completedAtMin.toISOString() :
                                    completedAtMin;
                            }
                            if (completedAtMax !== undefined) {
                                localVarQueryParameter['completedAtMax'] = (completedAtMax instanceof Date) ?
                                    completedAtMax.toISOString() :
                                    completedAtMax;
                            }
                            if (createdAtMin !== undefined) {
                                localVarQueryParameter['createdAtMin'] = (createdAtMin instanceof Date) ?
                                    createdAtMin.toISOString() :
                                    createdAtMin;
                            }
                            if (createdAtMax !== undefined) {
                                localVarQueryParameter['createdAtMax'] = (createdAtMax instanceof Date) ?
                                    createdAtMax.toISOString() :
                                    createdAtMax;
                            }
                            if (createdBy) {
                                localVarQueryParameter['createdBy'] = createdBy;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.AccountSettlementApiAxiosParamCreator = AccountSettlementApiAxiosParamCreator;
/**
 * AccountSettlementApi - functional programming interface
 * @export
 */
var AccountSettlementApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AccountSettlementApiAxiosParamCreator)(configuration);
    return {
        /**
         * Complete an AccountSettlement by specifying additional due payable amounts
         * @summary Complete an AccountSettlement
         * @param {number} id
         * @param {AccountSettlementCompletionData} accountSettlementCompletionData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeAccountSettlement: function (id, accountSettlementCompletionData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.completeAccountSettlement(id, accountSettlementCompletionData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountSettlementApi.completeAccountSettlement']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Create account settlements
         * @summary Create account settlements
         * @param {AccountSettlementCreateData} [accountSettlementCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountSettlements: function (accountSettlementCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createAccountSettlements(accountSettlementCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountSettlementApi.createAccountSettlements']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Return account settlements based upon request parameters
         * @summary Get account settlements
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id]
         * @param {Array<number>} [accountId]
         * @param {Array<AccountSettlementStatus>} [status]
         * @param {Date} [startedAtMin]
         * @param {Date} [startedAtMax]
         * @param {Date} [completedAtMin]
         * @param {Date} [completedAtMax]
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {Array<string>} [createdBy]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {AccountSettlementSort} [sortBy] The attribute with which to sort the resources.
         * @param {Order} [order] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountSettlements: function (limit, id, accountId, status, startedAtMin, startedAtMax, completedAtMin, completedAtMax, createdAtMin, createdAtMax, createdBy, offset, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAccountSettlements(limit, id, accountId, status, startedAtMin, startedAtMax, completedAtMin, completedAtMax, createdAtMin, createdAtMax, createdBy, offset, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AccountSettlementApi.getAccountSettlements']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.AccountSettlementApiFp = AccountSettlementApiFp;
/**
 * AccountSettlementApi - factory interface
 * @export
 */
var AccountSettlementApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AccountSettlementApiFp)(configuration);
    return {
        /**
         * Complete an AccountSettlement by specifying additional due payable amounts
         * @summary Complete an AccountSettlement
         * @param {AccountSettlementApiCompleteAccountSettlementRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeAccountSettlement: function (requestParameters, options) {
            return localVarFp.completeAccountSettlement(requestParameters.id, requestParameters.accountSettlementCompletionData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create account settlements
         * @summary Create account settlements
         * @param {AccountSettlementApiCreateAccountSettlementsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAccountSettlements: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createAccountSettlements(requestParameters.accountSettlementCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return account settlements based upon request parameters
         * @summary Get account settlements
         * @param {AccountSettlementApiGetAccountSettlementsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccountSettlements: function (requestParameters, options) {
            return localVarFp.getAccountSettlements(requestParameters.limit, requestParameters.id, requestParameters.accountId, requestParameters.status, requestParameters.startedAtMin, requestParameters.startedAtMax, requestParameters.completedAtMin, requestParameters.completedAtMax, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdBy, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AccountSettlementApiFactory = AccountSettlementApiFactory;
/**
 * AccountSettlementApi - object-oriented interface
 * @export
 * @class AccountSettlementApi
 * @extends {BaseAPI}
 */
var AccountSettlementApi = /** @class */ (function (_super) {
    __extends(AccountSettlementApi, _super);
    function AccountSettlementApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Complete an AccountSettlement by specifying additional due payable amounts
     * @summary Complete an AccountSettlement
     * @param {AccountSettlementApiCompleteAccountSettlementRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountSettlementApi
     */
    AccountSettlementApi.prototype.completeAccountSettlement = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AccountSettlementApiFp)(this.configuration).completeAccountSettlement(requestParameters.id, requestParameters.accountSettlementCompletionData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create account settlements
     * @summary Create account settlements
     * @param {AccountSettlementApiCreateAccountSettlementsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountSettlementApi
     */
    AccountSettlementApi.prototype.createAccountSettlements = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.AccountSettlementApiFp)(this.configuration).createAccountSettlements(requestParameters.accountSettlementCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return account settlements based upon request parameters
     * @summary Get account settlements
     * @param {AccountSettlementApiGetAccountSettlementsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountSettlementApi
     */
    AccountSettlementApi.prototype.getAccountSettlements = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AccountSettlementApiFp)(this.configuration).getAccountSettlements(requestParameters.limit, requestParameters.id, requestParameters.accountId, requestParameters.status, requestParameters.startedAtMin, requestParameters.startedAtMax, requestParameters.completedAtMin, requestParameters.completedAtMax, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdBy, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AccountSettlementApi;
}(base_1.BaseAPI));
exports.AccountSettlementApi = AccountSettlementApi;
/**
 * BillingCycleApi - axios parameter creator
 * @export
 */
var BillingCycleApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Record a billing cycle
         * @param {BillingCycleCreateData} [billingCycleCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBillingCycle: function (billingCycleCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([billingCycleCreateData_1], args_1, true), void 0, function (billingCycleCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/billingCycles";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(billingCycleCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Soft delete the billing cycle corresponding to the specified ID in URL path, if one exists
         * @summary Delete a billing cycle
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBillingCycle: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteBillingCycle', 'id', id);
                            localVarPath = "/billingCycles/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Generate a list of ledger items based on a specifed date
         * @summary Generate ledger items
         * @param {string} [generateForDate] A date you want to generate the ledger items for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateLedgerItemsForDate: function (generateForDate_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([generateForDate_1], args_1, true), void 0, function (generateForDate, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/billingCycles/generateLedgerItems";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (generateForDate !== undefined) {
                                localVarQueryParameter['generateForDate'] = (generateForDate instanceof Date) ?
                                    generateForDate.toISOString().substring(0, 10) :
                                    generateForDate;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Return a list of billing cycles that match the specified criteria
         * @summary Get billing cycles
         * @param {number} limit limit the results, default 100
         * @param {Array<number>} [ids] A comma separated list of Ledger Item ids
         * @param {Array<number>} [accountIds] A comma separated list of Account ids
         * @param {Array<string>} [ledgerItemType] Ledger Item Type, either payable or receivable
         * @param {Array<string>} [effectiveAtStart] beginning of effectiveAt range
         * @param {string} [effectiveAtEnd] end of effectiveAt range
         * @param {Array<number>} [netD] The amount of time allowed between cycle end and payment due
         * @param {Date} [createdAtStart] start of createdAtStart range
         * @param {Date} [createdAtEnd] end of createdAtStart range
         * @param {Array<string>} [createdByUuid]
         * @param {Date} [deletedAtStart] start of range for deletedAt
         * @param {Date} [deletedAtEnd] end of range for deletedAt
         * @param {Array<string>} [deletedByUuid] comma separated list of uuid
         * @param {number} [offset] default 0
         * @param {string} [sortBy]
         * @param {Order} [order] default asc
         * @param {boolean} [excludeDeleted] ignore deleted items, default true
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillingCycles: function (limit_1, ids_1, accountIds_1, ledgerItemType_1, effectiveAtStart_1, effectiveAtEnd_1, netD_1, createdAtStart_1, createdAtEnd_1, createdByUuid_1, deletedAtStart_1, deletedAtEnd_1, deletedByUuid_1, offset_1, sortBy_1, order_1, excludeDeleted_1) {
            var args_1 = [];
            for (var _i = 17; _i < arguments.length; _i++) {
                args_1[_i - 17] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, ids_1, accountIds_1, ledgerItemType_1, effectiveAtStart_1, effectiveAtEnd_1, netD_1, createdAtStart_1, createdAtEnd_1, createdByUuid_1, deletedAtStart_1, deletedAtEnd_1, deletedByUuid_1, offset_1, sortBy_1, order_1, excludeDeleted_1], args_1, true), void 0, function (limit, ids, accountIds, ledgerItemType, effectiveAtStart, effectiveAtEnd, netD, createdAtStart, createdAtEnd, createdByUuid, deletedAtStart, deletedAtEnd, deletedByUuid, offset, sortBy, order, excludeDeleted, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getBillingCycles', 'limit', limit);
                            localVarPath = "/billingCycles";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (ids) {
                                localVarQueryParameter['ids'] = ids;
                            }
                            if (accountIds) {
                                localVarQueryParameter['accountIds'] = accountIds;
                            }
                            if (ledgerItemType) {
                                localVarQueryParameter['ledgerItemType'] = ledgerItemType;
                            }
                            if (effectiveAtStart) {
                                localVarQueryParameter['effectiveAtStart'] = effectiveAtStart;
                            }
                            if (effectiveAtEnd !== undefined) {
                                localVarQueryParameter['effectiveAtEnd'] = (effectiveAtEnd instanceof Date) ?
                                    effectiveAtEnd.toISOString().substring(0, 10) :
                                    effectiveAtEnd;
                            }
                            if (netD) {
                                localVarQueryParameter['netD'] = netD;
                            }
                            if (createdAtStart !== undefined) {
                                localVarQueryParameter['createdAtStart'] = (createdAtStart instanceof Date) ?
                                    createdAtStart.toISOString() :
                                    createdAtStart;
                            }
                            if (createdAtEnd !== undefined) {
                                localVarQueryParameter['createdAtEnd'] = (createdAtEnd instanceof Date) ?
                                    createdAtEnd.toISOString() :
                                    createdAtEnd;
                            }
                            if (createdByUuid) {
                                localVarQueryParameter['createdByUuid'] = createdByUuid;
                            }
                            if (deletedAtStart !== undefined) {
                                localVarQueryParameter['deletedAtStart'] = (deletedAtStart instanceof Date) ?
                                    deletedAtStart.toISOString() :
                                    deletedAtStart;
                            }
                            if (deletedAtEnd !== undefined) {
                                localVarQueryParameter['deletedAtEnd'] = (deletedAtEnd instanceof Date) ?
                                    deletedAtEnd.toISOString() :
                                    deletedAtEnd;
                            }
                            if (deletedByUuid) {
                                localVarQueryParameter['deletedByUuid'] = deletedByUuid;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (excludeDeleted !== undefined) {
                                localVarQueryParameter['excludeDeleted'] = excludeDeleted;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Updates the memo field of the ledger item corresponding to the specified ID in URL path, if one exists
         * @summary Update a billing cycle
         * @param {number} id
         * @param {BillingCycleUpdateData} [billingCycleUpdateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBillingCycle: function (id_1, billingCycleUpdateData_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, billingCycleUpdateData_1], args_1, true), void 0, function (id, billingCycleUpdateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('updateBillingCycle', 'id', id);
                            localVarPath = "/billingCycles/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(billingCycleUpdateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.BillingCycleApiAxiosParamCreator = BillingCycleApiAxiosParamCreator;
/**
 * BillingCycleApi - functional programming interface
 * @export
 */
var BillingCycleApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.BillingCycleApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Record a billing cycle
         * @param {BillingCycleCreateData} [billingCycleCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBillingCycle: function (billingCycleCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createBillingCycle(billingCycleCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillingCycleApi.createBillingCycle']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Soft delete the billing cycle corresponding to the specified ID in URL path, if one exists
         * @summary Delete a billing cycle
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBillingCycle: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteBillingCycle(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillingCycleApi.deleteBillingCycle']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Generate a list of ledger items based on a specifed date
         * @summary Generate ledger items
         * @param {string} [generateForDate] A date you want to generate the ledger items for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateLedgerItemsForDate: function (generateForDate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.generateLedgerItemsForDate(generateForDate, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillingCycleApi.generateLedgerItemsForDate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Return a list of billing cycles that match the specified criteria
         * @summary Get billing cycles
         * @param {number} limit limit the results, default 100
         * @param {Array<number>} [ids] A comma separated list of Ledger Item ids
         * @param {Array<number>} [accountIds] A comma separated list of Account ids
         * @param {Array<string>} [ledgerItemType] Ledger Item Type, either payable or receivable
         * @param {Array<string>} [effectiveAtStart] beginning of effectiveAt range
         * @param {string} [effectiveAtEnd] end of effectiveAt range
         * @param {Array<number>} [netD] The amount of time allowed between cycle end and payment due
         * @param {Date} [createdAtStart] start of createdAtStart range
         * @param {Date} [createdAtEnd] end of createdAtStart range
         * @param {Array<string>} [createdByUuid]
         * @param {Date} [deletedAtStart] start of range for deletedAt
         * @param {Date} [deletedAtEnd] end of range for deletedAt
         * @param {Array<string>} [deletedByUuid] comma separated list of uuid
         * @param {number} [offset] default 0
         * @param {string} [sortBy]
         * @param {Order} [order] default asc
         * @param {boolean} [excludeDeleted] ignore deleted items, default true
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillingCycles: function (limit, ids, accountIds, ledgerItemType, effectiveAtStart, effectiveAtEnd, netD, createdAtStart, createdAtEnd, createdByUuid, deletedAtStart, deletedAtEnd, deletedByUuid, offset, sortBy, order, excludeDeleted, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getBillingCycles(limit, ids, accountIds, ledgerItemType, effectiveAtStart, effectiveAtEnd, netD, createdAtStart, createdAtEnd, createdByUuid, deletedAtStart, deletedAtEnd, deletedByUuid, offset, sortBy, order, excludeDeleted, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillingCycleApi.getBillingCycles']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Updates the memo field of the ledger item corresponding to the specified ID in URL path, if one exists
         * @summary Update a billing cycle
         * @param {number} id
         * @param {BillingCycleUpdateData} [billingCycleUpdateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBillingCycle: function (id, billingCycleUpdateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateBillingCycle(id, billingCycleUpdateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['BillingCycleApi.updateBillingCycle']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.BillingCycleApiFp = BillingCycleApiFp;
/**
 * BillingCycleApi - factory interface
 * @export
 */
var BillingCycleApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.BillingCycleApiFp)(configuration);
    return {
        /**
         *
         * @summary Record a billing cycle
         * @param {BillingCycleApiCreateBillingCycleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createBillingCycle: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createBillingCycle(requestParameters.billingCycleCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Soft delete the billing cycle corresponding to the specified ID in URL path, if one exists
         * @summary Delete a billing cycle
         * @param {BillingCycleApiDeleteBillingCycleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBillingCycle: function (requestParameters, options) {
            return localVarFp.deleteBillingCycle(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Generate a list of ledger items based on a specifed date
         * @summary Generate ledger items
         * @param {BillingCycleApiGenerateLedgerItemsForDateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateLedgerItemsForDate: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.generateLedgerItemsForDate(requestParameters.generateForDate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return a list of billing cycles that match the specified criteria
         * @summary Get billing cycles
         * @param {BillingCycleApiGetBillingCyclesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBillingCycles: function (requestParameters, options) {
            return localVarFp.getBillingCycles(requestParameters.limit, requestParameters.ids, requestParameters.accountIds, requestParameters.ledgerItemType, requestParameters.effectiveAtStart, requestParameters.effectiveAtEnd, requestParameters.netD, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.createdByUuid, requestParameters.deletedAtStart, requestParameters.deletedAtEnd, requestParameters.deletedByUuid, requestParameters.offset, requestParameters.sortBy, requestParameters.order, requestParameters.excludeDeleted, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates the memo field of the ledger item corresponding to the specified ID in URL path, if one exists
         * @summary Update a billing cycle
         * @param {BillingCycleApiUpdateBillingCycleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateBillingCycle: function (requestParameters, options) {
            return localVarFp.updateBillingCycle(requestParameters.id, requestParameters.billingCycleUpdateData, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.BillingCycleApiFactory = BillingCycleApiFactory;
/**
 * BillingCycleApi - object-oriented interface
 * @export
 * @class BillingCycleApi
 * @extends {BaseAPI}
 */
var BillingCycleApi = /** @class */ (function (_super) {
    __extends(BillingCycleApi, _super);
    function BillingCycleApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Record a billing cycle
     * @param {BillingCycleApiCreateBillingCycleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingCycleApi
     */
    BillingCycleApi.prototype.createBillingCycle = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.BillingCycleApiFp)(this.configuration).createBillingCycle(requestParameters.billingCycleCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Soft delete the billing cycle corresponding to the specified ID in URL path, if one exists
     * @summary Delete a billing cycle
     * @param {BillingCycleApiDeleteBillingCycleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingCycleApi
     */
    BillingCycleApi.prototype.deleteBillingCycle = function (requestParameters, options) {
        var _this = this;
        return (0, exports.BillingCycleApiFp)(this.configuration).deleteBillingCycle(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Generate a list of ledger items based on a specifed date
     * @summary Generate ledger items
     * @param {BillingCycleApiGenerateLedgerItemsForDateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingCycleApi
     */
    BillingCycleApi.prototype.generateLedgerItemsForDate = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.BillingCycleApiFp)(this.configuration).generateLedgerItemsForDate(requestParameters.generateForDate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return a list of billing cycles that match the specified criteria
     * @summary Get billing cycles
     * @param {BillingCycleApiGetBillingCyclesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingCycleApi
     */
    BillingCycleApi.prototype.getBillingCycles = function (requestParameters, options) {
        var _this = this;
        return (0, exports.BillingCycleApiFp)(this.configuration).getBillingCycles(requestParameters.limit, requestParameters.ids, requestParameters.accountIds, requestParameters.ledgerItemType, requestParameters.effectiveAtStart, requestParameters.effectiveAtEnd, requestParameters.netD, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.createdByUuid, requestParameters.deletedAtStart, requestParameters.deletedAtEnd, requestParameters.deletedByUuid, requestParameters.offset, requestParameters.sortBy, requestParameters.order, requestParameters.excludeDeleted, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates the memo field of the ledger item corresponding to the specified ID in URL path, if one exists
     * @summary Update a billing cycle
     * @param {BillingCycleApiUpdateBillingCycleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BillingCycleApi
     */
    BillingCycleApi.prototype.updateBillingCycle = function (requestParameters, options) {
        var _this = this;
        return (0, exports.BillingCycleApiFp)(this.configuration).updateBillingCycle(requestParameters.id, requestParameters.billingCycleUpdateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return BillingCycleApi;
}(base_1.BaseAPI));
exports.BillingCycleApi = BillingCycleApi;
/**
 * ContractApi - axios parameter creator
 * @export
 */
var ContractApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create a demand contract
         * @summary Create a demand contract
         * @param {DemandContractCreateData} demandContractCreateData A demand contract object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDemandContract: function (demandContractCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([demandContractCreateData_1], args_1, true), void 0, function (demandContractCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'demandContractCreateData' is not null or undefined
                            (0, common_1.assertParamExists)('createDemandContract', 'demandContractCreateData', demandContractCreateData);
                            localVarPath = "/demandContracts";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(demandContractCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create a supply contract based on the request
         * @summary Create a supply contract
         * @param {SupplyContractCreateData} supplyContractCreateData A supply contract object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplyContract: function (supplyContractCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([supplyContractCreateData_1], args_1, true), void 0, function (supplyContractCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'supplyContractCreateData' is not null or undefined
                            (0, common_1.assertParamExists)('createSupplyContract', 'supplyContractCreateData', supplyContractCreateData);
                            localVarPath = "/supplyContracts";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(supplyContractCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a demand contract
         * @summary Delete a demand contract
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDemandContract: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteDemandContract', 'id', id);
                            localVarPath = "/demandContracts/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a supply contract
         * @summary Delete a supply contract
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplyContract: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteSupplyContract', 'id', id);
                            localVarPath = "/supplyContracts/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Given a demand platform fee configuration, a revenue value, an optional financial product monetary value, and an optional supply sub account id, calculate what the demand contract financials will be. The financialProductMonetaryValue is required, if the demandFeeConfig is defined in terms of the financial product monetary value, and is ignored if it is not. If the supply sub account id is omitted and the demandFeeConfig is defined in terms of the supply sub account id, then the calculation will use the default value for the demandFeeConfig, that is, as though the supply sub account id was not one of the ones for which there are explict rules.
         * @param {string} revenue
         * @param {DemandPlatformFeeConfig} demandFeeConfig
         * @param {string} [financialProductMonetaryValue]
         * @param {number} [supplySubAccountId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        demandPlatformFeeCalculator: function (revenue_1, demandFeeConfig_1, financialProductMonetaryValue_1, supplySubAccountId_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([revenue_1, demandFeeConfig_1, financialProductMonetaryValue_1, supplySubAccountId_1], args_1, true), void 0, function (revenue, demandFeeConfig, financialProductMonetaryValue, supplySubAccountId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, _a, _b, _c, key, value, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_d) {
                    // verify required parameter 'revenue' is not null or undefined
                    (0, common_1.assertParamExists)('demandPlatformFeeCalculator', 'revenue', revenue);
                    // verify required parameter 'demandFeeConfig' is not null or undefined
                    (0, common_1.assertParamExists)('demandPlatformFeeCalculator', 'demandFeeConfig', demandFeeConfig);
                    localVarPath = "/demandContracts/demandPlatformFeeCalculator";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (financialProductMonetaryValue !== undefined) {
                        localVarQueryParameter['financialProductMonetaryValue'] = financialProductMonetaryValue;
                    }
                    if (revenue !== undefined) {
                        localVarQueryParameter['revenue'] = revenue;
                    }
                    if (demandFeeConfig !== undefined) {
                        for (_a = 0, _b = Object.entries(demandFeeConfig); _a < _b.length; _a++) {
                            _c = _b[_a], key = _c[0], value = _c[1];
                            localVarQueryParameter[key] = value;
                        }
                    }
                    if (supplySubAccountId !== undefined) {
                        localVarQueryParameter['supplySubAccountId'] = supplySubAccountId;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Return active demand contracts
         * @summary Get active demand contracts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveDemandContracts: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/demandContracts/active";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Return demand contracts based on request parameters
         * @summary Get demand contracts
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id] A comma separated list of demand contract IDs
         * @param {Array<number>} [subAccountId] A comma separated list of sub-account IDs
         * @param {string} [salesforceOpportunityId] Salesforce opportunity ID for contract
         * @param {Array<ProductType>} [productType] Product types associated with the contract\&#39;s sub-account.
         * @param {string} [effectiveAt] contract effective at date
         * @param {string} [effectiveAtMax] max effective at date for contract
         * @param {string} [effectiveAtMin] min effective at date for contract
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {Array<string>} [createdBy]
         * @param {Date} [deletedAtMin]
         * @param {Date} [deletedAtMax]
         * @param {boolean} [isDeleted]
         * @param {Array<string>} [deletedBy]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {string} [sortBy] The attribute with which to sort the resources.
         * @param {string} [order] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandContracts: function (limit_1, id_1, subAccountId_1, salesforceOpportunityId_1, productType_1, effectiveAt_1, effectiveAtMax_1, effectiveAtMin_1, createdAtMin_1, createdAtMax_1, createdBy_1, deletedAtMin_1, deletedAtMax_1, isDeleted_1, deletedBy_1, offset_1, sortBy_1, order_1) {
            var args_1 = [];
            for (var _i = 18; _i < arguments.length; _i++) {
                args_1[_i - 18] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, subAccountId_1, salesforceOpportunityId_1, productType_1, effectiveAt_1, effectiveAtMax_1, effectiveAtMin_1, createdAtMin_1, createdAtMax_1, createdBy_1, deletedAtMin_1, deletedAtMax_1, isDeleted_1, deletedBy_1, offset_1, sortBy_1, order_1], args_1, true), void 0, function (limit, id, subAccountId, salesforceOpportunityId, productType, effectiveAt, effectiveAtMax, effectiveAtMin, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, deletedBy, offset, sortBy, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getDemandContracts', 'limit', limit);
                            localVarPath = "/demandContracts";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (subAccountId) {
                                localVarQueryParameter['subAccountId'] = subAccountId;
                            }
                            if (salesforceOpportunityId !== undefined) {
                                localVarQueryParameter['salesforceOpportunityId'] = salesforceOpportunityId;
                            }
                            if (productType) {
                                localVarQueryParameter['productType'] = productType;
                            }
                            if (effectiveAt !== undefined) {
                                localVarQueryParameter['effectiveAt'] = (effectiveAt instanceof Date) ?
                                    effectiveAt.toISOString().substring(0, 10) :
                                    effectiveAt;
                            }
                            if (effectiveAtMax !== undefined) {
                                localVarQueryParameter['effectiveAtMax'] = (effectiveAtMax instanceof Date) ?
                                    effectiveAtMax.toISOString().substring(0, 10) :
                                    effectiveAtMax;
                            }
                            if (effectiveAtMin !== undefined) {
                                localVarQueryParameter['effectiveAtMin'] = (effectiveAtMin instanceof Date) ?
                                    effectiveAtMin.toISOString().substring(0, 10) :
                                    effectiveAtMin;
                            }
                            if (createdAtMin !== undefined) {
                                localVarQueryParameter['createdAtMin'] = (createdAtMin instanceof Date) ?
                                    createdAtMin.toISOString() :
                                    createdAtMin;
                            }
                            if (createdAtMax !== undefined) {
                                localVarQueryParameter['createdAtMax'] = (createdAtMax instanceof Date) ?
                                    createdAtMax.toISOString() :
                                    createdAtMax;
                            }
                            if (createdBy) {
                                localVarQueryParameter['createdBy'] = createdBy;
                            }
                            if (deletedAtMin !== undefined) {
                                localVarQueryParameter['deletedAtMin'] = (deletedAtMin instanceof Date) ?
                                    deletedAtMin.toISOString() :
                                    deletedAtMin;
                            }
                            if (deletedAtMax !== undefined) {
                                localVarQueryParameter['deletedAtMax'] = (deletedAtMax instanceof Date) ?
                                    deletedAtMax.toISOString() :
                                    deletedAtMax;
                            }
                            if (isDeleted !== undefined) {
                                localVarQueryParameter['isDeleted'] = isDeleted;
                            }
                            if (deletedBy) {
                                localVarQueryParameter['deletedBy'] = deletedBy;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Return supply contracts based on request parameters
         * @summary Get supply contracts
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id] A comma separated list of demand contract IDs
         * @param {Array<number>} [subAccountId] A comma separated list of sub-account IDs
         * @param {string} [salesforceOpportunityId] Salesforce opportunity ID for contract
         * @param {string} [effectiveAt] contract effective at date
         * @param {string} [effectiveAtMax] max effective at date for contract
         * @param {string} [effectiveAtMin] min effective at date for contract
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {Array<string>} [createdBy]
         * @param {Date} [deletedAtMin]
         * @param {Date} [deletedAtMax]
         * @param {boolean} [isDeleted]
         * @param {Array<string>} [deletedBy]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {string} [sortBy] The attribute with which to sort the resources.
         * @param {string} [order] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplyContracts: function (limit_1, id_1, subAccountId_1, salesforceOpportunityId_1, effectiveAt_1, effectiveAtMax_1, effectiveAtMin_1, createdAtMin_1, createdAtMax_1, createdBy_1, deletedAtMin_1, deletedAtMax_1, isDeleted_1, deletedBy_1, offset_1, sortBy_1, order_1) {
            var args_1 = [];
            for (var _i = 17; _i < arguments.length; _i++) {
                args_1[_i - 17] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, subAccountId_1, salesforceOpportunityId_1, effectiveAt_1, effectiveAtMax_1, effectiveAtMin_1, createdAtMin_1, createdAtMax_1, createdBy_1, deletedAtMin_1, deletedAtMax_1, isDeleted_1, deletedBy_1, offset_1, sortBy_1, order_1], args_1, true), void 0, function (limit, id, subAccountId, salesforceOpportunityId, effectiveAt, effectiveAtMax, effectiveAtMin, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, deletedBy, offset, sortBy, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getSupplyContracts', 'limit', limit);
                            localVarPath = "/supplyContracts";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (subAccountId) {
                                localVarQueryParameter['subAccountId'] = subAccountId;
                            }
                            if (salesforceOpportunityId !== undefined) {
                                localVarQueryParameter['salesforceOpportunityId'] = salesforceOpportunityId;
                            }
                            if (effectiveAt !== undefined) {
                                localVarQueryParameter['effectiveAt'] = (effectiveAt instanceof Date) ?
                                    effectiveAt.toISOString().substring(0, 10) :
                                    effectiveAt;
                            }
                            if (effectiveAtMax !== undefined) {
                                localVarQueryParameter['effectiveAtMax'] = (effectiveAtMax instanceof Date) ?
                                    effectiveAtMax.toISOString().substring(0, 10) :
                                    effectiveAtMax;
                            }
                            if (effectiveAtMin !== undefined) {
                                localVarQueryParameter['effectiveAtMin'] = (effectiveAtMin instanceof Date) ?
                                    effectiveAtMin.toISOString().substring(0, 10) :
                                    effectiveAtMin;
                            }
                            if (createdAtMin !== undefined) {
                                localVarQueryParameter['createdAtMin'] = (createdAtMin instanceof Date) ?
                                    createdAtMin.toISOString() :
                                    createdAtMin;
                            }
                            if (createdAtMax !== undefined) {
                                localVarQueryParameter['createdAtMax'] = (createdAtMax instanceof Date) ?
                                    createdAtMax.toISOString() :
                                    createdAtMax;
                            }
                            if (createdBy) {
                                localVarQueryParameter['createdBy'] = createdBy;
                            }
                            if (deletedAtMin !== undefined) {
                                localVarQueryParameter['deletedAtMin'] = (deletedAtMin instanceof Date) ?
                                    deletedAtMin.toISOString() :
                                    deletedAtMin;
                            }
                            if (deletedAtMax !== undefined) {
                                localVarQueryParameter['deletedAtMax'] = (deletedAtMax instanceof Date) ?
                                    deletedAtMax.toISOString() :
                                    deletedAtMax;
                            }
                            if (isDeleted !== undefined) {
                                localVarQueryParameter['isDeleted'] = isDeleted;
                            }
                            if (deletedBy) {
                                localVarQueryParameter['deletedBy'] = deletedBy;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ContractApiAxiosParamCreator = ContractApiAxiosParamCreator;
/**
 * ContractApi - functional programming interface
 * @export
 */
var ContractApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ContractApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create a demand contract
         * @summary Create a demand contract
         * @param {DemandContractCreateData} demandContractCreateData A demand contract object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDemandContract: function (demandContractCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createDemandContract(demandContractCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ContractApi.createDemandContract']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Create a supply contract based on the request
         * @summary Create a supply contract
         * @param {SupplyContractCreateData} supplyContractCreateData A supply contract object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplyContract: function (supplyContractCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSupplyContract(supplyContractCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ContractApi.createSupplyContract']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete a demand contract
         * @summary Delete a demand contract
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDemandContract: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteDemandContract(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ContractApi.deleteDemandContract']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete a supply contract
         * @summary Delete a supply contract
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplyContract: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteSupplyContract(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ContractApi.deleteSupplyContract']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Given a demand platform fee configuration, a revenue value, an optional financial product monetary value, and an optional supply sub account id, calculate what the demand contract financials will be. The financialProductMonetaryValue is required, if the demandFeeConfig is defined in terms of the financial product monetary value, and is ignored if it is not. If the supply sub account id is omitted and the demandFeeConfig is defined in terms of the supply sub account id, then the calculation will use the default value for the demandFeeConfig, that is, as though the supply sub account id was not one of the ones for which there are explict rules.
         * @param {string} revenue
         * @param {DemandPlatformFeeConfig} demandFeeConfig
         * @param {string} [financialProductMonetaryValue]
         * @param {number} [supplySubAccountId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        demandPlatformFeeCalculator: function (revenue, demandFeeConfig, financialProductMonetaryValue, supplySubAccountId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.demandPlatformFeeCalculator(revenue, demandFeeConfig, financialProductMonetaryValue, supplySubAccountId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ContractApi.demandPlatformFeeCalculator']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Return active demand contracts
         * @summary Get active demand contracts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveDemandContracts: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getActiveDemandContracts(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ContractApi.getActiveDemandContracts']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Return demand contracts based on request parameters
         * @summary Get demand contracts
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id] A comma separated list of demand contract IDs
         * @param {Array<number>} [subAccountId] A comma separated list of sub-account IDs
         * @param {string} [salesforceOpportunityId] Salesforce opportunity ID for contract
         * @param {Array<ProductType>} [productType] Product types associated with the contract\&#39;s sub-account.
         * @param {string} [effectiveAt] contract effective at date
         * @param {string} [effectiveAtMax] max effective at date for contract
         * @param {string} [effectiveAtMin] min effective at date for contract
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {Array<string>} [createdBy]
         * @param {Date} [deletedAtMin]
         * @param {Date} [deletedAtMax]
         * @param {boolean} [isDeleted]
         * @param {Array<string>} [deletedBy]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {string} [sortBy] The attribute with which to sort the resources.
         * @param {string} [order] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandContracts: function (limit, id, subAccountId, salesforceOpportunityId, productType, effectiveAt, effectiveAtMax, effectiveAtMin, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, deletedBy, offset, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDemandContracts(limit, id, subAccountId, salesforceOpportunityId, productType, effectiveAt, effectiveAtMax, effectiveAtMin, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, deletedBy, offset, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ContractApi.getDemandContracts']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Return supply contracts based on request parameters
         * @summary Get supply contracts
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id] A comma separated list of demand contract IDs
         * @param {Array<number>} [subAccountId] A comma separated list of sub-account IDs
         * @param {string} [salesforceOpportunityId] Salesforce opportunity ID for contract
         * @param {string} [effectiveAt] contract effective at date
         * @param {string} [effectiveAtMax] max effective at date for contract
         * @param {string} [effectiveAtMin] min effective at date for contract
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {Array<string>} [createdBy]
         * @param {Date} [deletedAtMin]
         * @param {Date} [deletedAtMax]
         * @param {boolean} [isDeleted]
         * @param {Array<string>} [deletedBy]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {string} [sortBy] The attribute with which to sort the resources.
         * @param {string} [order] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplyContracts: function (limit, id, subAccountId, salesforceOpportunityId, effectiveAt, effectiveAtMax, effectiveAtMin, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, deletedBy, offset, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSupplyContracts(limit, id, subAccountId, salesforceOpportunityId, effectiveAt, effectiveAtMax, effectiveAtMin, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, deletedBy, offset, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ContractApi.getSupplyContracts']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.ContractApiFp = ContractApiFp;
/**
 * ContractApi - factory interface
 * @export
 */
var ContractApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ContractApiFp)(configuration);
    return {
        /**
         * Create a demand contract
         * @summary Create a demand contract
         * @param {ContractApiCreateDemandContractRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDemandContract: function (requestParameters, options) {
            return localVarFp.createDemandContract(requestParameters.demandContractCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a supply contract based on the request
         * @summary Create a supply contract
         * @param {ContractApiCreateSupplyContractRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplyContract: function (requestParameters, options) {
            return localVarFp.createSupplyContract(requestParameters.supplyContractCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a demand contract
         * @summary Delete a demand contract
         * @param {ContractApiDeleteDemandContractRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDemandContract: function (requestParameters, options) {
            return localVarFp.deleteDemandContract(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a supply contract
         * @summary Delete a supply contract
         * @param {ContractApiDeleteSupplyContractRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplyContract: function (requestParameters, options) {
            return localVarFp.deleteSupplyContract(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Given a demand platform fee configuration, a revenue value, an optional financial product monetary value, and an optional supply sub account id, calculate what the demand contract financials will be. The financialProductMonetaryValue is required, if the demandFeeConfig is defined in terms of the financial product monetary value, and is ignored if it is not. If the supply sub account id is omitted and the demandFeeConfig is defined in terms of the supply sub account id, then the calculation will use the default value for the demandFeeConfig, that is, as though the supply sub account id was not one of the ones for which there are explict rules.
         * @param {ContractApiDemandPlatformFeeCalculatorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        demandPlatformFeeCalculator: function (requestParameters, options) {
            return localVarFp.demandPlatformFeeCalculator(requestParameters.revenue, requestParameters.demandFeeConfig, requestParameters.financialProductMonetaryValue, requestParameters.supplySubAccountId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return active demand contracts
         * @summary Get active demand contracts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveDemandContracts: function (options) {
            return localVarFp.getActiveDemandContracts(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return demand contracts based on request parameters
         * @summary Get demand contracts
         * @param {ContractApiGetDemandContractsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandContracts: function (requestParameters, options) {
            return localVarFp.getDemandContracts(requestParameters.limit, requestParameters.id, requestParameters.subAccountId, requestParameters.salesforceOpportunityId, requestParameters.productType, requestParameters.effectiveAt, requestParameters.effectiveAtMax, requestParameters.effectiveAtMin, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.isDeleted, requestParameters.deletedBy, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return supply contracts based on request parameters
         * @summary Get supply contracts
         * @param {ContractApiGetSupplyContractsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplyContracts: function (requestParameters, options) {
            return localVarFp.getSupplyContracts(requestParameters.limit, requestParameters.id, requestParameters.subAccountId, requestParameters.salesforceOpportunityId, requestParameters.effectiveAt, requestParameters.effectiveAtMax, requestParameters.effectiveAtMin, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.isDeleted, requestParameters.deletedBy, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ContractApiFactory = ContractApiFactory;
/**
 * ContractApi - object-oriented interface
 * @export
 * @class ContractApi
 * @extends {BaseAPI}
 */
var ContractApi = /** @class */ (function (_super) {
    __extends(ContractApi, _super);
    function ContractApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a demand contract
     * @summary Create a demand contract
     * @param {ContractApiCreateDemandContractRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractApi
     */
    ContractApi.prototype.createDemandContract = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ContractApiFp)(this.configuration).createDemandContract(requestParameters.demandContractCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create a supply contract based on the request
     * @summary Create a supply contract
     * @param {ContractApiCreateSupplyContractRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractApi
     */
    ContractApi.prototype.createSupplyContract = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ContractApiFp)(this.configuration).createSupplyContract(requestParameters.supplyContractCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a demand contract
     * @summary Delete a demand contract
     * @param {ContractApiDeleteDemandContractRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractApi
     */
    ContractApi.prototype.deleteDemandContract = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ContractApiFp)(this.configuration).deleteDemandContract(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a supply contract
     * @summary Delete a supply contract
     * @param {ContractApiDeleteSupplyContractRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractApi
     */
    ContractApi.prototype.deleteSupplyContract = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ContractApiFp)(this.configuration).deleteSupplyContract(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Given a demand platform fee configuration, a revenue value, an optional financial product monetary value, and an optional supply sub account id, calculate what the demand contract financials will be. The financialProductMonetaryValue is required, if the demandFeeConfig is defined in terms of the financial product monetary value, and is ignored if it is not. If the supply sub account id is omitted and the demandFeeConfig is defined in terms of the supply sub account id, then the calculation will use the default value for the demandFeeConfig, that is, as though the supply sub account id was not one of the ones for which there are explict rules.
     * @param {ContractApiDemandPlatformFeeCalculatorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractApi
     */
    ContractApi.prototype.demandPlatformFeeCalculator = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ContractApiFp)(this.configuration).demandPlatformFeeCalculator(requestParameters.revenue, requestParameters.demandFeeConfig, requestParameters.financialProductMonetaryValue, requestParameters.supplySubAccountId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return active demand contracts
     * @summary Get active demand contracts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractApi
     */
    ContractApi.prototype.getActiveDemandContracts = function (options) {
        var _this = this;
        return (0, exports.ContractApiFp)(this.configuration).getActiveDemandContracts(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return demand contracts based on request parameters
     * @summary Get demand contracts
     * @param {ContractApiGetDemandContractsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractApi
     */
    ContractApi.prototype.getDemandContracts = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ContractApiFp)(this.configuration).getDemandContracts(requestParameters.limit, requestParameters.id, requestParameters.subAccountId, requestParameters.salesforceOpportunityId, requestParameters.productType, requestParameters.effectiveAt, requestParameters.effectiveAtMax, requestParameters.effectiveAtMin, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.isDeleted, requestParameters.deletedBy, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return supply contracts based on request parameters
     * @summary Get supply contracts
     * @param {ContractApiGetSupplyContractsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractApi
     */
    ContractApi.prototype.getSupplyContracts = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ContractApiFp)(this.configuration).getSupplyContracts(requestParameters.limit, requestParameters.id, requestParameters.subAccountId, requestParameters.salesforceOpportunityId, requestParameters.effectiveAt, requestParameters.effectiveAtMax, requestParameters.effectiveAtMin, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.isDeleted, requestParameters.deletedBy, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ContractApi;
}(base_1.BaseAPI));
exports.ContractApi = ContractApi;
/**
 * DemandDataFileApi - axios parameter creator
 * @export
 */
var DemandDataFileApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create a demand data file
         * @summary Create a demand data file
         * @param {DemandDataFileCreateData} [demandDataFileCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDemandDataFile: function (demandDataFileCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([demandDataFileCreateData_1], args_1, true), void 0, function (demandDataFileCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/demandDataFiles";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(demandDataFileCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a demand data file
         * @summary Delete a demand data file
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDemandDataFile: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteDemandDataFile', 'id', id);
                            localVarPath = "/demandDataFiles/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Return demand data files based upon request parameters
         * @summary Get demand data files
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [ids]
         * @param {Array<string>} [urls]
         * @param {Array<string>} [sources]
         * @param {string} [state]
         * @param {Array<number>} [configurationIds]
         * @param {boolean} [excludeDeleted]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {string} [sortBy] The attribute with which to sort the resources.
         * @param {string} [orderAscending] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandDataFiles: function (limit_1, ids_1, urls_1, sources_1, state_1, configurationIds_1, excludeDeleted_1, offset_1, sortBy_1, orderAscending_1) {
            var args_1 = [];
            for (var _i = 10; _i < arguments.length; _i++) {
                args_1[_i - 10] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, ids_1, urls_1, sources_1, state_1, configurationIds_1, excludeDeleted_1, offset_1, sortBy_1, orderAscending_1], args_1, true), void 0, function (limit, ids, urls, sources, state, configurationIds, excludeDeleted, offset, sortBy, orderAscending, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getDemandDataFiles', 'limit', limit);
                            localVarPath = "/demandDataFiles";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (ids) {
                                localVarQueryParameter['ids'] = ids;
                            }
                            if (urls) {
                                localVarQueryParameter['urls'] = urls;
                            }
                            if (sources) {
                                localVarQueryParameter['sources'] = sources;
                            }
                            if (state !== undefined) {
                                localVarQueryParameter['state'] = state;
                            }
                            if (configurationIds) {
                                localVarQueryParameter['configurationIds'] = configurationIds;
                            }
                            if (excludeDeleted !== undefined) {
                                localVarQueryParameter['excludeDeleted'] = excludeDeleted;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (orderAscending !== undefined) {
                                localVarQueryParameter['orderAscending'] = orderAscending;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.DemandDataFileApiAxiosParamCreator = DemandDataFileApiAxiosParamCreator;
/**
 * DemandDataFileApi - functional programming interface
 * @export
 */
var DemandDataFileApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DemandDataFileApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create a demand data file
         * @summary Create a demand data file
         * @param {DemandDataFileCreateData} [demandDataFileCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDemandDataFile: function (demandDataFileCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createDemandDataFile(demandDataFileCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandDataFileApi.createDemandDataFile']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete a demand data file
         * @summary Delete a demand data file
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDemandDataFile: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteDemandDataFile(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandDataFileApi.deleteDemandDataFile']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Return demand data files based upon request parameters
         * @summary Get demand data files
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [ids]
         * @param {Array<string>} [urls]
         * @param {Array<string>} [sources]
         * @param {string} [state]
         * @param {Array<number>} [configurationIds]
         * @param {boolean} [excludeDeleted]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {string} [sortBy] The attribute with which to sort the resources.
         * @param {string} [orderAscending] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandDataFiles: function (limit, ids, urls, sources, state, configurationIds, excludeDeleted, offset, sortBy, orderAscending, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDemandDataFiles(limit, ids, urls, sources, state, configurationIds, excludeDeleted, offset, sortBy, orderAscending, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandDataFileApi.getDemandDataFiles']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.DemandDataFileApiFp = DemandDataFileApiFp;
/**
 * DemandDataFileApi - factory interface
 * @export
 */
var DemandDataFileApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DemandDataFileApiFp)(configuration);
    return {
        /**
         * Create a demand data file
         * @summary Create a demand data file
         * @param {DemandDataFileApiCreateDemandDataFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDemandDataFile: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createDemandDataFile(requestParameters.demandDataFileCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a demand data file
         * @summary Delete a demand data file
         * @param {DemandDataFileApiDeleteDemandDataFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDemandDataFile: function (requestParameters, options) {
            return localVarFp.deleteDemandDataFile(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return demand data files based upon request parameters
         * @summary Get demand data files
         * @param {DemandDataFileApiGetDemandDataFilesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandDataFiles: function (requestParameters, options) {
            return localVarFp.getDemandDataFiles(requestParameters.limit, requestParameters.ids, requestParameters.urls, requestParameters.sources, requestParameters.state, requestParameters.configurationIds, requestParameters.excludeDeleted, requestParameters.offset, requestParameters.sortBy, requestParameters.orderAscending, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DemandDataFileApiFactory = DemandDataFileApiFactory;
/**
 * DemandDataFileApi - object-oriented interface
 * @export
 * @class DemandDataFileApi
 * @extends {BaseAPI}
 */
var DemandDataFileApi = /** @class */ (function (_super) {
    __extends(DemandDataFileApi, _super);
    function DemandDataFileApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a demand data file
     * @summary Create a demand data file
     * @param {DemandDataFileApiCreateDemandDataFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandDataFileApi
     */
    DemandDataFileApi.prototype.createDemandDataFile = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DemandDataFileApiFp)(this.configuration).createDemandDataFile(requestParameters.demandDataFileCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a demand data file
     * @summary Delete a demand data file
     * @param {DemandDataFileApiDeleteDemandDataFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandDataFileApi
     */
    DemandDataFileApi.prototype.deleteDemandDataFile = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DemandDataFileApiFp)(this.configuration).deleteDemandDataFile(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return demand data files based upon request parameters
     * @summary Get demand data files
     * @param {DemandDataFileApiGetDemandDataFilesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandDataFileApi
     */
    DemandDataFileApi.prototype.getDemandDataFiles = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DemandDataFileApiFp)(this.configuration).getDemandDataFiles(requestParameters.limit, requestParameters.ids, requestParameters.urls, requestParameters.sources, requestParameters.state, requestParameters.configurationIds, requestParameters.excludeDeleted, requestParameters.offset, requestParameters.sortBy, requestParameters.orderAscending, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DemandDataFileApi;
}(base_1.BaseAPI));
exports.DemandDataFileApi = DemandDataFileApi;
/**
 * DemandDataImportApi - axios parameter creator
 * @export
 */
var DemandDataImportApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create a demand data import
         * @summary Create a demand data import
         * @param {DemandDataImportCreateData} [demandDataImportCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDemandDataImport: function (demandDataImportCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([demandDataImportCreateData_1], args_1, true), void 0, function (demandDataImportCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/demandDataImports";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(demandDataImportCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a demand data import
         * @summary Delete a demand data import
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDemandDataImport: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteDemandDataImport', 'id', id);
                            localVarPath = "/demandDataImports/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get demand data extractors
         * @summary Get demand data extractors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandDataExtractors: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/demandDataExtractors";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get demand data import lines
         * @summary Get demand data import lines
         * @param {number} limit limit results
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {number} [importId]
         * @param {string} [status]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {number} [lineNumbers]
         * @param {number} [duplicateExternalDemandEventIds]
         * @param {number} [newExternalDemandEventIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandDataImportLines: function (limit_1, id_1, importId_1, status_1, offset_1, sortBy_1, order_1, lineNumbers_1, duplicateExternalDemandEventIds_1, newExternalDemandEventIds_1) {
            var args_1 = [];
            for (var _i = 10; _i < arguments.length; _i++) {
                args_1[_i - 10] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, importId_1, status_1, offset_1, sortBy_1, order_1, lineNumbers_1, duplicateExternalDemandEventIds_1, newExternalDemandEventIds_1], args_1, true), void 0, function (limit, id, importId, status, offset, sortBy, order, lineNumbers, duplicateExternalDemandEventIds, newExternalDemandEventIds, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getDemandDataImportLines', 'limit', limit);
                            localVarPath = "/demandDataImportLines";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (importId !== undefined) {
                                localVarQueryParameter['importId'] = importId;
                            }
                            if (status !== undefined) {
                                localVarQueryParameter['status'] = status;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (lineNumbers !== undefined) {
                                localVarQueryParameter['lineNumbers'] = lineNumbers;
                            }
                            if (duplicateExternalDemandEventIds !== undefined) {
                                localVarQueryParameter['duplicateExternalDemandEventIds'] = duplicateExternalDemandEventIds;
                            }
                            if (newExternalDemandEventIds !== undefined) {
                                localVarQueryParameter['newExternalDemandEventIds'] = newExternalDemandEventIds;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get demand data import statuses
         * @summary Get demand data import statuses
         * @param {number} limit limit results
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {number} [importId]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandDataImportStatuses: function (limit_1, id_1, importId_1, offset_1, sortBy_1, order_1) {
            var args_1 = [];
            for (var _i = 6; _i < arguments.length; _i++) {
                args_1[_i - 6] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, importId_1, offset_1, sortBy_1, order_1], args_1, true), void 0, function (limit, id, importId, offset, sortBy, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getDemandDataImportStatuses', 'limit', limit);
                            localVarPath = "/demandDataImportStatuses";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (importId !== undefined) {
                                localVarQueryParameter['importId'] = importId;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Return demand data import summaries based upon request parameters
         * @summary Get demand data import summaries
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<number>} [fileId]
         * @param {Array<number>} [configurationId]
         * @param {Array<number>} [demandSubAccountId]
         * @param {Array<string>} [createdByUuid]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] The attribute with which to sort the resources.
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandDataImportSummaries: function (limit_1, id_1, fileId_1, configurationId_1, demandSubAccountId_1, createdByUuid_1, offset_1, sortBy_1, order_1) {
            var args_1 = [];
            for (var _i = 9; _i < arguments.length; _i++) {
                args_1[_i - 9] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, fileId_1, configurationId_1, demandSubAccountId_1, createdByUuid_1, offset_1, sortBy_1, order_1], args_1, true), void 0, function (limit, id, fileId, configurationId, demandSubAccountId, createdByUuid, offset, sortBy, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getDemandDataImportSummaries', 'limit', limit);
                            localVarPath = "/demandDataImportSummaries";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (fileId) {
                                localVarQueryParameter['fileId'] = fileId;
                            }
                            if (configurationId) {
                                localVarQueryParameter['configurationId'] = configurationId;
                            }
                            if (demandSubAccountId) {
                                localVarQueryParameter['demandSubAccountId'] = demandSubAccountId;
                            }
                            if (createdByUuid) {
                                localVarQueryParameter['createdByUuid'] = createdByUuid;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Return demand data imports based upon request parameters
         * @summary Get demand data imports
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id]
         * @param {Array<number>} [fileId]
         * @param {Array<number>} [configurationId]
         * @param {Array<number>} [demandSubAccountId]
         * @param {Array<string>} [createdByUuid]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {string} [sortBy] The attribute with which to sort the resources.
         * @param {string} [order] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandDataImports: function (limit_1, id_1, fileId_1, configurationId_1, demandSubAccountId_1, createdByUuid_1, offset_1, sortBy_1, order_1) {
            var args_1 = [];
            for (var _i = 9; _i < arguments.length; _i++) {
                args_1[_i - 9] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, fileId_1, configurationId_1, demandSubAccountId_1, createdByUuid_1, offset_1, sortBy_1, order_1], args_1, true), void 0, function (limit, id, fileId, configurationId, demandSubAccountId, createdByUuid, offset, sortBy, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getDemandDataImports', 'limit', limit);
                            localVarPath = "/demandDataImports";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (fileId) {
                                localVarQueryParameter['fileId'] = fileId;
                            }
                            if (configurationId) {
                                localVarQueryParameter['configurationId'] = configurationId;
                            }
                            if (demandSubAccountId) {
                                localVarQueryParameter['demandSubAccountId'] = demandSubAccountId;
                            }
                            if (createdByUuid) {
                                localVarQueryParameter['createdByUuid'] = createdByUuid;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get demand data transformers
         * @summary Get demand data transformers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandDataTransformers: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/demandDataTransformers";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.DemandDataImportApiAxiosParamCreator = DemandDataImportApiAxiosParamCreator;
/**
 * DemandDataImportApi - functional programming interface
 * @export
 */
var DemandDataImportApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DemandDataImportApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create a demand data import
         * @summary Create a demand data import
         * @param {DemandDataImportCreateData} [demandDataImportCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDemandDataImport: function (demandDataImportCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createDemandDataImport(demandDataImportCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandDataImportApi.createDemandDataImport']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete a demand data import
         * @summary Delete a demand data import
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDemandDataImport: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteDemandDataImport(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandDataImportApi.deleteDemandDataImport']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get demand data extractors
         * @summary Get demand data extractors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandDataExtractors: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDemandDataExtractors(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandDataImportApi.getDemandDataExtractors']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get demand data import lines
         * @summary Get demand data import lines
         * @param {number} limit limit results
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {number} [importId]
         * @param {string} [status]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {number} [lineNumbers]
         * @param {number} [duplicateExternalDemandEventIds]
         * @param {number} [newExternalDemandEventIds]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandDataImportLines: function (limit, id, importId, status, offset, sortBy, order, lineNumbers, duplicateExternalDemandEventIds, newExternalDemandEventIds, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDemandDataImportLines(limit, id, importId, status, offset, sortBy, order, lineNumbers, duplicateExternalDemandEventIds, newExternalDemandEventIds, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandDataImportApi.getDemandDataImportLines']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get demand data import statuses
         * @summary Get demand data import statuses
         * @param {number} limit limit results
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {number} [importId]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandDataImportStatuses: function (limit, id, importId, offset, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDemandDataImportStatuses(limit, id, importId, offset, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandDataImportApi.getDemandDataImportStatuses']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Return demand data import summaries based upon request parameters
         * @summary Get demand data import summaries
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<number>} [fileId]
         * @param {Array<number>} [configurationId]
         * @param {Array<number>} [demandSubAccountId]
         * @param {Array<string>} [createdByUuid]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] The attribute with which to sort the resources.
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandDataImportSummaries: function (limit, id, fileId, configurationId, demandSubAccountId, createdByUuid, offset, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDemandDataImportSummaries(limit, id, fileId, configurationId, demandSubAccountId, createdByUuid, offset, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandDataImportApi.getDemandDataImportSummaries']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Return demand data imports based upon request parameters
         * @summary Get demand data imports
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id]
         * @param {Array<number>} [fileId]
         * @param {Array<number>} [configurationId]
         * @param {Array<number>} [demandSubAccountId]
         * @param {Array<string>} [createdByUuid]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {string} [sortBy] The attribute with which to sort the resources.
         * @param {string} [order] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandDataImports: function (limit, id, fileId, configurationId, demandSubAccountId, createdByUuid, offset, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDemandDataImports(limit, id, fileId, configurationId, demandSubAccountId, createdByUuid, offset, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandDataImportApi.getDemandDataImports']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get demand data transformers
         * @summary Get demand data transformers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandDataTransformers: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDemandDataTransformers(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandDataImportApi.getDemandDataTransformers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.DemandDataImportApiFp = DemandDataImportApiFp;
/**
 * DemandDataImportApi - factory interface
 * @export
 */
var DemandDataImportApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DemandDataImportApiFp)(configuration);
    return {
        /**
         * Create a demand data import
         * @summary Create a demand data import
         * @param {DemandDataImportApiCreateDemandDataImportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDemandDataImport: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createDemandDataImport(requestParameters.demandDataImportCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a demand data import
         * @summary Delete a demand data import
         * @param {DemandDataImportApiDeleteDemandDataImportRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDemandDataImport: function (requestParameters, options) {
            return localVarFp.deleteDemandDataImport(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get demand data extractors
         * @summary Get demand data extractors
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandDataExtractors: function (options) {
            return localVarFp.getDemandDataExtractors(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get demand data import lines
         * @summary Get demand data import lines
         * @param {DemandDataImportApiGetDemandDataImportLinesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandDataImportLines: function (requestParameters, options) {
            return localVarFp.getDemandDataImportLines(requestParameters.limit, requestParameters.id, requestParameters.importId, requestParameters.status, requestParameters.offset, requestParameters.sortBy, requestParameters.order, requestParameters.lineNumbers, requestParameters.duplicateExternalDemandEventIds, requestParameters.newExternalDemandEventIds, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get demand data import statuses
         * @summary Get demand data import statuses
         * @param {DemandDataImportApiGetDemandDataImportStatusesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandDataImportStatuses: function (requestParameters, options) {
            return localVarFp.getDemandDataImportStatuses(requestParameters.limit, requestParameters.id, requestParameters.importId, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return demand data import summaries based upon request parameters
         * @summary Get demand data import summaries
         * @param {DemandDataImportApiGetDemandDataImportSummariesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandDataImportSummaries: function (requestParameters, options) {
            return localVarFp.getDemandDataImportSummaries(requestParameters.limit, requestParameters.id, requestParameters.fileId, requestParameters.configurationId, requestParameters.demandSubAccountId, requestParameters.createdByUuid, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return demand data imports based upon request parameters
         * @summary Get demand data imports
         * @param {DemandDataImportApiGetDemandDataImportsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandDataImports: function (requestParameters, options) {
            return localVarFp.getDemandDataImports(requestParameters.limit, requestParameters.id, requestParameters.fileId, requestParameters.configurationId, requestParameters.demandSubAccountId, requestParameters.createdByUuid, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get demand data transformers
         * @summary Get demand data transformers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandDataTransformers: function (options) {
            return localVarFp.getDemandDataTransformers(options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DemandDataImportApiFactory = DemandDataImportApiFactory;
/**
 * DemandDataImportApi - object-oriented interface
 * @export
 * @class DemandDataImportApi
 * @extends {BaseAPI}
 */
var DemandDataImportApi = /** @class */ (function (_super) {
    __extends(DemandDataImportApi, _super);
    function DemandDataImportApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a demand data import
     * @summary Create a demand data import
     * @param {DemandDataImportApiCreateDemandDataImportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandDataImportApi
     */
    DemandDataImportApi.prototype.createDemandDataImport = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DemandDataImportApiFp)(this.configuration).createDemandDataImport(requestParameters.demandDataImportCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a demand data import
     * @summary Delete a demand data import
     * @param {DemandDataImportApiDeleteDemandDataImportRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandDataImportApi
     */
    DemandDataImportApi.prototype.deleteDemandDataImport = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DemandDataImportApiFp)(this.configuration).deleteDemandDataImport(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get demand data extractors
     * @summary Get demand data extractors
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandDataImportApi
     */
    DemandDataImportApi.prototype.getDemandDataExtractors = function (options) {
        var _this = this;
        return (0, exports.DemandDataImportApiFp)(this.configuration).getDemandDataExtractors(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get demand data import lines
     * @summary Get demand data import lines
     * @param {DemandDataImportApiGetDemandDataImportLinesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandDataImportApi
     */
    DemandDataImportApi.prototype.getDemandDataImportLines = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DemandDataImportApiFp)(this.configuration).getDemandDataImportLines(requestParameters.limit, requestParameters.id, requestParameters.importId, requestParameters.status, requestParameters.offset, requestParameters.sortBy, requestParameters.order, requestParameters.lineNumbers, requestParameters.duplicateExternalDemandEventIds, requestParameters.newExternalDemandEventIds, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get demand data import statuses
     * @summary Get demand data import statuses
     * @param {DemandDataImportApiGetDemandDataImportStatusesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandDataImportApi
     */
    DemandDataImportApi.prototype.getDemandDataImportStatuses = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DemandDataImportApiFp)(this.configuration).getDemandDataImportStatuses(requestParameters.limit, requestParameters.id, requestParameters.importId, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return demand data import summaries based upon request parameters
     * @summary Get demand data import summaries
     * @param {DemandDataImportApiGetDemandDataImportSummariesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandDataImportApi
     */
    DemandDataImportApi.prototype.getDemandDataImportSummaries = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DemandDataImportApiFp)(this.configuration).getDemandDataImportSummaries(requestParameters.limit, requestParameters.id, requestParameters.fileId, requestParameters.configurationId, requestParameters.demandSubAccountId, requestParameters.createdByUuid, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return demand data imports based upon request parameters
     * @summary Get demand data imports
     * @param {DemandDataImportApiGetDemandDataImportsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandDataImportApi
     */
    DemandDataImportApi.prototype.getDemandDataImports = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DemandDataImportApiFp)(this.configuration).getDemandDataImports(requestParameters.limit, requestParameters.id, requestParameters.fileId, requestParameters.configurationId, requestParameters.demandSubAccountId, requestParameters.createdByUuid, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get demand data transformers
     * @summary Get demand data transformers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandDataImportApi
     */
    DemandDataImportApi.prototype.getDemandDataTransformers = function (options) {
        var _this = this;
        return (0, exports.DemandDataImportApiFp)(this.configuration).getDemandDataTransformers(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DemandDataImportApi;
}(base_1.BaseAPI));
exports.DemandDataImportApi = DemandDataImportApi;
/**
 * DemandDataImportConfigurationApi - axios parameter creator
 * @export
 */
var DemandDataImportConfigurationApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create a demand data import configuration
         * @summary Create a demand data import configuration
         * @param {DemandDataImportConfigurationCreateData} [demandDataImportConfigurationCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDemandDataImportConfiguration: function (demandDataImportConfigurationCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([demandDataImportConfigurationCreateData_1], args_1, true), void 0, function (demandDataImportConfigurationCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/demandDataImportConfigurations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(demandDataImportConfigurationCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a demand data import configuration
         * @summary Delete a demand data import configuration
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDemandDataImportConfiguration: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteDemandDataImportConfiguration', 'id', id);
                            localVarPath = "/demandDataImportConfigurations/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Return demand data import configurations based upon request parameters
         * @summary Get demand data import configurations
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id]
         * @param {Array<number>} [demandSubAccountId]
         * @param {boolean} [includeDeleted]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {string} [sortBy] The attribute with which to sort the resources.
         * @param {string} [order] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandDataImportConfigurations: function (limit_1, id_1, demandSubAccountId_1, includeDeleted_1, offset_1, sortBy_1, order_1) {
            var args_1 = [];
            for (var _i = 7; _i < arguments.length; _i++) {
                args_1[_i - 7] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, demandSubAccountId_1, includeDeleted_1, offset_1, sortBy_1, order_1], args_1, true), void 0, function (limit, id, demandSubAccountId, includeDeleted, offset, sortBy, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getDemandDataImportConfigurations', 'limit', limit);
                            localVarPath = "/demandDataImportConfigurations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (demandSubAccountId) {
                                localVarQueryParameter['demandSubAccountId'] = demandSubAccountId;
                            }
                            if (includeDeleted !== undefined) {
                                localVarQueryParameter['includeDeleted'] = includeDeleted;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.DemandDataImportConfigurationApiAxiosParamCreator = DemandDataImportConfigurationApiAxiosParamCreator;
/**
 * DemandDataImportConfigurationApi - functional programming interface
 * @export
 */
var DemandDataImportConfigurationApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DemandDataImportConfigurationApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create a demand data import configuration
         * @summary Create a demand data import configuration
         * @param {DemandDataImportConfigurationCreateData} [demandDataImportConfigurationCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDemandDataImportConfiguration: function (demandDataImportConfigurationCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createDemandDataImportConfiguration(demandDataImportConfigurationCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandDataImportConfigurationApi.createDemandDataImportConfiguration']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete a demand data import configuration
         * @summary Delete a demand data import configuration
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDemandDataImportConfiguration: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteDemandDataImportConfiguration(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandDataImportConfigurationApi.deleteDemandDataImportConfiguration']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Return demand data import configurations based upon request parameters
         * @summary Get demand data import configurations
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id]
         * @param {Array<number>} [demandSubAccountId]
         * @param {boolean} [includeDeleted]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {string} [sortBy] The attribute with which to sort the resources.
         * @param {string} [order] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandDataImportConfigurations: function (limit, id, demandSubAccountId, includeDeleted, offset, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDemandDataImportConfigurations(limit, id, demandSubAccountId, includeDeleted, offset, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandDataImportConfigurationApi.getDemandDataImportConfigurations']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.DemandDataImportConfigurationApiFp = DemandDataImportConfigurationApiFp;
/**
 * DemandDataImportConfigurationApi - factory interface
 * @export
 */
var DemandDataImportConfigurationApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DemandDataImportConfigurationApiFp)(configuration);
    return {
        /**
         * Create a demand data import configuration
         * @summary Create a demand data import configuration
         * @param {DemandDataImportConfigurationApiCreateDemandDataImportConfigurationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDemandDataImportConfiguration: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createDemandDataImportConfiguration(requestParameters.demandDataImportConfigurationCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a demand data import configuration
         * @summary Delete a demand data import configuration
         * @param {DemandDataImportConfigurationApiDeleteDemandDataImportConfigurationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDemandDataImportConfiguration: function (requestParameters, options) {
            return localVarFp.deleteDemandDataImportConfiguration(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return demand data import configurations based upon request parameters
         * @summary Get demand data import configurations
         * @param {DemandDataImportConfigurationApiGetDemandDataImportConfigurationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandDataImportConfigurations: function (requestParameters, options) {
            return localVarFp.getDemandDataImportConfigurations(requestParameters.limit, requestParameters.id, requestParameters.demandSubAccountId, requestParameters.includeDeleted, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DemandDataImportConfigurationApiFactory = DemandDataImportConfigurationApiFactory;
/**
 * DemandDataImportConfigurationApi - object-oriented interface
 * @export
 * @class DemandDataImportConfigurationApi
 * @extends {BaseAPI}
 */
var DemandDataImportConfigurationApi = /** @class */ (function (_super) {
    __extends(DemandDataImportConfigurationApi, _super);
    function DemandDataImportConfigurationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a demand data import configuration
     * @summary Create a demand data import configuration
     * @param {DemandDataImportConfigurationApiCreateDemandDataImportConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandDataImportConfigurationApi
     */
    DemandDataImportConfigurationApi.prototype.createDemandDataImportConfiguration = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DemandDataImportConfigurationApiFp)(this.configuration).createDemandDataImportConfiguration(requestParameters.demandDataImportConfigurationCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a demand data import configuration
     * @summary Delete a demand data import configuration
     * @param {DemandDataImportConfigurationApiDeleteDemandDataImportConfigurationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandDataImportConfigurationApi
     */
    DemandDataImportConfigurationApi.prototype.deleteDemandDataImportConfiguration = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DemandDataImportConfigurationApiFp)(this.configuration).deleteDemandDataImportConfiguration(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return demand data import configurations based upon request parameters
     * @summary Get demand data import configurations
     * @param {DemandDataImportConfigurationApiGetDemandDataImportConfigurationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandDataImportConfigurationApi
     */
    DemandDataImportConfigurationApi.prototype.getDemandDataImportConfigurations = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DemandDataImportConfigurationApiFp)(this.configuration).getDemandDataImportConfigurations(requestParameters.limit, requestParameters.id, requestParameters.demandSubAccountId, requestParameters.includeDeleted, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DemandDataImportConfigurationApi;
}(base_1.BaseAPI));
exports.DemandDataImportConfigurationApi = DemandDataImportConfigurationApi;
/**
 * DemandSubAccountApi - axios parameter creator
 * @export
 */
var DemandSubAccountApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create a demand sub-account based on the request
         * @summary Create a demand sub-account
         * @param {DemandSubAccountCreateData} demandSubAccountCreateData Demand sub-account creation fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDemandSubAccount: function (demandSubAccountCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([demandSubAccountCreateData_1], args_1, true), void 0, function (demandSubAccountCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'demandSubAccountCreateData' is not null or undefined
                            (0, common_1.assertParamExists)('createDemandSubAccount', 'demandSubAccountCreateData', demandSubAccountCreateData);
                            localVarPath = "/demandSubAccounts";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(demandSubAccountCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Soft delete the demand sub-account corresponding to the ID in URL path, if one exists
         * @summary Delete a demand sub-account
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDemandSubAccount: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteDemandSubAccount', 'id', id);
                            localVarPath = "/demandSubAccounts/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get a list of Sub Account Owners filtered by relevant query parameters
         * @summary Get a demand sub-account owner
         * @param {Array<number>} [subAccountOwnerId] comma separated list of sub account owner ids
         * @param {Array<string>} [subAccountOwnerDemandPartnerManager] comma separated list of demand partner manager uuids
         * @param {Array<string>} [subAccountOwnerDemandYieldManager] comma separated list of demand yield manager uuids
         * @param {Array<string>} [subAccountOwnerSupplydPartnerManager] comma separated list of supply partner manager uuids
         * @param {Array<string>} [subAccountOwnerSupplyYieldManager] comma separated list of supply yield manager uuids
         * @param {Array<string>} [subAccountOwnerCreatedBy] comma separated list of uuids
         * @param {Date} [subAccountOwnerCreatedAtMin] earliest bound to look at for creation date
         * @param {Date} [subAccountOwnerCreatedAtMax] latest bound to look at for creation date
         * @param {Array<string>} [subAccountOwnerDeletedBy] comma separated list of uuids
         * @param {Date} [subAccountOwnerDeletedAtMin] earliest bound for deletion date
         * @param {Date} [subAccountOwnerDeletedAtMax] latest time for deletion date
         * @param {boolean} [subAccountOwnerIsDeleted] include deleted Sub Account Owners, true/false
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandSubAccountOwners: function (subAccountOwnerId_1, subAccountOwnerDemandPartnerManager_1, subAccountOwnerDemandYieldManager_1, subAccountOwnerSupplydPartnerManager_1, subAccountOwnerSupplyYieldManager_1, subAccountOwnerCreatedBy_1, subAccountOwnerCreatedAtMin_1, subAccountOwnerCreatedAtMax_1, subAccountOwnerDeletedBy_1, subAccountOwnerDeletedAtMin_1, subAccountOwnerDeletedAtMax_1, subAccountOwnerIsDeleted_1) {
            var args_1 = [];
            for (var _i = 12; _i < arguments.length; _i++) {
                args_1[_i - 12] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([subAccountOwnerId_1, subAccountOwnerDemandPartnerManager_1, subAccountOwnerDemandYieldManager_1, subAccountOwnerSupplydPartnerManager_1, subAccountOwnerSupplyYieldManager_1, subAccountOwnerCreatedBy_1, subAccountOwnerCreatedAtMin_1, subAccountOwnerCreatedAtMax_1, subAccountOwnerDeletedBy_1, subAccountOwnerDeletedAtMin_1, subAccountOwnerDeletedAtMax_1, subAccountOwnerIsDeleted_1], args_1, true), void 0, function (subAccountOwnerId, subAccountOwnerDemandPartnerManager, subAccountOwnerDemandYieldManager, subAccountOwnerSupplydPartnerManager, subAccountOwnerSupplyYieldManager, subAccountOwnerCreatedBy, subAccountOwnerCreatedAtMin, subAccountOwnerCreatedAtMax, subAccountOwnerDeletedBy, subAccountOwnerDeletedAtMin, subAccountOwnerDeletedAtMax, subAccountOwnerIsDeleted, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/demandSubAccounts/owners";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (subAccountOwnerId) {
                                localVarQueryParameter['subAccountOwnerId'] = subAccountOwnerId.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (subAccountOwnerDemandPartnerManager) {
                                localVarQueryParameter['subAccountOwnerDemandPartnerManager'] = subAccountOwnerDemandPartnerManager.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (subAccountOwnerDemandYieldManager) {
                                localVarQueryParameter['subAccountOwnerDemandYieldManager'] = subAccountOwnerDemandYieldManager.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (subAccountOwnerSupplydPartnerManager) {
                                localVarQueryParameter['subAccountOwnerSupplydPartnerManager'] = subAccountOwnerSupplydPartnerManager.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (subAccountOwnerSupplyYieldManager) {
                                localVarQueryParameter['subAccountOwnerSupplyYieldManager'] = subAccountOwnerSupplyYieldManager.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (subAccountOwnerCreatedBy) {
                                localVarQueryParameter['subAccountOwnerCreatedBy'] = subAccountOwnerCreatedBy.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (subAccountOwnerCreatedAtMin !== undefined) {
                                localVarQueryParameter['subAccountOwnerCreatedAtMin'] = (subAccountOwnerCreatedAtMin instanceof Date) ?
                                    subAccountOwnerCreatedAtMin.toISOString() :
                                    subAccountOwnerCreatedAtMin;
                            }
                            if (subAccountOwnerCreatedAtMax !== undefined) {
                                localVarQueryParameter['subAccountOwnerCreatedAtMax'] = (subAccountOwnerCreatedAtMax instanceof Date) ?
                                    subAccountOwnerCreatedAtMax.toISOString() :
                                    subAccountOwnerCreatedAtMax;
                            }
                            if (subAccountOwnerDeletedBy) {
                                localVarQueryParameter['subAccountOwnerDeletedBy'] = subAccountOwnerDeletedBy.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (subAccountOwnerDeletedAtMin !== undefined) {
                                localVarQueryParameter['subAccountOwnerDeletedAtMin'] = (subAccountOwnerDeletedAtMin instanceof Date) ?
                                    subAccountOwnerDeletedAtMin.toISOString() :
                                    subAccountOwnerDeletedAtMin;
                            }
                            if (subAccountOwnerDeletedAtMax !== undefined) {
                                localVarQueryParameter['subAccountOwnerDeletedAtMax'] = (subAccountOwnerDeletedAtMax instanceof Date) ?
                                    subAccountOwnerDeletedAtMax.toISOString() :
                                    subAccountOwnerDeletedAtMax;
                            }
                            if (subAccountOwnerIsDeleted !== undefined) {
                                localVarQueryParameter['subAccountOwnerIsDeleted'] = subAccountOwnerIsDeleted;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get a list of demand sub-accounts filtered by relevant query parameters
         * @summary Get demand sub-accounts
         * @param {number} limit limit results
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<string>} [uuid] A comma separated list of uuids
         * @param {Array<number>} [accountId] A comma separated list of account ids
         * @param {Array<string>} [name] A comma separated list of names
         * @param {Array<string>} [companyUuid] A comma separated list of company uuids
         * @param {Array<string>} [displayName] A comma separated list of sub account display names
         * @param {Array<ProductType>} [productType]
         * @param {Array<string>} [createdBy] comma separated list of uuids
         * @param {Date} [createdAt] creation date of object
         * @param {boolean} [excludeDeleted] ignored deleted items, default true
         * @param {boolean} [includeDeactivated] include deactivated items, default false
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandSubAccounts: function (limit_1, id_1, uuid_1, accountId_1, name_1, companyUuid_1, displayName_1, productType_1, createdBy_1, createdAt_1, excludeDeleted_1, includeDeactivated_1, offset_1, sortBy_1, order_1) {
            var args_1 = [];
            for (var _i = 15; _i < arguments.length; _i++) {
                args_1[_i - 15] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, uuid_1, accountId_1, name_1, companyUuid_1, displayName_1, productType_1, createdBy_1, createdAt_1, excludeDeleted_1, includeDeactivated_1, offset_1, sortBy_1, order_1], args_1, true), void 0, function (limit, id, uuid, accountId, name, companyUuid, displayName, productType, createdBy, createdAt, excludeDeleted, includeDeactivated, offset, sortBy, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getDemandSubAccounts', 'limit', limit);
                            localVarPath = "/demandSubAccounts";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (uuid) {
                                localVarQueryParameter['uuid'] = uuid.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (accountId) {
                                localVarQueryParameter['accountId'] = accountId.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (name) {
                                localVarQueryParameter['name'] = name.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (companyUuid) {
                                localVarQueryParameter['companyUuid'] = companyUuid.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (displayName) {
                                localVarQueryParameter['displayName'] = displayName.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (productType) {
                                localVarQueryParameter['productType'] = productType;
                            }
                            if (createdBy) {
                                localVarQueryParameter['createdBy'] = createdBy.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (createdAt !== undefined) {
                                localVarQueryParameter['createdAt'] = (createdAt instanceof Date) ?
                                    createdAt.toISOString() :
                                    createdAt;
                            }
                            if (excludeDeleted !== undefined) {
                                localVarQueryParameter['excludeDeleted'] = excludeDeleted;
                            }
                            if (includeDeactivated !== undefined) {
                                localVarQueryParameter['includeDeactivated'] = includeDeactivated;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get a list of Demand sub-accounts based off search parameters sent in request body
         * @summary Search for demand sub-accounts
         * @param {DemandSubAccountCriteria} [demandSubAccountCriteria]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDemandSubAccounts: function (demandSubAccountCriteria_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([demandSubAccountCriteria_1], args_1, true), void 0, function (demandSubAccountCriteria, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/demandSubAccounts/search";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(demandSubAccountCriteria, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Updates the fields of a demand sub-account that corresponds to the ID in the URL path, if on exists
         * @summary Update a demand sub-account
         * @param {number} id
         * @param {DemandSubAccountUpdateData} demandSubAccountUpdateData Update fields for demand sub-account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDemandSubAccount: function (id_1, demandSubAccountUpdateData_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, demandSubAccountUpdateData_1], args_1, true), void 0, function (id, demandSubAccountUpdateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('updateDemandSubAccount', 'id', id);
                            // verify required parameter 'demandSubAccountUpdateData' is not null or undefined
                            (0, common_1.assertParamExists)('updateDemandSubAccount', 'demandSubAccountUpdateData', demandSubAccountUpdateData);
                            localVarPath = "/demandSubAccounts/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(demandSubAccountUpdateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.DemandSubAccountApiAxiosParamCreator = DemandSubAccountApiAxiosParamCreator;
/**
 * DemandSubAccountApi - functional programming interface
 * @export
 */
var DemandSubAccountApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DemandSubAccountApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create a demand sub-account based on the request
         * @summary Create a demand sub-account
         * @param {DemandSubAccountCreateData} demandSubAccountCreateData Demand sub-account creation fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDemandSubAccount: function (demandSubAccountCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createDemandSubAccount(demandSubAccountCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandSubAccountApi.createDemandSubAccount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Soft delete the demand sub-account corresponding to the ID in URL path, if one exists
         * @summary Delete a demand sub-account
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDemandSubAccount: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteDemandSubAccount(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandSubAccountApi.deleteDemandSubAccount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get a list of Sub Account Owners filtered by relevant query parameters
         * @summary Get a demand sub-account owner
         * @param {Array<number>} [subAccountOwnerId] comma separated list of sub account owner ids
         * @param {Array<string>} [subAccountOwnerDemandPartnerManager] comma separated list of demand partner manager uuids
         * @param {Array<string>} [subAccountOwnerDemandYieldManager] comma separated list of demand yield manager uuids
         * @param {Array<string>} [subAccountOwnerSupplydPartnerManager] comma separated list of supply partner manager uuids
         * @param {Array<string>} [subAccountOwnerSupplyYieldManager] comma separated list of supply yield manager uuids
         * @param {Array<string>} [subAccountOwnerCreatedBy] comma separated list of uuids
         * @param {Date} [subAccountOwnerCreatedAtMin] earliest bound to look at for creation date
         * @param {Date} [subAccountOwnerCreatedAtMax] latest bound to look at for creation date
         * @param {Array<string>} [subAccountOwnerDeletedBy] comma separated list of uuids
         * @param {Date} [subAccountOwnerDeletedAtMin] earliest bound for deletion date
         * @param {Date} [subAccountOwnerDeletedAtMax] latest time for deletion date
         * @param {boolean} [subAccountOwnerIsDeleted] include deleted Sub Account Owners, true/false
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandSubAccountOwners: function (subAccountOwnerId, subAccountOwnerDemandPartnerManager, subAccountOwnerDemandYieldManager, subAccountOwnerSupplydPartnerManager, subAccountOwnerSupplyYieldManager, subAccountOwnerCreatedBy, subAccountOwnerCreatedAtMin, subAccountOwnerCreatedAtMax, subAccountOwnerDeletedBy, subAccountOwnerDeletedAtMin, subAccountOwnerDeletedAtMax, subAccountOwnerIsDeleted, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDemandSubAccountOwners(subAccountOwnerId, subAccountOwnerDemandPartnerManager, subAccountOwnerDemandYieldManager, subAccountOwnerSupplydPartnerManager, subAccountOwnerSupplyYieldManager, subAccountOwnerCreatedBy, subAccountOwnerCreatedAtMin, subAccountOwnerCreatedAtMax, subAccountOwnerDeletedBy, subAccountOwnerDeletedAtMin, subAccountOwnerDeletedAtMax, subAccountOwnerIsDeleted, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandSubAccountApi.getDemandSubAccountOwners']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get a list of demand sub-accounts filtered by relevant query parameters
         * @summary Get demand sub-accounts
         * @param {number} limit limit results
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<string>} [uuid] A comma separated list of uuids
         * @param {Array<number>} [accountId] A comma separated list of account ids
         * @param {Array<string>} [name] A comma separated list of names
         * @param {Array<string>} [companyUuid] A comma separated list of company uuids
         * @param {Array<string>} [displayName] A comma separated list of sub account display names
         * @param {Array<ProductType>} [productType]
         * @param {Array<string>} [createdBy] comma separated list of uuids
         * @param {Date} [createdAt] creation date of object
         * @param {boolean} [excludeDeleted] ignored deleted items, default true
         * @param {boolean} [includeDeactivated] include deactivated items, default false
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandSubAccounts: function (limit, id, uuid, accountId, name, companyUuid, displayName, productType, createdBy, createdAt, excludeDeleted, includeDeactivated, offset, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDemandSubAccounts(limit, id, uuid, accountId, name, companyUuid, displayName, productType, createdBy, createdAt, excludeDeleted, includeDeactivated, offset, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandSubAccountApi.getDemandSubAccounts']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get a list of Demand sub-accounts based off search parameters sent in request body
         * @summary Search for demand sub-accounts
         * @param {DemandSubAccountCriteria} [demandSubAccountCriteria]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDemandSubAccounts: function (demandSubAccountCriteria, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.searchDemandSubAccounts(demandSubAccountCriteria, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandSubAccountApi.searchDemandSubAccounts']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Updates the fields of a demand sub-account that corresponds to the ID in the URL path, if on exists
         * @summary Update a demand sub-account
         * @param {number} id
         * @param {DemandSubAccountUpdateData} demandSubAccountUpdateData Update fields for demand sub-account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDemandSubAccount: function (id, demandSubAccountUpdateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateDemandSubAccount(id, demandSubAccountUpdateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandSubAccountApi.updateDemandSubAccount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.DemandSubAccountApiFp = DemandSubAccountApiFp;
/**
 * DemandSubAccountApi - factory interface
 * @export
 */
var DemandSubAccountApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DemandSubAccountApiFp)(configuration);
    return {
        /**
         * Create a demand sub-account based on the request
         * @summary Create a demand sub-account
         * @param {DemandSubAccountApiCreateDemandSubAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDemandSubAccount: function (requestParameters, options) {
            return localVarFp.createDemandSubAccount(requestParameters.demandSubAccountCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Soft delete the demand sub-account corresponding to the ID in URL path, if one exists
         * @summary Delete a demand sub-account
         * @param {DemandSubAccountApiDeleteDemandSubAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDemandSubAccount: function (requestParameters, options) {
            return localVarFp.deleteDemandSubAccount(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a list of Sub Account Owners filtered by relevant query parameters
         * @summary Get a demand sub-account owner
         * @param {DemandSubAccountApiGetDemandSubAccountOwnersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandSubAccountOwners: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.getDemandSubAccountOwners(requestParameters.subAccountOwnerId, requestParameters.subAccountOwnerDemandPartnerManager, requestParameters.subAccountOwnerDemandYieldManager, requestParameters.subAccountOwnerSupplydPartnerManager, requestParameters.subAccountOwnerSupplyYieldManager, requestParameters.subAccountOwnerCreatedBy, requestParameters.subAccountOwnerCreatedAtMin, requestParameters.subAccountOwnerCreatedAtMax, requestParameters.subAccountOwnerDeletedBy, requestParameters.subAccountOwnerDeletedAtMin, requestParameters.subAccountOwnerDeletedAtMax, requestParameters.subAccountOwnerIsDeleted, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a list of demand sub-accounts filtered by relevant query parameters
         * @summary Get demand sub-accounts
         * @param {DemandSubAccountApiGetDemandSubAccountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandSubAccounts: function (requestParameters, options) {
            return localVarFp.getDemandSubAccounts(requestParameters.limit, requestParameters.id, requestParameters.uuid, requestParameters.accountId, requestParameters.name, requestParameters.companyUuid, requestParameters.displayName, requestParameters.productType, requestParameters.createdBy, requestParameters.createdAt, requestParameters.excludeDeleted, requestParameters.includeDeactivated, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a list of Demand sub-accounts based off search parameters sent in request body
         * @summary Search for demand sub-accounts
         * @param {DemandSubAccountApiSearchDemandSubAccountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchDemandSubAccounts: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.searchDemandSubAccounts(requestParameters.demandSubAccountCriteria, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates the fields of a demand sub-account that corresponds to the ID in the URL path, if on exists
         * @summary Update a demand sub-account
         * @param {DemandSubAccountApiUpdateDemandSubAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDemandSubAccount: function (requestParameters, options) {
            return localVarFp.updateDemandSubAccount(requestParameters.id, requestParameters.demandSubAccountUpdateData, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DemandSubAccountApiFactory = DemandSubAccountApiFactory;
/**
 * DemandSubAccountApi - object-oriented interface
 * @export
 * @class DemandSubAccountApi
 * @extends {BaseAPI}
 */
var DemandSubAccountApi = /** @class */ (function (_super) {
    __extends(DemandSubAccountApi, _super);
    function DemandSubAccountApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a demand sub-account based on the request
     * @summary Create a demand sub-account
     * @param {DemandSubAccountApiCreateDemandSubAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandSubAccountApi
     */
    DemandSubAccountApi.prototype.createDemandSubAccount = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DemandSubAccountApiFp)(this.configuration).createDemandSubAccount(requestParameters.demandSubAccountCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Soft delete the demand sub-account corresponding to the ID in URL path, if one exists
     * @summary Delete a demand sub-account
     * @param {DemandSubAccountApiDeleteDemandSubAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandSubAccountApi
     */
    DemandSubAccountApi.prototype.deleteDemandSubAccount = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DemandSubAccountApiFp)(this.configuration).deleteDemandSubAccount(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a list of Sub Account Owners filtered by relevant query parameters
     * @summary Get a demand sub-account owner
     * @param {DemandSubAccountApiGetDemandSubAccountOwnersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandSubAccountApi
     */
    DemandSubAccountApi.prototype.getDemandSubAccountOwners = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DemandSubAccountApiFp)(this.configuration).getDemandSubAccountOwners(requestParameters.subAccountOwnerId, requestParameters.subAccountOwnerDemandPartnerManager, requestParameters.subAccountOwnerDemandYieldManager, requestParameters.subAccountOwnerSupplydPartnerManager, requestParameters.subAccountOwnerSupplyYieldManager, requestParameters.subAccountOwnerCreatedBy, requestParameters.subAccountOwnerCreatedAtMin, requestParameters.subAccountOwnerCreatedAtMax, requestParameters.subAccountOwnerDeletedBy, requestParameters.subAccountOwnerDeletedAtMin, requestParameters.subAccountOwnerDeletedAtMax, requestParameters.subAccountOwnerIsDeleted, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a list of demand sub-accounts filtered by relevant query parameters
     * @summary Get demand sub-accounts
     * @param {DemandSubAccountApiGetDemandSubAccountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandSubAccountApi
     */
    DemandSubAccountApi.prototype.getDemandSubAccounts = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DemandSubAccountApiFp)(this.configuration).getDemandSubAccounts(requestParameters.limit, requestParameters.id, requestParameters.uuid, requestParameters.accountId, requestParameters.name, requestParameters.companyUuid, requestParameters.displayName, requestParameters.productType, requestParameters.createdBy, requestParameters.createdAt, requestParameters.excludeDeleted, requestParameters.includeDeactivated, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a list of Demand sub-accounts based off search parameters sent in request body
     * @summary Search for demand sub-accounts
     * @param {DemandSubAccountApiSearchDemandSubAccountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandSubAccountApi
     */
    DemandSubAccountApi.prototype.searchDemandSubAccounts = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DemandSubAccountApiFp)(this.configuration).searchDemandSubAccounts(requestParameters.demandSubAccountCriteria, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates the fields of a demand sub-account that corresponds to the ID in the URL path, if on exists
     * @summary Update a demand sub-account
     * @param {DemandSubAccountApiUpdateDemandSubAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandSubAccountApi
     */
    DemandSubAccountApi.prototype.updateDemandSubAccount = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DemandSubAccountApiFp)(this.configuration).updateDemandSubAccount(requestParameters.id, requestParameters.demandSubAccountUpdateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DemandSubAccountApi;
}(base_1.BaseAPI));
exports.DemandSubAccountApi = DemandSubAccountApi;
/**
 * DemandSubAccountDeactivationApi - axios parameter creator
 * @export
 */
var DemandSubAccountDeactivationApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create demand sub-account deactivations
         * @summary Create demand sub-account deactivations
         * @param {DemandSubAccountDeactivationCreateData} [demandSubAccountDeactivationCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDemandSubAccountDeactivation: function (demandSubAccountDeactivationCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([demandSubAccountDeactivationCreateData_1], args_1, true), void 0, function (demandSubAccountDeactivationCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/demandSubAccountDeactivations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(demandSubAccountDeactivationCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a demand sub-account deactivation
         * @summary Delete a demand sub-account deactivation
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDemandSubAccountDeactivation: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteDemandSubAccountDeactivation', 'id', id);
                            localVarPath = "/demandSubAccountDeactivations/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Return demand sub-account deactivations based upon request parameters
         * @summary Get demand sub-account deactivations
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id]
         * @param {Array<number>} [demandSubAccountId]
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {Array<string>} [createdBy]
         * @param {Date} [deletedAtMin]
         * @param {Date} [deletedAtMax]
         * @param {boolean} [isDeleted]
         * @param {Array<string>} [deletedBy]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {string} [sortBy] The attribute with which to sort the resources.
         * @param {string} [order] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandSubAccountDeactivations: function (limit_1, id_1, demandSubAccountId_1, createdAtMin_1, createdAtMax_1, createdBy_1, deletedAtMin_1, deletedAtMax_1, isDeleted_1, deletedBy_1, offset_1, sortBy_1, order_1) {
            var args_1 = [];
            for (var _i = 13; _i < arguments.length; _i++) {
                args_1[_i - 13] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, demandSubAccountId_1, createdAtMin_1, createdAtMax_1, createdBy_1, deletedAtMin_1, deletedAtMax_1, isDeleted_1, deletedBy_1, offset_1, sortBy_1, order_1], args_1, true), void 0, function (limit, id, demandSubAccountId, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, deletedBy, offset, sortBy, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getDemandSubAccountDeactivations', 'limit', limit);
                            localVarPath = "/demandSubAccountDeactivations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (demandSubAccountId) {
                                localVarQueryParameter['demandSubAccountId'] = demandSubAccountId;
                            }
                            if (createdAtMin !== undefined) {
                                localVarQueryParameter['createdAtMin'] = (createdAtMin instanceof Date) ?
                                    createdAtMin.toISOString() :
                                    createdAtMin;
                            }
                            if (createdAtMax !== undefined) {
                                localVarQueryParameter['createdAtMax'] = (createdAtMax instanceof Date) ?
                                    createdAtMax.toISOString() :
                                    createdAtMax;
                            }
                            if (createdBy) {
                                localVarQueryParameter['createdBy'] = createdBy;
                            }
                            if (deletedAtMin !== undefined) {
                                localVarQueryParameter['deletedAtMin'] = (deletedAtMin instanceof Date) ?
                                    deletedAtMin.toISOString() :
                                    deletedAtMin;
                            }
                            if (deletedAtMax !== undefined) {
                                localVarQueryParameter['deletedAtMax'] = (deletedAtMax instanceof Date) ?
                                    deletedAtMax.toISOString() :
                                    deletedAtMax;
                            }
                            if (isDeleted !== undefined) {
                                localVarQueryParameter['isDeleted'] = isDeleted;
                            }
                            if (deletedBy) {
                                localVarQueryParameter['deletedBy'] = deletedBy;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.DemandSubAccountDeactivationApiAxiosParamCreator = DemandSubAccountDeactivationApiAxiosParamCreator;
/**
 * DemandSubAccountDeactivationApi - functional programming interface
 * @export
 */
var DemandSubAccountDeactivationApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DemandSubAccountDeactivationApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create demand sub-account deactivations
         * @summary Create demand sub-account deactivations
         * @param {DemandSubAccountDeactivationCreateData} [demandSubAccountDeactivationCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDemandSubAccountDeactivation: function (demandSubAccountDeactivationCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createDemandSubAccountDeactivation(demandSubAccountDeactivationCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandSubAccountDeactivationApi.createDemandSubAccountDeactivation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete a demand sub-account deactivation
         * @summary Delete a demand sub-account deactivation
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDemandSubAccountDeactivation: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteDemandSubAccountDeactivation(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandSubAccountDeactivationApi.deleteDemandSubAccountDeactivation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Return demand sub-account deactivations based upon request parameters
         * @summary Get demand sub-account deactivations
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id]
         * @param {Array<number>} [demandSubAccountId]
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {Array<string>} [createdBy]
         * @param {Date} [deletedAtMin]
         * @param {Date} [deletedAtMax]
         * @param {boolean} [isDeleted]
         * @param {Array<string>} [deletedBy]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {string} [sortBy] The attribute with which to sort the resources.
         * @param {string} [order] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandSubAccountDeactivations: function (limit, id, demandSubAccountId, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, deletedBy, offset, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDemandSubAccountDeactivations(limit, id, demandSubAccountId, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, deletedBy, offset, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandSubAccountDeactivationApi.getDemandSubAccountDeactivations']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.DemandSubAccountDeactivationApiFp = DemandSubAccountDeactivationApiFp;
/**
 * DemandSubAccountDeactivationApi - factory interface
 * @export
 */
var DemandSubAccountDeactivationApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DemandSubAccountDeactivationApiFp)(configuration);
    return {
        /**
         * Create demand sub-account deactivations
         * @summary Create demand sub-account deactivations
         * @param {DemandSubAccountDeactivationApiCreateDemandSubAccountDeactivationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDemandSubAccountDeactivation: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createDemandSubAccountDeactivation(requestParameters.demandSubAccountDeactivationCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a demand sub-account deactivation
         * @summary Delete a demand sub-account deactivation
         * @param {DemandSubAccountDeactivationApiDeleteDemandSubAccountDeactivationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDemandSubAccountDeactivation: function (requestParameters, options) {
            return localVarFp.deleteDemandSubAccountDeactivation(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return demand sub-account deactivations based upon request parameters
         * @summary Get demand sub-account deactivations
         * @param {DemandSubAccountDeactivationApiGetDemandSubAccountDeactivationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDemandSubAccountDeactivations: function (requestParameters, options) {
            return localVarFp.getDemandSubAccountDeactivations(requestParameters.limit, requestParameters.id, requestParameters.demandSubAccountId, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.isDeleted, requestParameters.deletedBy, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DemandSubAccountDeactivationApiFactory = DemandSubAccountDeactivationApiFactory;
/**
 * DemandSubAccountDeactivationApi - object-oriented interface
 * @export
 * @class DemandSubAccountDeactivationApi
 * @extends {BaseAPI}
 */
var DemandSubAccountDeactivationApi = /** @class */ (function (_super) {
    __extends(DemandSubAccountDeactivationApi, _super);
    function DemandSubAccountDeactivationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create demand sub-account deactivations
     * @summary Create demand sub-account deactivations
     * @param {DemandSubAccountDeactivationApiCreateDemandSubAccountDeactivationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandSubAccountDeactivationApi
     */
    DemandSubAccountDeactivationApi.prototype.createDemandSubAccountDeactivation = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DemandSubAccountDeactivationApiFp)(this.configuration).createDemandSubAccountDeactivation(requestParameters.demandSubAccountDeactivationCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a demand sub-account deactivation
     * @summary Delete a demand sub-account deactivation
     * @param {DemandSubAccountDeactivationApiDeleteDemandSubAccountDeactivationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandSubAccountDeactivationApi
     */
    DemandSubAccountDeactivationApi.prototype.deleteDemandSubAccountDeactivation = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DemandSubAccountDeactivationApiFp)(this.configuration).deleteDemandSubAccountDeactivation(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return demand sub-account deactivations based upon request parameters
     * @summary Get demand sub-account deactivations
     * @param {DemandSubAccountDeactivationApiGetDemandSubAccountDeactivationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandSubAccountDeactivationApi
     */
    DemandSubAccountDeactivationApi.prototype.getDemandSubAccountDeactivations = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DemandSubAccountDeactivationApiFp)(this.configuration).getDemandSubAccountDeactivations(requestParameters.limit, requestParameters.id, requestParameters.demandSubAccountId, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.isDeleted, requestParameters.deletedBy, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DemandSubAccountDeactivationApi;
}(base_1.BaseAPI));
exports.DemandSubAccountDeactivationApi = DemandSubAccountDeactivationApi;
/**
 * DemandSubAccountOwnerApi - axios parameter creator
 * @export
 */
var DemandSubAccountOwnerApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Delete a demand sub account owner
         * @summary Delete a demand sub account owner
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDemandSubAccountOwner: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteDemandSubAccountOwner', 'id', id);
                            localVarPath = "/demandSubAccounts/owners/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.DemandSubAccountOwnerApiAxiosParamCreator = DemandSubAccountOwnerApiAxiosParamCreator;
/**
 * DemandSubAccountOwnerApi - functional programming interface
 * @export
 */
var DemandSubAccountOwnerApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DemandSubAccountOwnerApiAxiosParamCreator)(configuration);
    return {
        /**
         * Delete a demand sub account owner
         * @summary Delete a demand sub account owner
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDemandSubAccountOwner: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteDemandSubAccountOwner(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['DemandSubAccountOwnerApi.deleteDemandSubAccountOwner']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.DemandSubAccountOwnerApiFp = DemandSubAccountOwnerApiFp;
/**
 * DemandSubAccountOwnerApi - factory interface
 * @export
 */
var DemandSubAccountOwnerApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DemandSubAccountOwnerApiFp)(configuration);
    return {
        /**
         * Delete a demand sub account owner
         * @summary Delete a demand sub account owner
         * @param {DemandSubAccountOwnerApiDeleteDemandSubAccountOwnerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDemandSubAccountOwner: function (requestParameters, options) {
            return localVarFp.deleteDemandSubAccountOwner(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DemandSubAccountOwnerApiFactory = DemandSubAccountOwnerApiFactory;
/**
 * DemandSubAccountOwnerApi - object-oriented interface
 * @export
 * @class DemandSubAccountOwnerApi
 * @extends {BaseAPI}
 */
var DemandSubAccountOwnerApi = /** @class */ (function (_super) {
    __extends(DemandSubAccountOwnerApi, _super);
    function DemandSubAccountOwnerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Delete a demand sub account owner
     * @summary Delete a demand sub account owner
     * @param {DemandSubAccountOwnerApiDeleteDemandSubAccountOwnerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DemandSubAccountOwnerApi
     */
    DemandSubAccountOwnerApi.prototype.deleteDemandSubAccountOwner = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DemandSubAccountOwnerApiFp)(this.configuration).deleteDemandSubAccountOwner(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DemandSubAccountOwnerApi;
}(base_1.BaseAPI));
exports.DemandSubAccountOwnerApi = DemandSubAccountOwnerApi;
/**
 * ExpectedEarningsShareApi - axios parameter creator
 * @export
 */
var ExpectedEarningsShareApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create an expected earnings share
         * @summary Create an expected earnings share
         * @param {ExpectedEarningsShareCreateData} [expectedEarningsShareCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExpectedEarningsShare: function (expectedEarningsShareCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([expectedEarningsShareCreateData_1], args_1, true), void 0, function (expectedEarningsShareCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/expectedEarningsShare";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(expectedEarningsShareCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create an expected earnings share override
         * @summary Create an expected earnings share override
         * @param {ExpectedEarningsShareOverrideCreateData} [expectedEarningsShareOverrideCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExpectedEarningsShareOverride: function (expectedEarningsShareOverrideCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([expectedEarningsShareOverrideCreateData_1], args_1, true), void 0, function (expectedEarningsShareOverrideCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/expectedEarningsShareOverrides";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(expectedEarningsShareOverrideCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get active expected earnings share overrides
         * @summary Get active expected earnings share overrides
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveExpectedEarningsShareOverrides: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/expectedEarningsShareOverrides/active";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Return the a list of active expected earnings shares
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveExpectedEarningsShares: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/expectedEarningsShare/active";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Return default expected earnings shares
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultExpectedEarningsShares: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/expectedEarningsShare/default";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get an expected earnings share override
         * @summary Get an expected earnings share override
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpectedEarningsShareOverride: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('getExpectedEarningsShareOverride', 'id', id);
                            localVarPath = "/expectedEarningsShareOverrides/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get expected earnings share overrides
         * @summary Get expected earnings share overrides
         * @param {Array<number>} [ids]
         * @param {Array<string>} [uuids]
         * @param {Array<number>} [supplySubAccountIds]
         * @param {Array<number>} [demandSubAccountIds]
         * @param {boolean} [includeDeleted]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpectedEarningsShareOverrides: function (ids_1, uuids_1, supplySubAccountIds_1, demandSubAccountIds_1, includeDeleted_1) {
            var args_1 = [];
            for (var _i = 5; _i < arguments.length; _i++) {
                args_1[_i - 5] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([ids_1, uuids_1, supplySubAccountIds_1, demandSubAccountIds_1, includeDeleted_1], args_1, true), void 0, function (ids, uuids, supplySubAccountIds, demandSubAccountIds, includeDeleted, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/expectedEarningsShareOverrides";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (ids) {
                                localVarQueryParameter['ids'] = ids;
                            }
                            if (uuids) {
                                localVarQueryParameter['uuids'] = uuids;
                            }
                            if (supplySubAccountIds) {
                                localVarQueryParameter['supplySubAccountIds'] = supplySubAccountIds;
                            }
                            if (demandSubAccountIds) {
                                localVarQueryParameter['demandSubAccountIds'] = demandSubAccountIds;
                            }
                            if (includeDeleted !== undefined) {
                                localVarQueryParameter['includeDeleted'] = includeDeleted;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get expected earnings shares
         * @summary Get expected earnings shares
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<string>} [company]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpectedEarningsShares: function (limit_1, company_1, offset_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, company_1, offset_1], args_1, true), void 0, function (limit, company, offset, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getExpectedEarningsShares', 'limit', limit);
                            localVarPath = "/expectedEarningsShare";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (company) {
                                localVarQueryParameter['company'] = company;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Return historical of expected earnings shares
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<Date>} [from] starting time to look at
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpectedEarningsSharesHistory: function (limit_1, from_1, offset_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, from_1, offset_1], args_1, true), void 0, function (limit, from, offset, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getExpectedEarningsSharesHistory', 'limit', limit);
                            localVarPath = "/expectedEarningsShare/history";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (from) {
                                localVarQueryParameter['from'] = from.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ExpectedEarningsShareApiAxiosParamCreator = ExpectedEarningsShareApiAxiosParamCreator;
/**
 * ExpectedEarningsShareApi - functional programming interface
 * @export
 */
var ExpectedEarningsShareApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ExpectedEarningsShareApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create an expected earnings share
         * @summary Create an expected earnings share
         * @param {ExpectedEarningsShareCreateData} [expectedEarningsShareCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExpectedEarningsShare: function (expectedEarningsShareCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createExpectedEarningsShare(expectedEarningsShareCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ExpectedEarningsShareApi.createExpectedEarningsShare']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Create an expected earnings share override
         * @summary Create an expected earnings share override
         * @param {ExpectedEarningsShareOverrideCreateData} [expectedEarningsShareOverrideCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExpectedEarningsShareOverride: function (expectedEarningsShareOverrideCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createExpectedEarningsShareOverride(expectedEarningsShareOverrideCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ExpectedEarningsShareApi.createExpectedEarningsShareOverride']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get active expected earnings share overrides
         * @summary Get active expected earnings share overrides
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveExpectedEarningsShareOverrides: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getActiveExpectedEarningsShareOverrides(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ExpectedEarningsShareApi.getActiveExpectedEarningsShareOverrides']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Return the a list of active expected earnings shares
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveExpectedEarningsShares: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getActiveExpectedEarningsShares(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ExpectedEarningsShareApi.getActiveExpectedEarningsShares']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Return default expected earnings shares
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultExpectedEarningsShares: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDefaultExpectedEarningsShares(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ExpectedEarningsShareApi.getDefaultExpectedEarningsShares']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get an expected earnings share override
         * @summary Get an expected earnings share override
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpectedEarningsShareOverride: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getExpectedEarningsShareOverride(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ExpectedEarningsShareApi.getExpectedEarningsShareOverride']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get expected earnings share overrides
         * @summary Get expected earnings share overrides
         * @param {Array<number>} [ids]
         * @param {Array<string>} [uuids]
         * @param {Array<number>} [supplySubAccountIds]
         * @param {Array<number>} [demandSubAccountIds]
         * @param {boolean} [includeDeleted]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpectedEarningsShareOverrides: function (ids, uuids, supplySubAccountIds, demandSubAccountIds, includeDeleted, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getExpectedEarningsShareOverrides(ids, uuids, supplySubAccountIds, demandSubAccountIds, includeDeleted, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ExpectedEarningsShareApi.getExpectedEarningsShareOverrides']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get expected earnings shares
         * @summary Get expected earnings shares
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<string>} [company]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpectedEarningsShares: function (limit, company, offset, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getExpectedEarningsShares(limit, company, offset, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ExpectedEarningsShareApi.getExpectedEarningsShares']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Return historical of expected earnings shares
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<Date>} [from] starting time to look at
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpectedEarningsSharesHistory: function (limit, from, offset, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getExpectedEarningsSharesHistory(limit, from, offset, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ExpectedEarningsShareApi.getExpectedEarningsSharesHistory']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.ExpectedEarningsShareApiFp = ExpectedEarningsShareApiFp;
/**
 * ExpectedEarningsShareApi - factory interface
 * @export
 */
var ExpectedEarningsShareApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ExpectedEarningsShareApiFp)(configuration);
    return {
        /**
         * Create an expected earnings share
         * @summary Create an expected earnings share
         * @param {ExpectedEarningsShareApiCreateExpectedEarningsShareRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExpectedEarningsShare: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createExpectedEarningsShare(requestParameters.expectedEarningsShareCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create an expected earnings share override
         * @summary Create an expected earnings share override
         * @param {ExpectedEarningsShareApiCreateExpectedEarningsShareOverrideRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExpectedEarningsShareOverride: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createExpectedEarningsShareOverride(requestParameters.expectedEarningsShareOverrideCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get active expected earnings share overrides
         * @summary Get active expected earnings share overrides
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveExpectedEarningsShareOverrides: function (options) {
            return localVarFp.getActiveExpectedEarningsShareOverrides(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Return the a list of active expected earnings shares
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveExpectedEarningsShares: function (options) {
            return localVarFp.getActiveExpectedEarningsShares(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Return default expected earnings shares
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultExpectedEarningsShares: function (options) {
            return localVarFp.getDefaultExpectedEarningsShares(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get an expected earnings share override
         * @summary Get an expected earnings share override
         * @param {ExpectedEarningsShareApiGetExpectedEarningsShareOverrideRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpectedEarningsShareOverride: function (requestParameters, options) {
            return localVarFp.getExpectedEarningsShareOverride(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get expected earnings share overrides
         * @summary Get expected earnings share overrides
         * @param {ExpectedEarningsShareApiGetExpectedEarningsShareOverridesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpectedEarningsShareOverrides: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.getExpectedEarningsShareOverrides(requestParameters.ids, requestParameters.uuids, requestParameters.supplySubAccountIds, requestParameters.demandSubAccountIds, requestParameters.includeDeleted, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get expected earnings shares
         * @summary Get expected earnings shares
         * @param {ExpectedEarningsShareApiGetExpectedEarningsSharesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpectedEarningsShares: function (requestParameters, options) {
            return localVarFp.getExpectedEarningsShares(requestParameters.limit, requestParameters.company, requestParameters.offset, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Return historical of expected earnings shares
         * @param {ExpectedEarningsShareApiGetExpectedEarningsSharesHistoryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExpectedEarningsSharesHistory: function (requestParameters, options) {
            return localVarFp.getExpectedEarningsSharesHistory(requestParameters.limit, requestParameters.from, requestParameters.offset, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ExpectedEarningsShareApiFactory = ExpectedEarningsShareApiFactory;
/**
 * ExpectedEarningsShareApi - object-oriented interface
 * @export
 * @class ExpectedEarningsShareApi
 * @extends {BaseAPI}
 */
var ExpectedEarningsShareApi = /** @class */ (function (_super) {
    __extends(ExpectedEarningsShareApi, _super);
    function ExpectedEarningsShareApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create an expected earnings share
     * @summary Create an expected earnings share
     * @param {ExpectedEarningsShareApiCreateExpectedEarningsShareRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpectedEarningsShareApi
     */
    ExpectedEarningsShareApi.prototype.createExpectedEarningsShare = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ExpectedEarningsShareApiFp)(this.configuration).createExpectedEarningsShare(requestParameters.expectedEarningsShareCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create an expected earnings share override
     * @summary Create an expected earnings share override
     * @param {ExpectedEarningsShareApiCreateExpectedEarningsShareOverrideRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpectedEarningsShareApi
     */
    ExpectedEarningsShareApi.prototype.createExpectedEarningsShareOverride = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ExpectedEarningsShareApiFp)(this.configuration).createExpectedEarningsShareOverride(requestParameters.expectedEarningsShareOverrideCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get active expected earnings share overrides
     * @summary Get active expected earnings share overrides
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpectedEarningsShareApi
     */
    ExpectedEarningsShareApi.prototype.getActiveExpectedEarningsShareOverrides = function (options) {
        var _this = this;
        return (0, exports.ExpectedEarningsShareApiFp)(this.configuration).getActiveExpectedEarningsShareOverrides(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Return the a list of active expected earnings shares
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpectedEarningsShareApi
     */
    ExpectedEarningsShareApi.prototype.getActiveExpectedEarningsShares = function (options) {
        var _this = this;
        return (0, exports.ExpectedEarningsShareApiFp)(this.configuration).getActiveExpectedEarningsShares(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Return default expected earnings shares
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpectedEarningsShareApi
     */
    ExpectedEarningsShareApi.prototype.getDefaultExpectedEarningsShares = function (options) {
        var _this = this;
        return (0, exports.ExpectedEarningsShareApiFp)(this.configuration).getDefaultExpectedEarningsShares(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get an expected earnings share override
     * @summary Get an expected earnings share override
     * @param {ExpectedEarningsShareApiGetExpectedEarningsShareOverrideRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpectedEarningsShareApi
     */
    ExpectedEarningsShareApi.prototype.getExpectedEarningsShareOverride = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ExpectedEarningsShareApiFp)(this.configuration).getExpectedEarningsShareOverride(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get expected earnings share overrides
     * @summary Get expected earnings share overrides
     * @param {ExpectedEarningsShareApiGetExpectedEarningsShareOverridesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpectedEarningsShareApi
     */
    ExpectedEarningsShareApi.prototype.getExpectedEarningsShareOverrides = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ExpectedEarningsShareApiFp)(this.configuration).getExpectedEarningsShareOverrides(requestParameters.ids, requestParameters.uuids, requestParameters.supplySubAccountIds, requestParameters.demandSubAccountIds, requestParameters.includeDeleted, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get expected earnings shares
     * @summary Get expected earnings shares
     * @param {ExpectedEarningsShareApiGetExpectedEarningsSharesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpectedEarningsShareApi
     */
    ExpectedEarningsShareApi.prototype.getExpectedEarningsShares = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ExpectedEarningsShareApiFp)(this.configuration).getExpectedEarningsShares(requestParameters.limit, requestParameters.company, requestParameters.offset, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Return historical of expected earnings shares
     * @param {ExpectedEarningsShareApiGetExpectedEarningsSharesHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExpectedEarningsShareApi
     */
    ExpectedEarningsShareApi.prototype.getExpectedEarningsSharesHistory = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ExpectedEarningsShareApiFp)(this.configuration).getExpectedEarningsSharesHistory(requestParameters.limit, requestParameters.from, requestParameters.offset, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ExpectedEarningsShareApi;
}(base_1.BaseAPI));
exports.ExpectedEarningsShareApi = ExpectedEarningsShareApi;
/**
 * ExternalDemandEventApi - axios parameter creator
 * @export
 */
var ExternalDemandEventApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create external demand event
         * @summary Create external demand event
         * @param {ExternalDemandEventCreateData} externalDemandEventCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExternalDemandEvent: function (externalDemandEventCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([externalDemandEventCreateData_1], args_1, true), void 0, function (externalDemandEventCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'externalDemandEventCreateData' is not null or undefined
                            (0, common_1.assertParamExists)('createExternalDemandEvent', 'externalDemandEventCreateData', externalDemandEventCreateData);
                            localVarPath = "/externalDemandEvents";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(externalDemandEventCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create external demand event for partner Leap Life
         * @summary Create external demand event for partner Leap Life
         * @param {ExternalDemandEventPartnerCreateData} externalDemandEventPartnerCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartnerExternalDemandEvent: function (externalDemandEventPartnerCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([externalDemandEventPartnerCreateData_1], args_1, true), void 0, function (externalDemandEventPartnerCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'externalDemandEventPartnerCreateData' is not null or undefined
                            (0, common_1.assertParamExists)('createPartnerExternalDemandEvent', 'externalDemandEventPartnerCreateData', externalDemandEventPartnerCreateData);
                            localVarPath = "/externalDemandEvents/leapLife";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["external-demand-event:write:restricted"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(externalDemandEventPartnerCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete an external demand event
         * @summary Delete an external demand event
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExternalDemandEvent: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteExternalDemandEvent', 'id', id);
                            localVarPath = "/externalDemandEvents/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get external demand events
         * @summary Get external demand events
         * @param {number} limit limit results
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<string>} [leadUuid]
         * @param {Array<number>} [subAccountId]
         * @param {Array<ExternalDemandEventType>} [eventType]
         * @param {Array<string>} [partnerTrackingId]
         * @param {Array<string>} [createdByUuid]
         * @param {number} [minId]
         * @param {Date} [timestampFrom]
         * @param {Date} [timestampTo]
         * @param {boolean} [includeDeleted]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalDemandEvents: function (limit_1, id_1, leadUuid_1, subAccountId_1, eventType_1, partnerTrackingId_1, createdByUuid_1, minId_1, timestampFrom_1, timestampTo_1, includeDeleted_1, offset_1, sortBy_1, order_1) {
            var args_1 = [];
            for (var _i = 14; _i < arguments.length; _i++) {
                args_1[_i - 14] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, leadUuid_1, subAccountId_1, eventType_1, partnerTrackingId_1, createdByUuid_1, minId_1, timestampFrom_1, timestampTo_1, includeDeleted_1, offset_1, sortBy_1, order_1], args_1, true), void 0, function (limit, id, leadUuid, subAccountId, eventType, partnerTrackingId, createdByUuid, minId, timestampFrom, timestampTo, includeDeleted, offset, sortBy, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getExternalDemandEvents', 'limit', limit);
                            localVarPath = "/externalDemandEvents";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (leadUuid) {
                                localVarQueryParameter['leadUuid'] = leadUuid;
                            }
                            if (subAccountId) {
                                localVarQueryParameter['subAccountId'] = subAccountId;
                            }
                            if (eventType) {
                                localVarQueryParameter['eventType'] = eventType;
                            }
                            if (partnerTrackingId) {
                                localVarQueryParameter['partnerTrackingId'] = partnerTrackingId;
                            }
                            if (createdByUuid) {
                                localVarQueryParameter['createdByUuid'] = createdByUuid;
                            }
                            if (minId !== undefined) {
                                localVarQueryParameter['minId'] = minId;
                            }
                            if (timestampFrom !== undefined) {
                                localVarQueryParameter['timestampFrom'] = (timestampFrom instanceof Date) ?
                                    timestampFrom.toISOString() :
                                    timestampFrom;
                            }
                            if (timestampTo !== undefined) {
                                localVarQueryParameter['timestampTo'] = (timestampTo instanceof Date) ?
                                    timestampTo.toISOString() :
                                    timestampTo;
                            }
                            if (includeDeleted !== undefined) {
                                localVarQueryParameter['includeDeleted'] = includeDeleted;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ExternalDemandEventApiAxiosParamCreator = ExternalDemandEventApiAxiosParamCreator;
/**
 * ExternalDemandEventApi - functional programming interface
 * @export
 */
var ExternalDemandEventApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ExternalDemandEventApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create external demand event
         * @summary Create external demand event
         * @param {ExternalDemandEventCreateData} externalDemandEventCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExternalDemandEvent: function (externalDemandEventCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createExternalDemandEvent(externalDemandEventCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ExternalDemandEventApi.createExternalDemandEvent']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Create external demand event for partner Leap Life
         * @summary Create external demand event for partner Leap Life
         * @param {ExternalDemandEventPartnerCreateData} externalDemandEventPartnerCreateData
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartnerExternalDemandEvent: function (externalDemandEventPartnerCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createPartnerExternalDemandEvent(externalDemandEventPartnerCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ExternalDemandEventApi.createPartnerExternalDemandEvent']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete an external demand event
         * @summary Delete an external demand event
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExternalDemandEvent: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteExternalDemandEvent(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ExternalDemandEventApi.deleteExternalDemandEvent']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get external demand events
         * @summary Get external demand events
         * @param {number} limit limit results
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<string>} [leadUuid]
         * @param {Array<number>} [subAccountId]
         * @param {Array<ExternalDemandEventType>} [eventType]
         * @param {Array<string>} [partnerTrackingId]
         * @param {Array<string>} [createdByUuid]
         * @param {number} [minId]
         * @param {Date} [timestampFrom]
         * @param {Date} [timestampTo]
         * @param {boolean} [includeDeleted]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalDemandEvents: function (limit, id, leadUuid, subAccountId, eventType, partnerTrackingId, createdByUuid, minId, timestampFrom, timestampTo, includeDeleted, offset, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getExternalDemandEvents(limit, id, leadUuid, subAccountId, eventType, partnerTrackingId, createdByUuid, minId, timestampFrom, timestampTo, includeDeleted, offset, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ExternalDemandEventApi.getExternalDemandEvents']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.ExternalDemandEventApiFp = ExternalDemandEventApiFp;
/**
 * ExternalDemandEventApi - factory interface
 * @export
 */
var ExternalDemandEventApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ExternalDemandEventApiFp)(configuration);
    return {
        /**
         * Create external demand event
         * @summary Create external demand event
         * @param {ExternalDemandEventApiCreateExternalDemandEventRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createExternalDemandEvent: function (requestParameters, options) {
            return localVarFp.createExternalDemandEvent(requestParameters.externalDemandEventCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create external demand event for partner Leap Life
         * @summary Create external demand event for partner Leap Life
         * @param {ExternalDemandEventApiCreatePartnerExternalDemandEventRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPartnerExternalDemandEvent: function (requestParameters, options) {
            return localVarFp.createPartnerExternalDemandEvent(requestParameters.externalDemandEventPartnerCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete an external demand event
         * @summary Delete an external demand event
         * @param {ExternalDemandEventApiDeleteExternalDemandEventRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExternalDemandEvent: function (requestParameters, options) {
            return localVarFp.deleteExternalDemandEvent(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get external demand events
         * @summary Get external demand events
         * @param {ExternalDemandEventApiGetExternalDemandEventsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalDemandEvents: function (requestParameters, options) {
            return localVarFp.getExternalDemandEvents(requestParameters.limit, requestParameters.id, requestParameters.leadUuid, requestParameters.subAccountId, requestParameters.eventType, requestParameters.partnerTrackingId, requestParameters.createdByUuid, requestParameters.minId, requestParameters.timestampFrom, requestParameters.timestampTo, requestParameters.includeDeleted, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ExternalDemandEventApiFactory = ExternalDemandEventApiFactory;
/**
 * ExternalDemandEventApi - object-oriented interface
 * @export
 * @class ExternalDemandEventApi
 * @extends {BaseAPI}
 */
var ExternalDemandEventApi = /** @class */ (function (_super) {
    __extends(ExternalDemandEventApi, _super);
    function ExternalDemandEventApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create external demand event
     * @summary Create external demand event
     * @param {ExternalDemandEventApiCreateExternalDemandEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalDemandEventApi
     */
    ExternalDemandEventApi.prototype.createExternalDemandEvent = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ExternalDemandEventApiFp)(this.configuration).createExternalDemandEvent(requestParameters.externalDemandEventCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create external demand event for partner Leap Life
     * @summary Create external demand event for partner Leap Life
     * @param {ExternalDemandEventApiCreatePartnerExternalDemandEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalDemandEventApi
     */
    ExternalDemandEventApi.prototype.createPartnerExternalDemandEvent = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ExternalDemandEventApiFp)(this.configuration).createPartnerExternalDemandEvent(requestParameters.externalDemandEventPartnerCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete an external demand event
     * @summary Delete an external demand event
     * @param {ExternalDemandEventApiDeleteExternalDemandEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalDemandEventApi
     */
    ExternalDemandEventApi.prototype.deleteExternalDemandEvent = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ExternalDemandEventApiFp)(this.configuration).deleteExternalDemandEvent(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get external demand events
     * @summary Get external demand events
     * @param {ExternalDemandEventApiGetExternalDemandEventsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ExternalDemandEventApi
     */
    ExternalDemandEventApi.prototype.getExternalDemandEvents = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ExternalDemandEventApiFp)(this.configuration).getExternalDemandEvents(requestParameters.limit, requestParameters.id, requestParameters.leadUuid, requestParameters.subAccountId, requestParameters.eventType, requestParameters.partnerTrackingId, requestParameters.createdByUuid, requestParameters.minId, requestParameters.timestampFrom, requestParameters.timestampTo, requestParameters.includeDeleted, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ExternalDemandEventApi;
}(base_1.BaseAPI));
exports.ExternalDemandEventApi = ExternalDemandEventApi;
/**
 * LedgerItemApi - axios parameter creator
 * @export
 */
var LedgerItemApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Create ledger item
         * @param {LedgerItemCreateData} [ledgerItemCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLedgerItem: function (ledgerItemCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([ledgerItemCreateData_1], args_1, true), void 0, function (ledgerItemCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/ledgerItems";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(ledgerItemCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Regenerate multiple ledger items
         * @param {LedgerItemRecreationBatchCreateData} [ledgerItemRecreationBatchCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLedgerItemRecreationBatch: function (ledgerItemRecreationBatchCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([ledgerItemRecreationBatchCreateData_1], args_1, true), void 0, function (ledgerItemRecreationBatchCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/ledgerItemRecreationBatches";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(ledgerItemRecreationBatchCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a one off ledger item
         * @param {OneOffLedgerItemCreateData} [oneOffLedgerItemCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneOffLedgerItem: function (oneOffLedgerItemCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([oneOffLedgerItemCreateData_1], args_1, true), void 0, function (oneOffLedgerItemCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/ledgerItems/oneOffs";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(oneOffLedgerItemCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Soft delete the ledger item corresponding to the specified ID in URL path, if one exists
         * @summary Delete a ledger item
         * @param {number} id id of ledger item to find
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLedgerItem: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteLedgerItem', 'id', id);
                            localVarPath = "/ledgerItems/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns the ledger item corresponding to the specified ID in the URL path, if one exists.
         * @summary Get a ledger item
         * @param {number} id id of ledger item to find
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLedgerItem: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('getLedgerItem', 'id', id);
                            localVarPath = "/ledgerItems/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get events for a ledger item
         * @param {number} id id of item to find events for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLedgerItemEvents: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('getLedgerItemEvents', 'id', id);
                            localVarPath = "/ledgerItems/{id}/events"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns a list of ledger item settlements that match the specified criteria.
         * @summary Get ledger item settlements
         * @param {number} limit
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<number>} [ledgerItemIds]
         * @param {Array<number>} [originalLedgerItemIds]
         * @param {Date} [createdAtStart] beginning of range createdAt
         * @param {Date} [createdAtEnd] end of range createdAt
         * @param {Array<string>} [createdBy] comma separated list of uuids
         * @param {Date} [deletedAtStart] beginning of range for deletedAt
         * @param {Date} [deletedAtEnd] end of range for deletedAt
         * @param {Array<string>} [deletedBy] comma separated list of uuids
         * @param {number} [offset] default is 0
         * @param {string} [sortBy] default is created_at
         * @param {Order} [order] default case is asc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLedgerItemSettlements: function (limit_1, id_1, ledgerItemIds_1, originalLedgerItemIds_1, createdAtStart_1, createdAtEnd_1, createdBy_1, deletedAtStart_1, deletedAtEnd_1, deletedBy_1, offset_1, sortBy_1, order_1) {
            var args_1 = [];
            for (var _i = 13; _i < arguments.length; _i++) {
                args_1[_i - 13] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, ledgerItemIds_1, originalLedgerItemIds_1, createdAtStart_1, createdAtEnd_1, createdBy_1, deletedAtStart_1, deletedAtEnd_1, deletedBy_1, offset_1, sortBy_1, order_1], args_1, true), void 0, function (limit, id, ledgerItemIds, originalLedgerItemIds, createdAtStart, createdAtEnd, createdBy, deletedAtStart, deletedAtEnd, deletedBy, offset, sortBy, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getLedgerItemSettlements', 'limit', limit);
                            localVarPath = "/ledgerItemSettlements";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (ledgerItemIds) {
                                localVarQueryParameter['ledgerItemIds'] = ledgerItemIds;
                            }
                            if (originalLedgerItemIds) {
                                localVarQueryParameter['originalLedgerItemIds'] = originalLedgerItemIds;
                            }
                            if (createdAtStart !== undefined) {
                                localVarQueryParameter['createdAtStart'] = (createdAtStart instanceof Date) ?
                                    createdAtStart.toISOString() :
                                    createdAtStart;
                            }
                            if (createdAtEnd !== undefined) {
                                localVarQueryParameter['createdAtEnd'] = (createdAtEnd instanceof Date) ?
                                    createdAtEnd.toISOString() :
                                    createdAtEnd;
                            }
                            if (createdBy) {
                                localVarQueryParameter['createdBy'] = createdBy;
                            }
                            if (deletedAtStart !== undefined) {
                                localVarQueryParameter['deletedAtStart'] = (deletedAtStart instanceof Date) ?
                                    deletedAtStart.toISOString() :
                                    deletedAtStart;
                            }
                            if (deletedAtEnd !== undefined) {
                                localVarQueryParameter['deletedAtEnd'] = (deletedAtEnd instanceof Date) ?
                                    deletedAtEnd.toISOString() :
                                    deletedAtEnd;
                            }
                            if (deletedBy) {
                                localVarQueryParameter['deletedBy'] = deletedBy;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns a list of ledger items that match the specified criteria.
         * @summary Get ledger items
         * @param {number} limit
         * @param {Array<number>} [id] A comma separated list of Ledger Item ids
         * @param {Array<number>} [accountIds] A comma separated list of Account ids
         * @param {string} [startDate] ledger item start date
         * @param {string} [endDate] ledger item end date
         * @param {string} [dueDate]
         * @param {Array<string>} [ledgerItemType] Ledger Item Type, either payable or receivable
         * @param {Array<string>} [reconciliationType] Reconciliation type, either paid or ignored
         * @param {Array<LedgerItemReason>} [reason]
         * @param {Array<number>} [netD] The amount of time allowed between cycle end and payment due
         * @param {Array<string>} [q] Fuzzy search parameter
         * @param {Date} [createdAtStart]
         * @param {Date} [createdAtEnd]
         * @param {Array<string>} [createdBy]
         * @param {Date} [deletedAtStart]
         * @param {Date} [deletedAtEnd]
         * @param {Array<string>} [deletedBy]
         * @param {number} [offset]
         * @param {string} [sortBy]
         * @param {Order} [order]
         * @param {boolean} [excludeDeleted]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLedgerItems: function (limit_1, id_1, accountIds_1, startDate_1, endDate_1, dueDate_1, ledgerItemType_1, reconciliationType_1, reason_1, netD_1, q_1, createdAtStart_1, createdAtEnd_1, createdBy_1, deletedAtStart_1, deletedAtEnd_1, deletedBy_1, offset_1, sortBy_1, order_1, excludeDeleted_1) {
            var args_1 = [];
            for (var _i = 21; _i < arguments.length; _i++) {
                args_1[_i - 21] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, accountIds_1, startDate_1, endDate_1, dueDate_1, ledgerItemType_1, reconciliationType_1, reason_1, netD_1, q_1, createdAtStart_1, createdAtEnd_1, createdBy_1, deletedAtStart_1, deletedAtEnd_1, deletedBy_1, offset_1, sortBy_1, order_1, excludeDeleted_1], args_1, true), void 0, function (limit, id, accountIds, startDate, endDate, dueDate, ledgerItemType, reconciliationType, reason, netD, q, createdAtStart, createdAtEnd, createdBy, deletedAtStart, deletedAtEnd, deletedBy, offset, sortBy, order, excludeDeleted, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getLedgerItems', 'limit', limit);
                            localVarPath = "/ledgerItems";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (accountIds) {
                                localVarQueryParameter['accountIds'] = accountIds;
                            }
                            if (startDate !== undefined) {
                                localVarQueryParameter['startDate'] = (startDate instanceof Date) ?
                                    startDate.toISOString().substring(0, 10) :
                                    startDate;
                            }
                            if (endDate !== undefined) {
                                localVarQueryParameter['endDate'] = (endDate instanceof Date) ?
                                    endDate.toISOString().substring(0, 10) :
                                    endDate;
                            }
                            if (dueDate !== undefined) {
                                localVarQueryParameter['dueDate'] = (dueDate instanceof Date) ?
                                    dueDate.toISOString().substring(0, 10) :
                                    dueDate;
                            }
                            if (ledgerItemType) {
                                localVarQueryParameter['ledgerItemType'] = ledgerItemType;
                            }
                            if (reconciliationType) {
                                localVarQueryParameter['reconciliationType'] = reconciliationType;
                            }
                            if (reason) {
                                localVarQueryParameter['reason'] = reason;
                            }
                            if (netD) {
                                localVarQueryParameter['netD'] = netD;
                            }
                            if (q) {
                                localVarQueryParameter['q'] = q;
                            }
                            if (createdAtStart !== undefined) {
                                localVarQueryParameter['createdAtStart'] = (createdAtStart instanceof Date) ?
                                    createdAtStart.toISOString() :
                                    createdAtStart;
                            }
                            if (createdAtEnd !== undefined) {
                                localVarQueryParameter['createdAtEnd'] = (createdAtEnd instanceof Date) ?
                                    createdAtEnd.toISOString() :
                                    createdAtEnd;
                            }
                            if (createdBy) {
                                localVarQueryParameter['createdBy'] = createdBy;
                            }
                            if (deletedAtStart !== undefined) {
                                localVarQueryParameter['deletedAtStart'] = (deletedAtStart instanceof Date) ?
                                    deletedAtStart.toISOString() :
                                    deletedAtStart;
                            }
                            if (deletedAtEnd !== undefined) {
                                localVarQueryParameter['deletedAtEnd'] = (deletedAtEnd instanceof Date) ?
                                    deletedAtEnd.toISOString() :
                                    deletedAtEnd;
                            }
                            if (deletedBy) {
                                localVarQueryParameter['deletedBy'] = deletedBy;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (excludeDeleted !== undefined) {
                                localVarQueryParameter['excludeDeleted'] = excludeDeleted;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns a list of payable adjustment summaries that match the specified criteria.
         * @summary Get payable adjustment summaries
         * @param {number} limit
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<number>} [accountIds]
         * @param {Array<AdjustmentReason>} [reason]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy]
         * @param {boolean} [isDeleted]
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayableAdjustmentSummaries: function (limit_1, id_1, accountIds_1, reason_1, offset_1, sortBy_1, isDeleted_1, order_1) {
            var args_1 = [];
            for (var _i = 8; _i < arguments.length; _i++) {
                args_1[_i - 8] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, accountIds_1, reason_1, offset_1, sortBy_1, isDeleted_1, order_1], args_1, true), void 0, function (limit, id, accountIds, reason, offset, sortBy, isDeleted, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getPayableAdjustmentSummaries', 'limit', limit);
                            localVarPath = "/payableAdjustmentSummaries";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (accountIds) {
                                localVarQueryParameter['accountIds'] = accountIds;
                            }
                            if (reason) {
                                localVarQueryParameter['reason'] = reason;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (isDeleted !== undefined) {
                                localVarQueryParameter['isDeleted'] = isDeleted;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns a list of payable summaries that match the specified criteria.
         * @summary Get payable summaries
         * @param {number} limit
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<number>} [accountIds]
         * @param {Array<LedgerItemReason>} [reason]
         * @param {Array<ReconciliationType>} [reconciliationType]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy]
         * @param {Order} [order]
         * @param {boolean} [excludeDeleted] ignored deleted items, default true
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayableSummaries: function (limit_1, id_1, accountIds_1, reason_1, reconciliationType_1, offset_1, sortBy_1, order_1, excludeDeleted_1) {
            var args_1 = [];
            for (var _i = 9; _i < arguments.length; _i++) {
                args_1[_i - 9] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, accountIds_1, reason_1, reconciliationType_1, offset_1, sortBy_1, order_1, excludeDeleted_1], args_1, true), void 0, function (limit, id, accountIds, reason, reconciliationType, offset, sortBy, order, excludeDeleted, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getPayableSummaries', 'limit', limit);
                            localVarPath = "/payableSummaries";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (accountIds) {
                                localVarQueryParameter['accountIds'] = accountIds;
                            }
                            if (reason) {
                                localVarQueryParameter['reason'] = reason;
                            }
                            if (reconciliationType) {
                                localVarQueryParameter['reconciliationType'] = reconciliationType;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (excludeDeleted !== undefined) {
                                localVarQueryParameter['excludeDeleted'] = excludeDeleted;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns a list of receivable adjustment summaries that match the specified criteria.
         * @summary Get receivable adjustment summaries
         * @param {number} limit
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<number>} [accountIds]
         * @param {Array<AdjustmentReason>} [reason]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy]
         * @param {boolean} [isDeleted]
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReceivableAdjustmentSummaries: function (limit_1, id_1, accountIds_1, reason_1, offset_1, sortBy_1, isDeleted_1, order_1) {
            var args_1 = [];
            for (var _i = 8; _i < arguments.length; _i++) {
                args_1[_i - 8] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, accountIds_1, reason_1, offset_1, sortBy_1, isDeleted_1, order_1], args_1, true), void 0, function (limit, id, accountIds, reason, offset, sortBy, isDeleted, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getReceivableAdjustmentSummaries', 'limit', limit);
                            localVarPath = "/receivableAdjustmentSummaries";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (accountIds) {
                                localVarQueryParameter['accountIds'] = accountIds;
                            }
                            if (reason) {
                                localVarQueryParameter['reason'] = reason;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (isDeleted !== undefined) {
                                localVarQueryParameter['isDeleted'] = isDeleted;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns a list of receivable summaries that match the specified criteria.
         * @summary Get receivable summaries
         * @param {number} limit
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<number>} [accountIds]
         * @param {Array<ReconciliationType>} [reconciliationType]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy]
         * @param {Order} [order]
         * @param {boolean} [excludeDeleted] ignored deleted items, default true
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReceivableSummaries: function (limit_1, id_1, accountIds_1, reconciliationType_1, offset_1, sortBy_1, order_1, excludeDeleted_1) {
            var args_1 = [];
            for (var _i = 8; _i < arguments.length; _i++) {
                args_1[_i - 8] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, accountIds_1, reconciliationType_1, offset_1, sortBy_1, order_1, excludeDeleted_1], args_1, true), void 0, function (limit, id, accountIds, reconciliationType, offset, sortBy, order, excludeDeleted, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getReceivableSummaries', 'limit', limit);
                            localVarPath = "/receivableSummaries";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (accountIds) {
                                localVarQueryParameter['accountIds'] = accountIds;
                            }
                            if (reconciliationType) {
                                localVarQueryParameter['reconciliationType'] = reconciliationType;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (excludeDeleted !== undefined) {
                                localVarQueryParameter['excludeDeleted'] = excludeDeleted;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Recreate a ledger item
         * @param {number} id id of item to recreate
         * @param {LedgerItemRecreateData} [ledgerItemRecreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recreateLedgerItem: function (id_1, ledgerItemRecreateData_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, ledgerItemRecreateData_1], args_1, true), void 0, function (id, ledgerItemRecreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('recreateLedgerItem', 'id', id);
                            localVarPath = "/ledgerItems/{id}/recreate"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(ledgerItemRecreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Updates the memo field of the ledger item corresponding to the specified ID in URL path, if one exists
         * @summary Update a ledger item
         * @param {number} id id of ledger item to find
         * @param {string} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLedgerItem: function (id_1, body_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, body_1], args_1, true), void 0, function (id, body, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('updateLedgerItem', 'id', id);
                            localVarPath = "/ledgerItems/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.LedgerItemApiAxiosParamCreator = LedgerItemApiAxiosParamCreator;
/**
 * LedgerItemApi - functional programming interface
 * @export
 */
var LedgerItemApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.LedgerItemApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Create ledger item
         * @param {LedgerItemCreateData} [ledgerItemCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLedgerItem: function (ledgerItemCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createLedgerItem(ledgerItemCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LedgerItemApi.createLedgerItem']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Regenerate multiple ledger items
         * @param {LedgerItemRecreationBatchCreateData} [ledgerItemRecreationBatchCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLedgerItemRecreationBatch: function (ledgerItemRecreationBatchCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createLedgerItemRecreationBatch(ledgerItemRecreationBatchCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LedgerItemApi.createLedgerItemRecreationBatch']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create a one off ledger item
         * @param {OneOffLedgerItemCreateData} [oneOffLedgerItemCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneOffLedgerItem: function (oneOffLedgerItemCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createOneOffLedgerItem(oneOffLedgerItemCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LedgerItemApi.createOneOffLedgerItem']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Soft delete the ledger item corresponding to the specified ID in URL path, if one exists
         * @summary Delete a ledger item
         * @param {number} id id of ledger item to find
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLedgerItem: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteLedgerItem(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LedgerItemApi.deleteLedgerItem']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Returns the ledger item corresponding to the specified ID in the URL path, if one exists.
         * @summary Get a ledger item
         * @param {number} id id of ledger item to find
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLedgerItem: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLedgerItem(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LedgerItemApi.getLedgerItem']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get events for a ledger item
         * @param {number} id id of item to find events for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLedgerItemEvents: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLedgerItemEvents(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LedgerItemApi.getLedgerItemEvents']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Returns a list of ledger item settlements that match the specified criteria.
         * @summary Get ledger item settlements
         * @param {number} limit
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<number>} [ledgerItemIds]
         * @param {Array<number>} [originalLedgerItemIds]
         * @param {Date} [createdAtStart] beginning of range createdAt
         * @param {Date} [createdAtEnd] end of range createdAt
         * @param {Array<string>} [createdBy] comma separated list of uuids
         * @param {Date} [deletedAtStart] beginning of range for deletedAt
         * @param {Date} [deletedAtEnd] end of range for deletedAt
         * @param {Array<string>} [deletedBy] comma separated list of uuids
         * @param {number} [offset] default is 0
         * @param {string} [sortBy] default is created_at
         * @param {Order} [order] default case is asc
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLedgerItemSettlements: function (limit, id, ledgerItemIds, originalLedgerItemIds, createdAtStart, createdAtEnd, createdBy, deletedAtStart, deletedAtEnd, deletedBy, offset, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLedgerItemSettlements(limit, id, ledgerItemIds, originalLedgerItemIds, createdAtStart, createdAtEnd, createdBy, deletedAtStart, deletedAtEnd, deletedBy, offset, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LedgerItemApi.getLedgerItemSettlements']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Returns a list of ledger items that match the specified criteria.
         * @summary Get ledger items
         * @param {number} limit
         * @param {Array<number>} [id] A comma separated list of Ledger Item ids
         * @param {Array<number>} [accountIds] A comma separated list of Account ids
         * @param {string} [startDate] ledger item start date
         * @param {string} [endDate] ledger item end date
         * @param {string} [dueDate]
         * @param {Array<string>} [ledgerItemType] Ledger Item Type, either payable or receivable
         * @param {Array<string>} [reconciliationType] Reconciliation type, either paid or ignored
         * @param {Array<LedgerItemReason>} [reason]
         * @param {Array<number>} [netD] The amount of time allowed between cycle end and payment due
         * @param {Array<string>} [q] Fuzzy search parameter
         * @param {Date} [createdAtStart]
         * @param {Date} [createdAtEnd]
         * @param {Array<string>} [createdBy]
         * @param {Date} [deletedAtStart]
         * @param {Date} [deletedAtEnd]
         * @param {Array<string>} [deletedBy]
         * @param {number} [offset]
         * @param {string} [sortBy]
         * @param {Order} [order]
         * @param {boolean} [excludeDeleted]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLedgerItems: function (limit, id, accountIds, startDate, endDate, dueDate, ledgerItemType, reconciliationType, reason, netD, q, createdAtStart, createdAtEnd, createdBy, deletedAtStart, deletedAtEnd, deletedBy, offset, sortBy, order, excludeDeleted, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLedgerItems(limit, id, accountIds, startDate, endDate, dueDate, ledgerItemType, reconciliationType, reason, netD, q, createdAtStart, createdAtEnd, createdBy, deletedAtStart, deletedAtEnd, deletedBy, offset, sortBy, order, excludeDeleted, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LedgerItemApi.getLedgerItems']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Returns a list of payable adjustment summaries that match the specified criteria.
         * @summary Get payable adjustment summaries
         * @param {number} limit
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<number>} [accountIds]
         * @param {Array<AdjustmentReason>} [reason]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy]
         * @param {boolean} [isDeleted]
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayableAdjustmentSummaries: function (limit, id, accountIds, reason, offset, sortBy, isDeleted, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPayableAdjustmentSummaries(limit, id, accountIds, reason, offset, sortBy, isDeleted, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LedgerItemApi.getPayableAdjustmentSummaries']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Returns a list of payable summaries that match the specified criteria.
         * @summary Get payable summaries
         * @param {number} limit
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<number>} [accountIds]
         * @param {Array<LedgerItemReason>} [reason]
         * @param {Array<ReconciliationType>} [reconciliationType]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy]
         * @param {Order} [order]
         * @param {boolean} [excludeDeleted] ignored deleted items, default true
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayableSummaries: function (limit, id, accountIds, reason, reconciliationType, offset, sortBy, order, excludeDeleted, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPayableSummaries(limit, id, accountIds, reason, reconciliationType, offset, sortBy, order, excludeDeleted, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LedgerItemApi.getPayableSummaries']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Returns a list of receivable adjustment summaries that match the specified criteria.
         * @summary Get receivable adjustment summaries
         * @param {number} limit
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<number>} [accountIds]
         * @param {Array<AdjustmentReason>} [reason]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy]
         * @param {boolean} [isDeleted]
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReceivableAdjustmentSummaries: function (limit, id, accountIds, reason, offset, sortBy, isDeleted, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getReceivableAdjustmentSummaries(limit, id, accountIds, reason, offset, sortBy, isDeleted, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LedgerItemApi.getReceivableAdjustmentSummaries']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Returns a list of receivable summaries that match the specified criteria.
         * @summary Get receivable summaries
         * @param {number} limit
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<number>} [accountIds]
         * @param {Array<ReconciliationType>} [reconciliationType]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy]
         * @param {Order} [order]
         * @param {boolean} [excludeDeleted] ignored deleted items, default true
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReceivableSummaries: function (limit, id, accountIds, reconciliationType, offset, sortBy, order, excludeDeleted, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getReceivableSummaries(limit, id, accountIds, reconciliationType, offset, sortBy, order, excludeDeleted, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LedgerItemApi.getReceivableSummaries']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Recreate a ledger item
         * @param {number} id id of item to recreate
         * @param {LedgerItemRecreateData} [ledgerItemRecreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recreateLedgerItem: function (id, ledgerItemRecreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.recreateLedgerItem(id, ledgerItemRecreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LedgerItemApi.recreateLedgerItem']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Updates the memo field of the ledger item corresponding to the specified ID in URL path, if one exists
         * @summary Update a ledger item
         * @param {number} id id of ledger item to find
         * @param {string} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLedgerItem: function (id, body, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateLedgerItem(id, body, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LedgerItemApi.updateLedgerItem']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.LedgerItemApiFp = LedgerItemApiFp;
/**
 * LedgerItemApi - factory interface
 * @export
 */
var LedgerItemApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.LedgerItemApiFp)(configuration);
    return {
        /**
         *
         * @summary Create ledger item
         * @param {LedgerItemApiCreateLedgerItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLedgerItem: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createLedgerItem(requestParameters.ledgerItemCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Regenerate multiple ledger items
         * @param {LedgerItemApiCreateLedgerItemRecreationBatchRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLedgerItemRecreationBatch: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createLedgerItemRecreationBatch(requestParameters.ledgerItemRecreationBatchCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create a one off ledger item
         * @param {LedgerItemApiCreateOneOffLedgerItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneOffLedgerItem: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createOneOffLedgerItem(requestParameters.oneOffLedgerItemCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Soft delete the ledger item corresponding to the specified ID in URL path, if one exists
         * @summary Delete a ledger item
         * @param {LedgerItemApiDeleteLedgerItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLedgerItem: function (requestParameters, options) {
            return localVarFp.deleteLedgerItem(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns the ledger item corresponding to the specified ID in the URL path, if one exists.
         * @summary Get a ledger item
         * @param {LedgerItemApiGetLedgerItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLedgerItem: function (requestParameters, options) {
            return localVarFp.getLedgerItem(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get events for a ledger item
         * @param {LedgerItemApiGetLedgerItemEventsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLedgerItemEvents: function (requestParameters, options) {
            return localVarFp.getLedgerItemEvents(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a list of ledger item settlements that match the specified criteria.
         * @summary Get ledger item settlements
         * @param {LedgerItemApiGetLedgerItemSettlementsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLedgerItemSettlements: function (requestParameters, options) {
            return localVarFp.getLedgerItemSettlements(requestParameters.limit, requestParameters.id, requestParameters.ledgerItemIds, requestParameters.originalLedgerItemIds, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.createdBy, requestParameters.deletedAtStart, requestParameters.deletedAtEnd, requestParameters.deletedBy, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a list of ledger items that match the specified criteria.
         * @summary Get ledger items
         * @param {LedgerItemApiGetLedgerItemsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLedgerItems: function (requestParameters, options) {
            return localVarFp.getLedgerItems(requestParameters.limit, requestParameters.id, requestParameters.accountIds, requestParameters.startDate, requestParameters.endDate, requestParameters.dueDate, requestParameters.ledgerItemType, requestParameters.reconciliationType, requestParameters.reason, requestParameters.netD, requestParameters.q, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.createdBy, requestParameters.deletedAtStart, requestParameters.deletedAtEnd, requestParameters.deletedBy, requestParameters.offset, requestParameters.sortBy, requestParameters.order, requestParameters.excludeDeleted, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a list of payable adjustment summaries that match the specified criteria.
         * @summary Get payable adjustment summaries
         * @param {LedgerItemApiGetPayableAdjustmentSummariesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayableAdjustmentSummaries: function (requestParameters, options) {
            return localVarFp.getPayableAdjustmentSummaries(requestParameters.limit, requestParameters.id, requestParameters.accountIds, requestParameters.reason, requestParameters.offset, requestParameters.sortBy, requestParameters.isDeleted, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a list of payable summaries that match the specified criteria.
         * @summary Get payable summaries
         * @param {LedgerItemApiGetPayableSummariesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPayableSummaries: function (requestParameters, options) {
            return localVarFp.getPayableSummaries(requestParameters.limit, requestParameters.id, requestParameters.accountIds, requestParameters.reason, requestParameters.reconciliationType, requestParameters.offset, requestParameters.sortBy, requestParameters.order, requestParameters.excludeDeleted, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a list of receivable adjustment summaries that match the specified criteria.
         * @summary Get receivable adjustment summaries
         * @param {LedgerItemApiGetReceivableAdjustmentSummariesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReceivableAdjustmentSummaries: function (requestParameters, options) {
            return localVarFp.getReceivableAdjustmentSummaries(requestParameters.limit, requestParameters.id, requestParameters.accountIds, requestParameters.reason, requestParameters.offset, requestParameters.sortBy, requestParameters.isDeleted, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a list of receivable summaries that match the specified criteria.
         * @summary Get receivable summaries
         * @param {LedgerItemApiGetReceivableSummariesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReceivableSummaries: function (requestParameters, options) {
            return localVarFp.getReceivableSummaries(requestParameters.limit, requestParameters.id, requestParameters.accountIds, requestParameters.reconciliationType, requestParameters.offset, requestParameters.sortBy, requestParameters.order, requestParameters.excludeDeleted, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Recreate a ledger item
         * @param {LedgerItemApiRecreateLedgerItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recreateLedgerItem: function (requestParameters, options) {
            return localVarFp.recreateLedgerItem(requestParameters.id, requestParameters.ledgerItemRecreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates the memo field of the ledger item corresponding to the specified ID in URL path, if one exists
         * @summary Update a ledger item
         * @param {LedgerItemApiUpdateLedgerItemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLedgerItem: function (requestParameters, options) {
            return localVarFp.updateLedgerItem(requestParameters.id, requestParameters.body, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.LedgerItemApiFactory = LedgerItemApiFactory;
/**
 * LedgerItemApi - object-oriented interface
 * @export
 * @class LedgerItemApi
 * @extends {BaseAPI}
 */
var LedgerItemApi = /** @class */ (function (_super) {
    __extends(LedgerItemApi, _super);
    function LedgerItemApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create ledger item
     * @param {LedgerItemApiCreateLedgerItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerItemApi
     */
    LedgerItemApi.prototype.createLedgerItem = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.LedgerItemApiFp)(this.configuration).createLedgerItem(requestParameters.ledgerItemCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Regenerate multiple ledger items
     * @param {LedgerItemApiCreateLedgerItemRecreationBatchRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerItemApi
     */
    LedgerItemApi.prototype.createLedgerItemRecreationBatch = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.LedgerItemApiFp)(this.configuration).createLedgerItemRecreationBatch(requestParameters.ledgerItemRecreationBatchCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create a one off ledger item
     * @param {LedgerItemApiCreateOneOffLedgerItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerItemApi
     */
    LedgerItemApi.prototype.createOneOffLedgerItem = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.LedgerItemApiFp)(this.configuration).createOneOffLedgerItem(requestParameters.oneOffLedgerItemCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Soft delete the ledger item corresponding to the specified ID in URL path, if one exists
     * @summary Delete a ledger item
     * @param {LedgerItemApiDeleteLedgerItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerItemApi
     */
    LedgerItemApi.prototype.deleteLedgerItem = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LedgerItemApiFp)(this.configuration).deleteLedgerItem(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns the ledger item corresponding to the specified ID in the URL path, if one exists.
     * @summary Get a ledger item
     * @param {LedgerItemApiGetLedgerItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerItemApi
     */
    LedgerItemApi.prototype.getLedgerItem = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LedgerItemApiFp)(this.configuration).getLedgerItem(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get events for a ledger item
     * @param {LedgerItemApiGetLedgerItemEventsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerItemApi
     */
    LedgerItemApi.prototype.getLedgerItemEvents = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LedgerItemApiFp)(this.configuration).getLedgerItemEvents(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a list of ledger item settlements that match the specified criteria.
     * @summary Get ledger item settlements
     * @param {LedgerItemApiGetLedgerItemSettlementsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerItemApi
     */
    LedgerItemApi.prototype.getLedgerItemSettlements = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LedgerItemApiFp)(this.configuration).getLedgerItemSettlements(requestParameters.limit, requestParameters.id, requestParameters.ledgerItemIds, requestParameters.originalLedgerItemIds, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.createdBy, requestParameters.deletedAtStart, requestParameters.deletedAtEnd, requestParameters.deletedBy, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a list of ledger items that match the specified criteria.
     * @summary Get ledger items
     * @param {LedgerItemApiGetLedgerItemsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerItemApi
     */
    LedgerItemApi.prototype.getLedgerItems = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LedgerItemApiFp)(this.configuration).getLedgerItems(requestParameters.limit, requestParameters.id, requestParameters.accountIds, requestParameters.startDate, requestParameters.endDate, requestParameters.dueDate, requestParameters.ledgerItemType, requestParameters.reconciliationType, requestParameters.reason, requestParameters.netD, requestParameters.q, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.createdBy, requestParameters.deletedAtStart, requestParameters.deletedAtEnd, requestParameters.deletedBy, requestParameters.offset, requestParameters.sortBy, requestParameters.order, requestParameters.excludeDeleted, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a list of payable adjustment summaries that match the specified criteria.
     * @summary Get payable adjustment summaries
     * @param {LedgerItemApiGetPayableAdjustmentSummariesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerItemApi
     */
    LedgerItemApi.prototype.getPayableAdjustmentSummaries = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LedgerItemApiFp)(this.configuration).getPayableAdjustmentSummaries(requestParameters.limit, requestParameters.id, requestParameters.accountIds, requestParameters.reason, requestParameters.offset, requestParameters.sortBy, requestParameters.isDeleted, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a list of payable summaries that match the specified criteria.
     * @summary Get payable summaries
     * @param {LedgerItemApiGetPayableSummariesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerItemApi
     */
    LedgerItemApi.prototype.getPayableSummaries = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LedgerItemApiFp)(this.configuration).getPayableSummaries(requestParameters.limit, requestParameters.id, requestParameters.accountIds, requestParameters.reason, requestParameters.reconciliationType, requestParameters.offset, requestParameters.sortBy, requestParameters.order, requestParameters.excludeDeleted, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a list of receivable adjustment summaries that match the specified criteria.
     * @summary Get receivable adjustment summaries
     * @param {LedgerItemApiGetReceivableAdjustmentSummariesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerItemApi
     */
    LedgerItemApi.prototype.getReceivableAdjustmentSummaries = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LedgerItemApiFp)(this.configuration).getReceivableAdjustmentSummaries(requestParameters.limit, requestParameters.id, requestParameters.accountIds, requestParameters.reason, requestParameters.offset, requestParameters.sortBy, requestParameters.isDeleted, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a list of receivable summaries that match the specified criteria.
     * @summary Get receivable summaries
     * @param {LedgerItemApiGetReceivableSummariesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerItemApi
     */
    LedgerItemApi.prototype.getReceivableSummaries = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LedgerItemApiFp)(this.configuration).getReceivableSummaries(requestParameters.limit, requestParameters.id, requestParameters.accountIds, requestParameters.reconciliationType, requestParameters.offset, requestParameters.sortBy, requestParameters.order, requestParameters.excludeDeleted, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Recreate a ledger item
     * @param {LedgerItemApiRecreateLedgerItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerItemApi
     */
    LedgerItemApi.prototype.recreateLedgerItem = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LedgerItemApiFp)(this.configuration).recreateLedgerItem(requestParameters.id, requestParameters.ledgerItemRecreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates the memo field of the ledger item corresponding to the specified ID in URL path, if one exists
     * @summary Update a ledger item
     * @param {LedgerItemApiUpdateLedgerItemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerItemApi
     */
    LedgerItemApi.prototype.updateLedgerItem = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LedgerItemApiFp)(this.configuration).updateLedgerItem(requestParameters.id, requestParameters.body, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return LedgerItemApi;
}(base_1.BaseAPI));
exports.LedgerItemApi = LedgerItemApi;
/**
 * LedgerItemPostBackApi - axios parameter creator
 * @export
 */
var LedgerItemPostBackApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Create ledger item postback endpoint from FLI
         * @param {LedgerItemCreationRequest} [ledgerItemCreationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLedgerItemAsync: function (ledgerItemCreationRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([ledgerItemCreationRequest_1], args_1, true), void 0, function (ledgerItemCreationRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/asyncLedgerItems";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["internal"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(ledgerItemCreationRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.LedgerItemPostBackApiAxiosParamCreator = LedgerItemPostBackApiAxiosParamCreator;
/**
 * LedgerItemPostBackApi - functional programming interface
 * @export
 */
var LedgerItemPostBackApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.LedgerItemPostBackApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Create ledger item postback endpoint from FLI
         * @param {LedgerItemCreationRequest} [ledgerItemCreationRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLedgerItemAsync: function (ledgerItemCreationRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createLedgerItemAsync(ledgerItemCreationRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LedgerItemPostBackApi.createLedgerItemAsync']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.LedgerItemPostBackApiFp = LedgerItemPostBackApiFp;
/**
 * LedgerItemPostBackApi - factory interface
 * @export
 */
var LedgerItemPostBackApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.LedgerItemPostBackApiFp)(configuration);
    return {
        /**
         *
         * @summary Create ledger item postback endpoint from FLI
         * @param {LedgerItemPostBackApiCreateLedgerItemAsyncRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLedgerItemAsync: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createLedgerItemAsync(requestParameters.ledgerItemCreationRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.LedgerItemPostBackApiFactory = LedgerItemPostBackApiFactory;
/**
 * LedgerItemPostBackApi - object-oriented interface
 * @export
 * @class LedgerItemPostBackApi
 * @extends {BaseAPI}
 */
var LedgerItemPostBackApi = /** @class */ (function (_super) {
    __extends(LedgerItemPostBackApi, _super);
    function LedgerItemPostBackApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create ledger item postback endpoint from FLI
     * @param {LedgerItemPostBackApiCreateLedgerItemAsyncRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerItemPostBackApi
     */
    LedgerItemPostBackApi.prototype.createLedgerItemAsync = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.LedgerItemPostBackApiFp)(this.configuration).createLedgerItemAsync(requestParameters.ledgerItemCreationRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return LedgerItemPostBackApi;
}(base_1.BaseAPI));
exports.LedgerItemPostBackApi = LedgerItemPostBackApi;
/**
 * LedgerItemReconciliationApi - axios parameter creator
 * @export
 */
var LedgerItemReconciliationApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Create a ledger item reconciliation
         * @param {LedgerItemReconciliationCreateData} [ledgerItemReconciliationCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLedgerItemReconciliation: function (ledgerItemReconciliationCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([ledgerItemReconciliationCreateData_1], args_1, true), void 0, function (ledgerItemReconciliationCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/ledgerItemReconciliations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(ledgerItemReconciliationCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Soft delete multiple ledger item reconciliations that match the ids provided in the URL path
         * @summary Delete multiple ledger item reconciliations
         * @param {Array<number>} ids A comma separated list of Ledger Item id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLedgerItemReconciliations: function (ids_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([ids_1], args_1, true), void 0, function (ids, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'ids' is not null or undefined
                            (0, common_1.assertParamExists)('deleteLedgerItemReconciliations', 'ids', ids);
                            localVarPath = "/ledgerItemReconciliations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (ids) {
                                localVarQueryParameter['ids'] = ids;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns the ledger item reconciliation corresponding to the specified ID in the URL path, if one exists.
         * @summary Get a ledger item reconciliation
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLedgerItemReconciliation: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('getLedgerItemReconciliation', 'id', id);
                            localVarPath = "/ledgerItemReconciliations/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Returns a list of ledger item reconciliations that match the specified criteria.
         * @summary Get ledger item reconiliations
         * @param {number} limit default 100
         * @param {Array<number>} [ids] A comma separated list of Ledger Item ids
         * @param {Array<number>} [ledgerItemIds] A comma separated list of Ledger Item ids
         * @param {ReconciliationType} [reconciliationType] Ledger Item reconciliation type
         * @param {Date} [createdAtStart] beginning of range createdAt
         * @param {Date} [createdAtEnd] end of range createdAt
         * @param {Array<string>} [createdBy] comma separated list of uuids
         * @param {Date} [deletedAtStart] beginning of range for deletedAt
         * @param {Date} [deletedAtEnd] end of range for deletedAt
         * @param {Array<string>} [deletedBy] comma separated list of uuids
         * @param {number} [offset] default is 0
         * @param {string} [sortBy] default is created_at
         * @param {Order} [order] default case is asc
         * @param {boolean} [excludeDeleted] default case is true
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLedgerItemReconciliations: function (limit_1, ids_1, ledgerItemIds_1, reconciliationType_1, createdAtStart_1, createdAtEnd_1, createdBy_1, deletedAtStart_1, deletedAtEnd_1, deletedBy_1, offset_1, sortBy_1, order_1, excludeDeleted_1) {
            var args_1 = [];
            for (var _i = 14; _i < arguments.length; _i++) {
                args_1[_i - 14] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, ids_1, ledgerItemIds_1, reconciliationType_1, createdAtStart_1, createdAtEnd_1, createdBy_1, deletedAtStart_1, deletedAtEnd_1, deletedBy_1, offset_1, sortBy_1, order_1, excludeDeleted_1], args_1, true), void 0, function (limit, ids, ledgerItemIds, reconciliationType, createdAtStart, createdAtEnd, createdBy, deletedAtStart, deletedAtEnd, deletedBy, offset, sortBy, order, excludeDeleted, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getLedgerItemReconciliations', 'limit', limit);
                            localVarPath = "/ledgerItemReconciliations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (ids) {
                                localVarQueryParameter['ids'] = ids;
                            }
                            if (ledgerItemIds) {
                                localVarQueryParameter['ledgerItemIds'] = ledgerItemIds;
                            }
                            if (reconciliationType !== undefined) {
                                localVarQueryParameter['reconciliationType'] = reconciliationType;
                            }
                            if (createdAtStart !== undefined) {
                                localVarQueryParameter['createdAtStart'] = (createdAtStart instanceof Date) ?
                                    createdAtStart.toISOString() :
                                    createdAtStart;
                            }
                            if (createdAtEnd !== undefined) {
                                localVarQueryParameter['createdAtEnd'] = (createdAtEnd instanceof Date) ?
                                    createdAtEnd.toISOString() :
                                    createdAtEnd;
                            }
                            if (createdBy) {
                                localVarQueryParameter['createdBy'] = createdBy;
                            }
                            if (deletedAtStart !== undefined) {
                                localVarQueryParameter['deletedAtStart'] = (deletedAtStart instanceof Date) ?
                                    deletedAtStart.toISOString() :
                                    deletedAtStart;
                            }
                            if (deletedAtEnd !== undefined) {
                                localVarQueryParameter['deletedAtEnd'] = (deletedAtEnd instanceof Date) ?
                                    deletedAtEnd.toISOString() :
                                    deletedAtEnd;
                            }
                            if (deletedBy) {
                                localVarQueryParameter['deletedBy'] = deletedBy;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (excludeDeleted !== undefined) {
                                localVarQueryParameter['excludeDeleted'] = excludeDeleted;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.LedgerItemReconciliationApiAxiosParamCreator = LedgerItemReconciliationApiAxiosParamCreator;
/**
 * LedgerItemReconciliationApi - functional programming interface
 * @export
 */
var LedgerItemReconciliationApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.LedgerItemReconciliationApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Create a ledger item reconciliation
         * @param {LedgerItemReconciliationCreateData} [ledgerItemReconciliationCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLedgerItemReconciliation: function (ledgerItemReconciliationCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createLedgerItemReconciliation(ledgerItemReconciliationCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LedgerItemReconciliationApi.createLedgerItemReconciliation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Soft delete multiple ledger item reconciliations that match the ids provided in the URL path
         * @summary Delete multiple ledger item reconciliations
         * @param {Array<number>} ids A comma separated list of Ledger Item id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLedgerItemReconciliations: function (ids, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteLedgerItemReconciliations(ids, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LedgerItemReconciliationApi.deleteLedgerItemReconciliations']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Returns the ledger item reconciliation corresponding to the specified ID in the URL path, if one exists.
         * @summary Get a ledger item reconciliation
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLedgerItemReconciliation: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLedgerItemReconciliation(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LedgerItemReconciliationApi.getLedgerItemReconciliation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Returns a list of ledger item reconciliations that match the specified criteria.
         * @summary Get ledger item reconiliations
         * @param {number} limit default 100
         * @param {Array<number>} [ids] A comma separated list of Ledger Item ids
         * @param {Array<number>} [ledgerItemIds] A comma separated list of Ledger Item ids
         * @param {ReconciliationType} [reconciliationType] Ledger Item reconciliation type
         * @param {Date} [createdAtStart] beginning of range createdAt
         * @param {Date} [createdAtEnd] end of range createdAt
         * @param {Array<string>} [createdBy] comma separated list of uuids
         * @param {Date} [deletedAtStart] beginning of range for deletedAt
         * @param {Date} [deletedAtEnd] end of range for deletedAt
         * @param {Array<string>} [deletedBy] comma separated list of uuids
         * @param {number} [offset] default is 0
         * @param {string} [sortBy] default is created_at
         * @param {Order} [order] default case is asc
         * @param {boolean} [excludeDeleted] default case is true
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLedgerItemReconciliations: function (limit, ids, ledgerItemIds, reconciliationType, createdAtStart, createdAtEnd, createdBy, deletedAtStart, deletedAtEnd, deletedBy, offset, sortBy, order, excludeDeleted, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getLedgerItemReconciliations(limit, ids, ledgerItemIds, reconciliationType, createdAtStart, createdAtEnd, createdBy, deletedAtStart, deletedAtEnd, deletedBy, offset, sortBy, order, excludeDeleted, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LedgerItemReconciliationApi.getLedgerItemReconciliations']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.LedgerItemReconciliationApiFp = LedgerItemReconciliationApiFp;
/**
 * LedgerItemReconciliationApi - factory interface
 * @export
 */
var LedgerItemReconciliationApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.LedgerItemReconciliationApiFp)(configuration);
    return {
        /**
         *
         * @summary Create a ledger item reconciliation
         * @param {LedgerItemReconciliationApiCreateLedgerItemReconciliationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLedgerItemReconciliation: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createLedgerItemReconciliation(requestParameters.ledgerItemReconciliationCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Soft delete multiple ledger item reconciliations that match the ids provided in the URL path
         * @summary Delete multiple ledger item reconciliations
         * @param {LedgerItemReconciliationApiDeleteLedgerItemReconciliationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLedgerItemReconciliations: function (requestParameters, options) {
            return localVarFp.deleteLedgerItemReconciliations(requestParameters.ids, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns the ledger item reconciliation corresponding to the specified ID in the URL path, if one exists.
         * @summary Get a ledger item reconciliation
         * @param {LedgerItemReconciliationApiGetLedgerItemReconciliationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLedgerItemReconciliation: function (requestParameters, options) {
            return localVarFp.getLedgerItemReconciliation(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Returns a list of ledger item reconciliations that match the specified criteria.
         * @summary Get ledger item reconiliations
         * @param {LedgerItemReconciliationApiGetLedgerItemReconciliationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLedgerItemReconciliations: function (requestParameters, options) {
            return localVarFp.getLedgerItemReconciliations(requestParameters.limit, requestParameters.ids, requestParameters.ledgerItemIds, requestParameters.reconciliationType, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.createdBy, requestParameters.deletedAtStart, requestParameters.deletedAtEnd, requestParameters.deletedBy, requestParameters.offset, requestParameters.sortBy, requestParameters.order, requestParameters.excludeDeleted, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.LedgerItemReconciliationApiFactory = LedgerItemReconciliationApiFactory;
/**
 * LedgerItemReconciliationApi - object-oriented interface
 * @export
 * @class LedgerItemReconciliationApi
 * @extends {BaseAPI}
 */
var LedgerItemReconciliationApi = /** @class */ (function (_super) {
    __extends(LedgerItemReconciliationApi, _super);
    function LedgerItemReconciliationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Create a ledger item reconciliation
     * @param {LedgerItemReconciliationApiCreateLedgerItemReconciliationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerItemReconciliationApi
     */
    LedgerItemReconciliationApi.prototype.createLedgerItemReconciliation = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.LedgerItemReconciliationApiFp)(this.configuration).createLedgerItemReconciliation(requestParameters.ledgerItemReconciliationCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Soft delete multiple ledger item reconciliations that match the ids provided in the URL path
     * @summary Delete multiple ledger item reconciliations
     * @param {LedgerItemReconciliationApiDeleteLedgerItemReconciliationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerItemReconciliationApi
     */
    LedgerItemReconciliationApi.prototype.deleteLedgerItemReconciliations = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LedgerItemReconciliationApiFp)(this.configuration).deleteLedgerItemReconciliations(requestParameters.ids, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns the ledger item reconciliation corresponding to the specified ID in the URL path, if one exists.
     * @summary Get a ledger item reconciliation
     * @param {LedgerItemReconciliationApiGetLedgerItemReconciliationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerItemReconciliationApi
     */
    LedgerItemReconciliationApi.prototype.getLedgerItemReconciliation = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LedgerItemReconciliationApiFp)(this.configuration).getLedgerItemReconciliation(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Returns a list of ledger item reconciliations that match the specified criteria.
     * @summary Get ledger item reconiliations
     * @param {LedgerItemReconciliationApiGetLedgerItemReconciliationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LedgerItemReconciliationApi
     */
    LedgerItemReconciliationApi.prototype.getLedgerItemReconciliations = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LedgerItemReconciliationApiFp)(this.configuration).getLedgerItemReconciliations(requestParameters.limit, requestParameters.ids, requestParameters.ledgerItemIds, requestParameters.reconciliationType, requestParameters.createdAtStart, requestParameters.createdAtEnd, requestParameters.createdBy, requestParameters.deletedAtStart, requestParameters.deletedAtEnd, requestParameters.deletedBy, requestParameters.offset, requestParameters.sortBy, requestParameters.order, requestParameters.excludeDeleted, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return LedgerItemReconciliationApi;
}(base_1.BaseAPI));
exports.LedgerItemReconciliationApi = LedgerItemReconciliationApi;
/**
 * OnboardingContractApi - axios parameter creator
 * @export
 */
var OnboardingContractApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create an onboarding contract
         * @summary Create an onboarding contract
         * @param {OnboardingContractCreateData} [onboardingContractCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOnboardingContract: function (onboardingContractCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([onboardingContractCreateData_1], args_1, true), void 0, function (onboardingContractCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/onboardingContracts";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(onboardingContractCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get onboarding contracts
         * @summary Get onboarding contracts
         * @param {number} limit
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<string>} [uuid] A comma separated list of uuids
         * @param {Array<OnboardingContractType>} [type]
         * @param {Array<string>} [createdBy] comma separated list of uuids
         * @param {Date} [createdAtMin] earliest bound to look at for creation date
         * @param {Date} [createdAtMax] latest bound to look at for creation date
         * @param {Array<string>} [updatedBy]
         * @param {Date} [updatedAtMin]
         * @param {Date} [updatedAtMax]
         * @param {Array<string>} [deletedBy] comma separated list of uuids
         * @param {Date} [deletedAtMin] earliest bound for deletion date
         * @param {Date} [deletedAtMax] latest bound for deletion date
         * @param {boolean} [includeDeleted]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingContracts: function (limit_1, id_1, uuid_1, type_1, createdBy_1, createdAtMin_1, createdAtMax_1, updatedBy_1, updatedAtMin_1, updatedAtMax_1, deletedBy_1, deletedAtMin_1, deletedAtMax_1, includeDeleted_1, offset_1, sortBy_1, order_1) {
            var args_1 = [];
            for (var _i = 17; _i < arguments.length; _i++) {
                args_1[_i - 17] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, uuid_1, type_1, createdBy_1, createdAtMin_1, createdAtMax_1, updatedBy_1, updatedAtMin_1, updatedAtMax_1, deletedBy_1, deletedAtMin_1, deletedAtMax_1, includeDeleted_1, offset_1, sortBy_1, order_1], args_1, true), void 0, function (limit, id, uuid, type, createdBy, createdAtMin, createdAtMax, updatedBy, updatedAtMin, updatedAtMax, deletedBy, deletedAtMin, deletedAtMax, includeDeleted, offset, sortBy, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getOnboardingContracts', 'limit', limit);
                            localVarPath = "/onboardingContracts";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (uuid) {
                                localVarQueryParameter['uuid'] = uuid.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (type) {
                                localVarQueryParameter['type'] = type;
                            }
                            if (createdBy) {
                                localVarQueryParameter['createdBy'] = createdBy.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (createdAtMin !== undefined) {
                                localVarQueryParameter['createdAtMin'] = (createdAtMin instanceof Date) ?
                                    createdAtMin.toISOString() :
                                    createdAtMin;
                            }
                            if (createdAtMax !== undefined) {
                                localVarQueryParameter['createdAtMax'] = (createdAtMax instanceof Date) ?
                                    createdAtMax.toISOString() :
                                    createdAtMax;
                            }
                            if (updatedBy) {
                                localVarQueryParameter['updatedBy'] = updatedBy;
                            }
                            if (updatedAtMin !== undefined) {
                                localVarQueryParameter['updatedAtMin'] = (updatedAtMin instanceof Date) ?
                                    updatedAtMin.toISOString() :
                                    updatedAtMin;
                            }
                            if (updatedAtMax !== undefined) {
                                localVarQueryParameter['updatedAtMax'] = (updatedAtMax instanceof Date) ?
                                    updatedAtMax.toISOString() :
                                    updatedAtMax;
                            }
                            if (deletedBy) {
                                localVarQueryParameter['deletedBy'] = deletedBy.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (deletedAtMin !== undefined) {
                                localVarQueryParameter['deletedAtMin'] = (deletedAtMin instanceof Date) ?
                                    deletedAtMin.toISOString() :
                                    deletedAtMin;
                            }
                            if (deletedAtMax !== undefined) {
                                localVarQueryParameter['deletedAtMax'] = (deletedAtMax instanceof Date) ?
                                    deletedAtMax.toISOString() :
                                    deletedAtMax;
                            }
                            if (includeDeleted !== undefined) {
                                localVarQueryParameter['includeDeleted'] = includeDeleted;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.OnboardingContractApiAxiosParamCreator = OnboardingContractApiAxiosParamCreator;
/**
 * OnboardingContractApi - functional programming interface
 * @export
 */
var OnboardingContractApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.OnboardingContractApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create an onboarding contract
         * @summary Create an onboarding contract
         * @param {OnboardingContractCreateData} [onboardingContractCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOnboardingContract: function (onboardingContractCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createOnboardingContract(onboardingContractCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OnboardingContractApi.createOnboardingContract']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get onboarding contracts
         * @summary Get onboarding contracts
         * @param {number} limit
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<string>} [uuid] A comma separated list of uuids
         * @param {Array<OnboardingContractType>} [type]
         * @param {Array<string>} [createdBy] comma separated list of uuids
         * @param {Date} [createdAtMin] earliest bound to look at for creation date
         * @param {Date} [createdAtMax] latest bound to look at for creation date
         * @param {Array<string>} [updatedBy]
         * @param {Date} [updatedAtMin]
         * @param {Date} [updatedAtMax]
         * @param {Array<string>} [deletedBy] comma separated list of uuids
         * @param {Date} [deletedAtMin] earliest bound for deletion date
         * @param {Date} [deletedAtMax] latest bound for deletion date
         * @param {boolean} [includeDeleted]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingContracts: function (limit, id, uuid, type, createdBy, createdAtMin, createdAtMax, updatedBy, updatedAtMin, updatedAtMax, deletedBy, deletedAtMin, deletedAtMax, includeDeleted, offset, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getOnboardingContracts(limit, id, uuid, type, createdBy, createdAtMin, createdAtMax, updatedBy, updatedAtMin, updatedAtMax, deletedBy, deletedAtMin, deletedAtMax, includeDeleted, offset, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OnboardingContractApi.getOnboardingContracts']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.OnboardingContractApiFp = OnboardingContractApiFp;
/**
 * OnboardingContractApi - factory interface
 * @export
 */
var OnboardingContractApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.OnboardingContractApiFp)(configuration);
    return {
        /**
         * Create an onboarding contract
         * @summary Create an onboarding contract
         * @param {OnboardingContractApiCreateOnboardingContractRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOnboardingContract: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createOnboardingContract(requestParameters.onboardingContractCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get onboarding contracts
         * @summary Get onboarding contracts
         * @param {OnboardingContractApiGetOnboardingContractsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingContracts: function (requestParameters, options) {
            return localVarFp.getOnboardingContracts(requestParameters.limit, requestParameters.id, requestParameters.uuid, requestParameters.type, requestParameters.createdBy, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.updatedBy, requestParameters.updatedAtMin, requestParameters.updatedAtMax, requestParameters.deletedBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.includeDeleted, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.OnboardingContractApiFactory = OnboardingContractApiFactory;
/**
 * OnboardingContractApi - object-oriented interface
 * @export
 * @class OnboardingContractApi
 * @extends {BaseAPI}
 */
var OnboardingContractApi = /** @class */ (function (_super) {
    __extends(OnboardingContractApi, _super);
    function OnboardingContractApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create an onboarding contract
     * @summary Create an onboarding contract
     * @param {OnboardingContractApiCreateOnboardingContractRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingContractApi
     */
    OnboardingContractApi.prototype.createOnboardingContract = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.OnboardingContractApiFp)(this.configuration).createOnboardingContract(requestParameters.onboardingContractCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get onboarding contracts
     * @summary Get onboarding contracts
     * @param {OnboardingContractApiGetOnboardingContractsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingContractApi
     */
    OnboardingContractApi.prototype.getOnboardingContracts = function (requestParameters, options) {
        var _this = this;
        return (0, exports.OnboardingContractApiFp)(this.configuration).getOnboardingContracts(requestParameters.limit, requestParameters.id, requestParameters.uuid, requestParameters.type, requestParameters.createdBy, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.updatedBy, requestParameters.updatedAtMin, requestParameters.updatedAtMax, requestParameters.deletedBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.includeDeleted, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return OnboardingContractApi;
}(base_1.BaseAPI));
exports.OnboardingContractApi = OnboardingContractApi;
/**
 * OnboardingContractSignatureApi - axios parameter creator
 * @export
 */
var OnboardingContractSignatureApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create an onboarding contract signature
         * @summary Create an onboarding contract signature
         * @param {OnboardingContractSignatureCreateData} [onboardingContractSignatureCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOnboardingContractSignature: function (onboardingContractSignatureCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([onboardingContractSignatureCreateData_1], args_1, true), void 0, function (onboardingContractSignatureCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/onboardingContractSignatures";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(onboardingContractSignatureCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get onboarding contract signatures
         * @summary Get onboarding contract signatures
         * @param {number} limit
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<string>} [uuid] A comma separated list of uuids
         * @param {Array<number>} [userId]
         * @param {Array<number>} [onboardingContractId]
         * @param {Array<string>} [createdBy] comma separated list of uuids
         * @param {Date} [createdAtMin] earliest bound to look at for creation date
         * @param {Date} [createdAtMax] latest bound to look at for creation date
         * @param {Array<string>} [updatedBy]
         * @param {Date} [updatedAtMin]
         * @param {Date} [updatedAtMax]
         * @param {Array<string>} [deletedBy] comma separated list of uuids
         * @param {Date} [deletedAtMin] earliest bound for deletion date
         * @param {Date} [deletedAtMax] latest bound for deletion date
         * @param {boolean} [includeDeleted]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingContractSignatures: function (limit_1, id_1, uuid_1, userId_1, onboardingContractId_1, createdBy_1, createdAtMin_1, createdAtMax_1, updatedBy_1, updatedAtMin_1, updatedAtMax_1, deletedBy_1, deletedAtMin_1, deletedAtMax_1, includeDeleted_1, offset_1, sortBy_1, order_1) {
            var args_1 = [];
            for (var _i = 18; _i < arguments.length; _i++) {
                args_1[_i - 18] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, uuid_1, userId_1, onboardingContractId_1, createdBy_1, createdAtMin_1, createdAtMax_1, updatedBy_1, updatedAtMin_1, updatedAtMax_1, deletedBy_1, deletedAtMin_1, deletedAtMax_1, includeDeleted_1, offset_1, sortBy_1, order_1], args_1, true), void 0, function (limit, id, uuid, userId, onboardingContractId, createdBy, createdAtMin, createdAtMax, updatedBy, updatedAtMin, updatedAtMax, deletedBy, deletedAtMin, deletedAtMax, includeDeleted, offset, sortBy, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getOnboardingContractSignatures', 'limit', limit);
                            localVarPath = "/onboardingContractSignatures";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (uuid) {
                                localVarQueryParameter['uuid'] = uuid.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (userId) {
                                localVarQueryParameter['userId'] = userId;
                            }
                            if (onboardingContractId) {
                                localVarQueryParameter['onboardingContractId'] = onboardingContractId;
                            }
                            if (createdBy) {
                                localVarQueryParameter['createdBy'] = createdBy.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (createdAtMin !== undefined) {
                                localVarQueryParameter['createdAtMin'] = (createdAtMin instanceof Date) ?
                                    createdAtMin.toISOString() :
                                    createdAtMin;
                            }
                            if (createdAtMax !== undefined) {
                                localVarQueryParameter['createdAtMax'] = (createdAtMax instanceof Date) ?
                                    createdAtMax.toISOString() :
                                    createdAtMax;
                            }
                            if (updatedBy) {
                                localVarQueryParameter['updatedBy'] = updatedBy;
                            }
                            if (updatedAtMin !== undefined) {
                                localVarQueryParameter['updatedAtMin'] = (updatedAtMin instanceof Date) ?
                                    updatedAtMin.toISOString() :
                                    updatedAtMin;
                            }
                            if (updatedAtMax !== undefined) {
                                localVarQueryParameter['updatedAtMax'] = (updatedAtMax instanceof Date) ?
                                    updatedAtMax.toISOString() :
                                    updatedAtMax;
                            }
                            if (deletedBy) {
                                localVarQueryParameter['deletedBy'] = deletedBy.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (deletedAtMin !== undefined) {
                                localVarQueryParameter['deletedAtMin'] = (deletedAtMin instanceof Date) ?
                                    deletedAtMin.toISOString() :
                                    deletedAtMin;
                            }
                            if (deletedAtMax !== undefined) {
                                localVarQueryParameter['deletedAtMax'] = (deletedAtMax instanceof Date) ?
                                    deletedAtMax.toISOString() :
                                    deletedAtMax;
                            }
                            if (includeDeleted !== undefined) {
                                localVarQueryParameter['includeDeleted'] = includeDeleted;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.OnboardingContractSignatureApiAxiosParamCreator = OnboardingContractSignatureApiAxiosParamCreator;
/**
 * OnboardingContractSignatureApi - functional programming interface
 * @export
 */
var OnboardingContractSignatureApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.OnboardingContractSignatureApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create an onboarding contract signature
         * @summary Create an onboarding contract signature
         * @param {OnboardingContractSignatureCreateData} [onboardingContractSignatureCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOnboardingContractSignature: function (onboardingContractSignatureCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createOnboardingContractSignature(onboardingContractSignatureCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OnboardingContractSignatureApi.createOnboardingContractSignature']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get onboarding contract signatures
         * @summary Get onboarding contract signatures
         * @param {number} limit
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<string>} [uuid] A comma separated list of uuids
         * @param {Array<number>} [userId]
         * @param {Array<number>} [onboardingContractId]
         * @param {Array<string>} [createdBy] comma separated list of uuids
         * @param {Date} [createdAtMin] earliest bound to look at for creation date
         * @param {Date} [createdAtMax] latest bound to look at for creation date
         * @param {Array<string>} [updatedBy]
         * @param {Date} [updatedAtMin]
         * @param {Date} [updatedAtMax]
         * @param {Array<string>} [deletedBy] comma separated list of uuids
         * @param {Date} [deletedAtMin] earliest bound for deletion date
         * @param {Date} [deletedAtMax] latest bound for deletion date
         * @param {boolean} [includeDeleted]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingContractSignatures: function (limit, id, uuid, userId, onboardingContractId, createdBy, createdAtMin, createdAtMax, updatedBy, updatedAtMin, updatedAtMax, deletedBy, deletedAtMin, deletedAtMax, includeDeleted, offset, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getOnboardingContractSignatures(limit, id, uuid, userId, onboardingContractId, createdBy, createdAtMin, createdAtMax, updatedBy, updatedAtMin, updatedAtMax, deletedBy, deletedAtMin, deletedAtMax, includeDeleted, offset, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OnboardingContractSignatureApi.getOnboardingContractSignatures']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.OnboardingContractSignatureApiFp = OnboardingContractSignatureApiFp;
/**
 * OnboardingContractSignatureApi - factory interface
 * @export
 */
var OnboardingContractSignatureApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.OnboardingContractSignatureApiFp)(configuration);
    return {
        /**
         * Create an onboarding contract signature
         * @summary Create an onboarding contract signature
         * @param {OnboardingContractSignatureApiCreateOnboardingContractSignatureRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOnboardingContractSignature: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createOnboardingContractSignature(requestParameters.onboardingContractSignatureCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get onboarding contract signatures
         * @summary Get onboarding contract signatures
         * @param {OnboardingContractSignatureApiGetOnboardingContractSignaturesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOnboardingContractSignatures: function (requestParameters, options) {
            return localVarFp.getOnboardingContractSignatures(requestParameters.limit, requestParameters.id, requestParameters.uuid, requestParameters.userId, requestParameters.onboardingContractId, requestParameters.createdBy, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.updatedBy, requestParameters.updatedAtMin, requestParameters.updatedAtMax, requestParameters.deletedBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.includeDeleted, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.OnboardingContractSignatureApiFactory = OnboardingContractSignatureApiFactory;
/**
 * OnboardingContractSignatureApi - object-oriented interface
 * @export
 * @class OnboardingContractSignatureApi
 * @extends {BaseAPI}
 */
var OnboardingContractSignatureApi = /** @class */ (function (_super) {
    __extends(OnboardingContractSignatureApi, _super);
    function OnboardingContractSignatureApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create an onboarding contract signature
     * @summary Create an onboarding contract signature
     * @param {OnboardingContractSignatureApiCreateOnboardingContractSignatureRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingContractSignatureApi
     */
    OnboardingContractSignatureApi.prototype.createOnboardingContractSignature = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.OnboardingContractSignatureApiFp)(this.configuration).createOnboardingContractSignature(requestParameters.onboardingContractSignatureCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get onboarding contract signatures
     * @summary Get onboarding contract signatures
     * @param {OnboardingContractSignatureApiGetOnboardingContractSignaturesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingContractSignatureApi
     */
    OnboardingContractSignatureApi.prototype.getOnboardingContractSignatures = function (requestParameters, options) {
        var _this = this;
        return (0, exports.OnboardingContractSignatureApiFp)(this.configuration).getOnboardingContractSignatures(requestParameters.limit, requestParameters.id, requestParameters.uuid, requestParameters.userId, requestParameters.onboardingContractId, requestParameters.createdBy, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.updatedBy, requestParameters.updatedAtMin, requestParameters.updatedAtMax, requestParameters.deletedBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.includeDeleted, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return OnboardingContractSignatureApi;
}(base_1.BaseAPI));
exports.OnboardingContractSignatureApi = OnboardingContractSignatureApi;
/**
 * RecurlyTokenApi - axios parameter creator
 * @export
 */
var RecurlyTokenApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create a recurly token
         * @summary Create a recurly token
         * @param {RecurlyTokenCreateData} [recurlyTokenCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRecurlyToken: function (recurlyTokenCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([recurlyTokenCreateData_1], args_1, true), void 0, function (recurlyTokenCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/recurlyTokens";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(recurlyTokenCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.RecurlyTokenApiAxiosParamCreator = RecurlyTokenApiAxiosParamCreator;
/**
 * RecurlyTokenApi - functional programming interface
 * @export
 */
var RecurlyTokenApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.RecurlyTokenApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create a recurly token
         * @summary Create a recurly token
         * @param {RecurlyTokenCreateData} [recurlyTokenCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRecurlyToken: function (recurlyTokenCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createRecurlyToken(recurlyTokenCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RecurlyTokenApi.createRecurlyToken']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.RecurlyTokenApiFp = RecurlyTokenApiFp;
/**
 * RecurlyTokenApi - factory interface
 * @export
 */
var RecurlyTokenApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.RecurlyTokenApiFp)(configuration);
    return {
        /**
         * Create a recurly token
         * @summary Create a recurly token
         * @param {RecurlyTokenApiCreateRecurlyTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRecurlyToken: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createRecurlyToken(requestParameters.recurlyTokenCreateData, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.RecurlyTokenApiFactory = RecurlyTokenApiFactory;
/**
 * RecurlyTokenApi - object-oriented interface
 * @export
 * @class RecurlyTokenApi
 * @extends {BaseAPI}
 */
var RecurlyTokenApi = /** @class */ (function (_super) {
    __extends(RecurlyTokenApi, _super);
    function RecurlyTokenApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a recurly token
     * @summary Create a recurly token
     * @param {RecurlyTokenApiCreateRecurlyTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RecurlyTokenApi
     */
    RecurlyTokenApi.prototype.createRecurlyToken = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.RecurlyTokenApiFp)(this.configuration).createRecurlyToken(requestParameters.recurlyTokenCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return RecurlyTokenApi;
}(base_1.BaseAPI));
exports.RecurlyTokenApi = RecurlyTokenApi;
/**
 * ReportingAPICallsApi - axios parameter creator
 * @export
 */
var ReportingAPICallsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create a Reporting Api Call
         * @summary Create a ReportingApiCall
         * @param {ReportingApiCallCreateData} [reportingApiCallCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReportingApiCall: function (reportingApiCallCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([reportingApiCallCreateData_1], args_1, true), void 0, function (reportingApiCallCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/reportingApiCalls";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(reportingApiCallCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get Reporting API Calls
         * @summary Get Reporting API Calls
         * @param {number} limit limit results
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<number>} [subAccountId] A comma separated list of sub account ids
         * @param {Array<string>} [createdBy] comma separated list of uuids
         * @param {Date} [createdAtMax] latest bound to look at for creation date
         * @param {Date} [createdAtMin] earliest bound to look at for creation date
         * @param {boolean} [isDeleted] ignored deleted items
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportingApiCalls: function (limit_1, id_1, subAccountId_1, createdBy_1, createdAtMax_1, createdAtMin_1, isDeleted_1, offset_1, sortBy_1, order_1) {
            var args_1 = [];
            for (var _i = 10; _i < arguments.length; _i++) {
                args_1[_i - 10] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, subAccountId_1, createdBy_1, createdAtMax_1, createdAtMin_1, isDeleted_1, offset_1, sortBy_1, order_1], args_1, true), void 0, function (limit, id, subAccountId, createdBy, createdAtMax, createdAtMin, isDeleted, offset, sortBy, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getReportingApiCalls', 'limit', limit);
                            localVarPath = "/reportingApiCalls";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (subAccountId) {
                                localVarQueryParameter['subAccountId'] = subAccountId;
                            }
                            if (createdBy) {
                                localVarQueryParameter['createdBy'] = createdBy.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (createdAtMax !== undefined) {
                                localVarQueryParameter['createdAtMax'] = (createdAtMax instanceof Date) ?
                                    createdAtMax.toISOString() :
                                    createdAtMax;
                            }
                            if (createdAtMin !== undefined) {
                                localVarQueryParameter['createdAtMin'] = (createdAtMin instanceof Date) ?
                                    createdAtMin.toISOString() :
                                    createdAtMin;
                            }
                            if (isDeleted !== undefined) {
                                localVarQueryParameter['isDeleted'] = isDeleted;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ReportingAPICallsApiAxiosParamCreator = ReportingAPICallsApiAxiosParamCreator;
/**
 * ReportingAPICallsApi - functional programming interface
 * @export
 */
var ReportingAPICallsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ReportingAPICallsApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create a Reporting Api Call
         * @summary Create a ReportingApiCall
         * @param {ReportingApiCallCreateData} [reportingApiCallCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReportingApiCall: function (reportingApiCallCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createReportingApiCall(reportingApiCallCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ReportingAPICallsApi.createReportingApiCall']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get Reporting API Calls
         * @summary Get Reporting API Calls
         * @param {number} limit limit results
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<number>} [subAccountId] A comma separated list of sub account ids
         * @param {Array<string>} [createdBy] comma separated list of uuids
         * @param {Date} [createdAtMax] latest bound to look at for creation date
         * @param {Date} [createdAtMin] earliest bound to look at for creation date
         * @param {boolean} [isDeleted] ignored deleted items
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportingApiCalls: function (limit, id, subAccountId, createdBy, createdAtMax, createdAtMin, isDeleted, offset, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getReportingApiCalls(limit, id, subAccountId, createdBy, createdAtMax, createdAtMin, isDeleted, offset, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ReportingAPICallsApi.getReportingApiCalls']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.ReportingAPICallsApiFp = ReportingAPICallsApiFp;
/**
 * ReportingAPICallsApi - factory interface
 * @export
 */
var ReportingAPICallsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ReportingAPICallsApiFp)(configuration);
    return {
        /**
         * Create a Reporting Api Call
         * @summary Create a ReportingApiCall
         * @param {ReportingAPICallsApiCreateReportingApiCallRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createReportingApiCall: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createReportingApiCall(requestParameters.reportingApiCallCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get Reporting API Calls
         * @summary Get Reporting API Calls
         * @param {ReportingAPICallsApiGetReportingApiCallsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReportingApiCalls: function (requestParameters, options) {
            return localVarFp.getReportingApiCalls(requestParameters.limit, requestParameters.id, requestParameters.subAccountId, requestParameters.createdBy, requestParameters.createdAtMax, requestParameters.createdAtMin, requestParameters.isDeleted, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ReportingAPICallsApiFactory = ReportingAPICallsApiFactory;
/**
 * ReportingAPICallsApi - object-oriented interface
 * @export
 * @class ReportingAPICallsApi
 * @extends {BaseAPI}
 */
var ReportingAPICallsApi = /** @class */ (function (_super) {
    __extends(ReportingAPICallsApi, _super);
    function ReportingAPICallsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a Reporting Api Call
     * @summary Create a ReportingApiCall
     * @param {ReportingAPICallsApiCreateReportingApiCallRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingAPICallsApi
     */
    ReportingAPICallsApi.prototype.createReportingApiCall = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ReportingAPICallsApiFp)(this.configuration).createReportingApiCall(requestParameters.reportingApiCallCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get Reporting API Calls
     * @summary Get Reporting API Calls
     * @param {ReportingAPICallsApiGetReportingApiCallsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingAPICallsApi
     */
    ReportingAPICallsApi.prototype.getReportingApiCalls = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ReportingAPICallsApiFp)(this.configuration).getReportingApiCalls(requestParameters.limit, requestParameters.id, requestParameters.subAccountId, requestParameters.createdBy, requestParameters.createdAtMax, requestParameters.createdAtMin, requestParameters.isDeleted, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ReportingAPICallsApi;
}(base_1.BaseAPI));
exports.ReportingAPICallsApi = ReportingAPICallsApi;
/**
 * SaasFeeApi - axios parameter creator
 * @export
 */
var SaasFeeApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create a Saas fee
         * @summary Create a Saas fee
         * @param {SaasFeeCreateData} [saasFeeCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSaasFee: function (saasFeeCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([saasFeeCreateData_1], args_1, true), void 0, function (saasFeeCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/saasFees";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(saasFeeCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get Saas fees
         * @summary Get Saas fees
         * @param {number} limit
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<string>} [uuid] A comma separated list of uuids
         * @param {Array<SaasFeeReason>} [reason]
         * @param {Array<string>} [accessTokenUuid]
         * @param {Array<number>} [accountId] A comma separated list of account ids
         * @param {Array<string>} [createdBy] comma separated list of uuids
         * @param {Date} [createdAtMin] earliest bound to look at for creation date
         * @param {Date} [createdAtMax] latest bound to look at for creation date
         * @param {Array<string>} [updatedBy]
         * @param {Date} [updatedAtMin]
         * @param {Date} [updatedAtMax]
         * @param {Array<string>} [deletedBy] comma separated list of uuids
         * @param {Date} [deletedAtMin] earliest bound for deletion date
         * @param {Date} [deletedAtMax] latest bound for deletion date
         * @param {boolean} [includeDeleted]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaasFees: function (limit_1, id_1, uuid_1, reason_1, accessTokenUuid_1, accountId_1, createdBy_1, createdAtMin_1, createdAtMax_1, updatedBy_1, updatedAtMin_1, updatedAtMax_1, deletedBy_1, deletedAtMin_1, deletedAtMax_1, includeDeleted_1, offset_1, sortBy_1, order_1) {
            var args_1 = [];
            for (var _i = 19; _i < arguments.length; _i++) {
                args_1[_i - 19] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, uuid_1, reason_1, accessTokenUuid_1, accountId_1, createdBy_1, createdAtMin_1, createdAtMax_1, updatedBy_1, updatedAtMin_1, updatedAtMax_1, deletedBy_1, deletedAtMin_1, deletedAtMax_1, includeDeleted_1, offset_1, sortBy_1, order_1], args_1, true), void 0, function (limit, id, uuid, reason, accessTokenUuid, accountId, createdBy, createdAtMin, createdAtMax, updatedBy, updatedAtMin, updatedAtMax, deletedBy, deletedAtMin, deletedAtMax, includeDeleted, offset, sortBy, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getSaasFees', 'limit', limit);
                            localVarPath = "/saasFees";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (uuid) {
                                localVarQueryParameter['uuid'] = uuid.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (reason) {
                                localVarQueryParameter['reason'] = reason;
                            }
                            if (accessTokenUuid) {
                                localVarQueryParameter['accessTokenUuid'] = accessTokenUuid;
                            }
                            if (accountId) {
                                localVarQueryParameter['accountId'] = accountId.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (createdBy) {
                                localVarQueryParameter['createdBy'] = createdBy.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (createdAtMin !== undefined) {
                                localVarQueryParameter['createdAtMin'] = (createdAtMin instanceof Date) ?
                                    createdAtMin.toISOString() :
                                    createdAtMin;
                            }
                            if (createdAtMax !== undefined) {
                                localVarQueryParameter['createdAtMax'] = (createdAtMax instanceof Date) ?
                                    createdAtMax.toISOString() :
                                    createdAtMax;
                            }
                            if (updatedBy) {
                                localVarQueryParameter['updatedBy'] = updatedBy;
                            }
                            if (updatedAtMin !== undefined) {
                                localVarQueryParameter['updatedAtMin'] = (updatedAtMin instanceof Date) ?
                                    updatedAtMin.toISOString() :
                                    updatedAtMin;
                            }
                            if (updatedAtMax !== undefined) {
                                localVarQueryParameter['updatedAtMax'] = (updatedAtMax instanceof Date) ?
                                    updatedAtMax.toISOString() :
                                    updatedAtMax;
                            }
                            if (deletedBy) {
                                localVarQueryParameter['deletedBy'] = deletedBy.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (deletedAtMin !== undefined) {
                                localVarQueryParameter['deletedAtMin'] = (deletedAtMin instanceof Date) ?
                                    deletedAtMin.toISOString() :
                                    deletedAtMin;
                            }
                            if (deletedAtMax !== undefined) {
                                localVarQueryParameter['deletedAtMax'] = (deletedAtMax instanceof Date) ?
                                    deletedAtMax.toISOString() :
                                    deletedAtMax;
                            }
                            if (includeDeleted !== undefined) {
                                localVarQueryParameter['includeDeleted'] = includeDeleted;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SaasFeeApiAxiosParamCreator = SaasFeeApiAxiosParamCreator;
/**
 * SaasFeeApi - functional programming interface
 * @export
 */
var SaasFeeApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SaasFeeApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create a Saas fee
         * @summary Create a Saas fee
         * @param {SaasFeeCreateData} [saasFeeCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSaasFee: function (saasFeeCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSaasFee(saasFeeCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SaasFeeApi.createSaasFee']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get Saas fees
         * @summary Get Saas fees
         * @param {number} limit
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<string>} [uuid] A comma separated list of uuids
         * @param {Array<SaasFeeReason>} [reason]
         * @param {Array<string>} [accessTokenUuid]
         * @param {Array<number>} [accountId] A comma separated list of account ids
         * @param {Array<string>} [createdBy] comma separated list of uuids
         * @param {Date} [createdAtMin] earliest bound to look at for creation date
         * @param {Date} [createdAtMax] latest bound to look at for creation date
         * @param {Array<string>} [updatedBy]
         * @param {Date} [updatedAtMin]
         * @param {Date} [updatedAtMax]
         * @param {Array<string>} [deletedBy] comma separated list of uuids
         * @param {Date} [deletedAtMin] earliest bound for deletion date
         * @param {Date} [deletedAtMax] latest bound for deletion date
         * @param {boolean} [includeDeleted]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaasFees: function (limit, id, uuid, reason, accessTokenUuid, accountId, createdBy, createdAtMin, createdAtMax, updatedBy, updatedAtMin, updatedAtMax, deletedBy, deletedAtMin, deletedAtMax, includeDeleted, offset, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSaasFees(limit, id, uuid, reason, accessTokenUuid, accountId, createdBy, createdAtMin, createdAtMax, updatedBy, updatedAtMin, updatedAtMax, deletedBy, deletedAtMin, deletedAtMax, includeDeleted, offset, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SaasFeeApi.getSaasFees']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.SaasFeeApiFp = SaasFeeApiFp;
/**
 * SaasFeeApi - factory interface
 * @export
 */
var SaasFeeApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SaasFeeApiFp)(configuration);
    return {
        /**
         * Create a Saas fee
         * @summary Create a Saas fee
         * @param {SaasFeeApiCreateSaasFeeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSaasFee: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createSaasFee(requestParameters.saasFeeCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get Saas fees
         * @summary Get Saas fees
         * @param {SaasFeeApiGetSaasFeesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaasFees: function (requestParameters, options) {
            return localVarFp.getSaasFees(requestParameters.limit, requestParameters.id, requestParameters.uuid, requestParameters.reason, requestParameters.accessTokenUuid, requestParameters.accountId, requestParameters.createdBy, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.updatedBy, requestParameters.updatedAtMin, requestParameters.updatedAtMax, requestParameters.deletedBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.includeDeleted, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SaasFeeApiFactory = SaasFeeApiFactory;
/**
 * SaasFeeApi - object-oriented interface
 * @export
 * @class SaasFeeApi
 * @extends {BaseAPI}
 */
var SaasFeeApi = /** @class */ (function (_super) {
    __extends(SaasFeeApi, _super);
    function SaasFeeApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a Saas fee
     * @summary Create a Saas fee
     * @param {SaasFeeApiCreateSaasFeeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SaasFeeApi
     */
    SaasFeeApi.prototype.createSaasFee = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.SaasFeeApiFp)(this.configuration).createSaasFee(requestParameters.saasFeeCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get Saas fees
     * @summary Get Saas fees
     * @param {SaasFeeApiGetSaasFeesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SaasFeeApi
     */
    SaasFeeApi.prototype.getSaasFees = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SaasFeeApiFp)(this.configuration).getSaasFees(requestParameters.limit, requestParameters.id, requestParameters.uuid, requestParameters.reason, requestParameters.accessTokenUuid, requestParameters.accountId, requestParameters.createdBy, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.updatedBy, requestParameters.updatedAtMin, requestParameters.updatedAtMax, requestParameters.deletedBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.includeDeleted, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SaasFeeApi;
}(base_1.BaseAPI));
exports.SaasFeeApi = SaasFeeApi;
/**
 * SaasFeeCouponApi - axios parameter creator
 * @export
 */
var SaasFeeCouponApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create a Saas Fee Coupon
         * @summary Create a Saas Fee Coupon
         * @param {SaasFeeCouponCreateData} [saasFeeCouponCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSaasFeeCoupon: function (saasFeeCouponCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([saasFeeCouponCreateData_1], args_1, true), void 0, function (saasFeeCouponCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/saasFeeCoupons";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(saasFeeCouponCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a Saas Fee Coupon
         * @summary Delete a Saas Fee Coupon
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSaasFeeCoupon: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteSaasFeeCoupon', 'id', id);
                            localVarPath = "/saasFeeCoupons/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get Saas Fee Coupons
         * @summary Get Saas Fee Coupons
         * @param {number} limit
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<string>} [uuid] A comma separated list of uuids
         * @param {Array<number>} [accountId] A comma separated list of account ids
         * @param {Date} [appliedAtMin]
         * @param {Date} [appliedAtMax]
         * @param {Array<string>} [createdBy] comma separated list of uuids
         * @param {Date} [createdAtMin] earliest bound to look at for creation date
         * @param {Date} [createdAtMax] latest bound to look at for creation date
         * @param {Array<string>} [updatedBy]
         * @param {Date} [updatedAtMin]
         * @param {Date} [updatedAtMax]
         * @param {Array<string>} [deletedBy] comma separated list of uuids
         * @param {Date} [deletedAtMin] earliest bound for deletion date
         * @param {Date} [deletedAtMax] latest bound for deletion date
         * @param {boolean} [isDeleted] ignored deleted items
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaasFeeCoupons: function (limit_1, id_1, uuid_1, accountId_1, appliedAtMin_1, appliedAtMax_1, createdBy_1, createdAtMin_1, createdAtMax_1, updatedBy_1, updatedAtMin_1, updatedAtMax_1, deletedBy_1, deletedAtMin_1, deletedAtMax_1, isDeleted_1, offset_1, sortBy_1, order_1) {
            var args_1 = [];
            for (var _i = 19; _i < arguments.length; _i++) {
                args_1[_i - 19] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, uuid_1, accountId_1, appliedAtMin_1, appliedAtMax_1, createdBy_1, createdAtMin_1, createdAtMax_1, updatedBy_1, updatedAtMin_1, updatedAtMax_1, deletedBy_1, deletedAtMin_1, deletedAtMax_1, isDeleted_1, offset_1, sortBy_1, order_1], args_1, true), void 0, function (limit, id, uuid, accountId, appliedAtMin, appliedAtMax, createdBy, createdAtMin, createdAtMax, updatedBy, updatedAtMin, updatedAtMax, deletedBy, deletedAtMin, deletedAtMax, isDeleted, offset, sortBy, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getSaasFeeCoupons', 'limit', limit);
                            localVarPath = "/saasFeeCoupons";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (uuid) {
                                localVarQueryParameter['uuid'] = uuid.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (accountId) {
                                localVarQueryParameter['accountId'] = accountId.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (appliedAtMin !== undefined) {
                                localVarQueryParameter['appliedAtMin'] = (appliedAtMin instanceof Date) ?
                                    appliedAtMin.toISOString() :
                                    appliedAtMin;
                            }
                            if (appliedAtMax !== undefined) {
                                localVarQueryParameter['appliedAtMax'] = (appliedAtMax instanceof Date) ?
                                    appliedAtMax.toISOString() :
                                    appliedAtMax;
                            }
                            if (createdBy) {
                                localVarQueryParameter['createdBy'] = createdBy.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (createdAtMin !== undefined) {
                                localVarQueryParameter['createdAtMin'] = (createdAtMin instanceof Date) ?
                                    createdAtMin.toISOString() :
                                    createdAtMin;
                            }
                            if (createdAtMax !== undefined) {
                                localVarQueryParameter['createdAtMax'] = (createdAtMax instanceof Date) ?
                                    createdAtMax.toISOString() :
                                    createdAtMax;
                            }
                            if (updatedBy) {
                                localVarQueryParameter['updatedBy'] = updatedBy;
                            }
                            if (updatedAtMin !== undefined) {
                                localVarQueryParameter['updatedAtMin'] = (updatedAtMin instanceof Date) ?
                                    updatedAtMin.toISOString() :
                                    updatedAtMin;
                            }
                            if (updatedAtMax !== undefined) {
                                localVarQueryParameter['updatedAtMax'] = (updatedAtMax instanceof Date) ?
                                    updatedAtMax.toISOString() :
                                    updatedAtMax;
                            }
                            if (deletedBy) {
                                localVarQueryParameter['deletedBy'] = deletedBy.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (deletedAtMin !== undefined) {
                                localVarQueryParameter['deletedAtMin'] = (deletedAtMin instanceof Date) ?
                                    deletedAtMin.toISOString() :
                                    deletedAtMin;
                            }
                            if (deletedAtMax !== undefined) {
                                localVarQueryParameter['deletedAtMax'] = (deletedAtMax instanceof Date) ?
                                    deletedAtMax.toISOString() :
                                    deletedAtMax;
                            }
                            if (isDeleted !== undefined) {
                                localVarQueryParameter['isDeleted'] = isDeleted;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SaasFeeCouponApiAxiosParamCreator = SaasFeeCouponApiAxiosParamCreator;
/**
 * SaasFeeCouponApi - functional programming interface
 * @export
 */
var SaasFeeCouponApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SaasFeeCouponApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create a Saas Fee Coupon
         * @summary Create a Saas Fee Coupon
         * @param {SaasFeeCouponCreateData} [saasFeeCouponCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSaasFeeCoupon: function (saasFeeCouponCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSaasFeeCoupon(saasFeeCouponCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SaasFeeCouponApi.createSaasFeeCoupon']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete a Saas Fee Coupon
         * @summary Delete a Saas Fee Coupon
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSaasFeeCoupon: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteSaasFeeCoupon(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SaasFeeCouponApi.deleteSaasFeeCoupon']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get Saas Fee Coupons
         * @summary Get Saas Fee Coupons
         * @param {number} limit
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<string>} [uuid] A comma separated list of uuids
         * @param {Array<number>} [accountId] A comma separated list of account ids
         * @param {Date} [appliedAtMin]
         * @param {Date} [appliedAtMax]
         * @param {Array<string>} [createdBy] comma separated list of uuids
         * @param {Date} [createdAtMin] earliest bound to look at for creation date
         * @param {Date} [createdAtMax] latest bound to look at for creation date
         * @param {Array<string>} [updatedBy]
         * @param {Date} [updatedAtMin]
         * @param {Date} [updatedAtMax]
         * @param {Array<string>} [deletedBy] comma separated list of uuids
         * @param {Date} [deletedAtMin] earliest bound for deletion date
         * @param {Date} [deletedAtMax] latest bound for deletion date
         * @param {boolean} [isDeleted] ignored deleted items
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaasFeeCoupons: function (limit, id, uuid, accountId, appliedAtMin, appliedAtMax, createdBy, createdAtMin, createdAtMax, updatedBy, updatedAtMin, updatedAtMax, deletedBy, deletedAtMin, deletedAtMax, isDeleted, offset, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSaasFeeCoupons(limit, id, uuid, accountId, appliedAtMin, appliedAtMax, createdBy, createdAtMin, createdAtMax, updatedBy, updatedAtMin, updatedAtMax, deletedBy, deletedAtMin, deletedAtMax, isDeleted, offset, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SaasFeeCouponApi.getSaasFeeCoupons']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.SaasFeeCouponApiFp = SaasFeeCouponApiFp;
/**
 * SaasFeeCouponApi - factory interface
 * @export
 */
var SaasFeeCouponApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SaasFeeCouponApiFp)(configuration);
    return {
        /**
         * Create a Saas Fee Coupon
         * @summary Create a Saas Fee Coupon
         * @param {SaasFeeCouponApiCreateSaasFeeCouponRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSaasFeeCoupon: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createSaasFeeCoupon(requestParameters.saasFeeCouponCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a Saas Fee Coupon
         * @summary Delete a Saas Fee Coupon
         * @param {SaasFeeCouponApiDeleteSaasFeeCouponRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSaasFeeCoupon: function (requestParameters, options) {
            return localVarFp.deleteSaasFeeCoupon(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get Saas Fee Coupons
         * @summary Get Saas Fee Coupons
         * @param {SaasFeeCouponApiGetSaasFeeCouponsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaasFeeCoupons: function (requestParameters, options) {
            return localVarFp.getSaasFeeCoupons(requestParameters.limit, requestParameters.id, requestParameters.uuid, requestParameters.accountId, requestParameters.appliedAtMin, requestParameters.appliedAtMax, requestParameters.createdBy, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.updatedBy, requestParameters.updatedAtMin, requestParameters.updatedAtMax, requestParameters.deletedBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.isDeleted, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SaasFeeCouponApiFactory = SaasFeeCouponApiFactory;
/**
 * SaasFeeCouponApi - object-oriented interface
 * @export
 * @class SaasFeeCouponApi
 * @extends {BaseAPI}
 */
var SaasFeeCouponApi = /** @class */ (function (_super) {
    __extends(SaasFeeCouponApi, _super);
    function SaasFeeCouponApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a Saas Fee Coupon
     * @summary Create a Saas Fee Coupon
     * @param {SaasFeeCouponApiCreateSaasFeeCouponRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SaasFeeCouponApi
     */
    SaasFeeCouponApi.prototype.createSaasFeeCoupon = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.SaasFeeCouponApiFp)(this.configuration).createSaasFeeCoupon(requestParameters.saasFeeCouponCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a Saas Fee Coupon
     * @summary Delete a Saas Fee Coupon
     * @param {SaasFeeCouponApiDeleteSaasFeeCouponRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SaasFeeCouponApi
     */
    SaasFeeCouponApi.prototype.deleteSaasFeeCoupon = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SaasFeeCouponApiFp)(this.configuration).deleteSaasFeeCoupon(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get Saas Fee Coupons
     * @summary Get Saas Fee Coupons
     * @param {SaasFeeCouponApiGetSaasFeeCouponsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SaasFeeCouponApi
     */
    SaasFeeCouponApi.prototype.getSaasFeeCoupons = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SaasFeeCouponApiFp)(this.configuration).getSaasFeeCoupons(requestParameters.limit, requestParameters.id, requestParameters.uuid, requestParameters.accountId, requestParameters.appliedAtMin, requestParameters.appliedAtMax, requestParameters.createdBy, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.updatedBy, requestParameters.updatedAtMin, requestParameters.updatedAtMax, requestParameters.deletedBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.isDeleted, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SaasFeeCouponApi;
}(base_1.BaseAPI));
exports.SaasFeeCouponApi = SaasFeeCouponApi;
/**
 * SaasMigrationApi - axios parameter creator
 * @export
 */
var SaasMigrationApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create a SaaS migration
         * @summary Create a SaaS migration
         * @param {SaasMigrationCreateData} [saasMigrationCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSaasMigration: function (saasMigrationCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([saasMigrationCreateData_1], args_1, true), void 0, function (saasMigrationCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/saasMigrations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(saasMigrationCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create a SaaS migration setting
         * @summary Create a SaaS migration setting
         * @param {SaasMigrationSettingCreateData} [saasMigrationSettingCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSaasMigrationSetting: function (saasMigrationSettingCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([saasMigrationSettingCreateData_1], args_1, true), void 0, function (saasMigrationSettingCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/saasMigrationSettings";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(saasMigrationSettingCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get SaaS migration
         * @summary Get SaaS migration
         * @param {number} limit limit results
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<string>} [uuid] A comma separated list of uuids
         * @param {number} [saasMigrationSettingId] unique identifier for a saas migration setting
         * @param {boolean} [isDeleted] ignored deleted items
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaasMigration: function (limit_1, id_1, uuid_1, saasMigrationSettingId_1, isDeleted_1, offset_1, sortBy_1, order_1) {
            var args_1 = [];
            for (var _i = 8; _i < arguments.length; _i++) {
                args_1[_i - 8] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, uuid_1, saasMigrationSettingId_1, isDeleted_1, offset_1, sortBy_1, order_1], args_1, true), void 0, function (limit, id, uuid, saasMigrationSettingId, isDeleted, offset, sortBy, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getSaasMigration', 'limit', limit);
                            localVarPath = "/saasMigrations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (uuid) {
                                localVarQueryParameter['uuid'] = uuid.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (saasMigrationSettingId !== undefined) {
                                localVarQueryParameter['saasMigrationSettingId'] = saasMigrationSettingId;
                            }
                            if (isDeleted !== undefined) {
                                localVarQueryParameter['isDeleted'] = isDeleted;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get SaaS migration settings
         * @summary Get SaaS migration settings
         * @param {number} limit limit results
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<string>} [uuid] A comma separated list of uuids
         * @param {Array<number>} [accountId] A comma separated list of account ids
         * @param {boolean} [isDeleted] ignored deleted items
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaasMigrationSettings: function (limit_1, id_1, uuid_1, accountId_1, isDeleted_1, offset_1, sortBy_1, order_1) {
            var args_1 = [];
            for (var _i = 8; _i < arguments.length; _i++) {
                args_1[_i - 8] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, uuid_1, accountId_1, isDeleted_1, offset_1, sortBy_1, order_1], args_1, true), void 0, function (limit, id, uuid, accountId, isDeleted, offset, sortBy, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getSaasMigrationSettings', 'limit', limit);
                            localVarPath = "/saasMigrationSettings";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (uuid) {
                                localVarQueryParameter['uuid'] = uuid.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (accountId) {
                                localVarQueryParameter['accountId'] = accountId.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (isDeleted !== undefined) {
                                localVarQueryParameter['isDeleted'] = isDeleted;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SaasMigrationApiAxiosParamCreator = SaasMigrationApiAxiosParamCreator;
/**
 * SaasMigrationApi - functional programming interface
 * @export
 */
var SaasMigrationApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SaasMigrationApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create a SaaS migration
         * @summary Create a SaaS migration
         * @param {SaasMigrationCreateData} [saasMigrationCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSaasMigration: function (saasMigrationCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSaasMigration(saasMigrationCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SaasMigrationApi.createSaasMigration']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Create a SaaS migration setting
         * @summary Create a SaaS migration setting
         * @param {SaasMigrationSettingCreateData} [saasMigrationSettingCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSaasMigrationSetting: function (saasMigrationSettingCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSaasMigrationSetting(saasMigrationSettingCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SaasMigrationApi.createSaasMigrationSetting']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get SaaS migration
         * @summary Get SaaS migration
         * @param {number} limit limit results
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<string>} [uuid] A comma separated list of uuids
         * @param {number} [saasMigrationSettingId] unique identifier for a saas migration setting
         * @param {boolean} [isDeleted] ignored deleted items
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaasMigration: function (limit, id, uuid, saasMigrationSettingId, isDeleted, offset, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSaasMigration(limit, id, uuid, saasMigrationSettingId, isDeleted, offset, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SaasMigrationApi.getSaasMigration']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get SaaS migration settings
         * @summary Get SaaS migration settings
         * @param {number} limit limit results
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<string>} [uuid] A comma separated list of uuids
         * @param {Array<number>} [accountId] A comma separated list of account ids
         * @param {boolean} [isDeleted] ignored deleted items
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaasMigrationSettings: function (limit, id, uuid, accountId, isDeleted, offset, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSaasMigrationSettings(limit, id, uuid, accountId, isDeleted, offset, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SaasMigrationApi.getSaasMigrationSettings']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.SaasMigrationApiFp = SaasMigrationApiFp;
/**
 * SaasMigrationApi - factory interface
 * @export
 */
var SaasMigrationApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SaasMigrationApiFp)(configuration);
    return {
        /**
         * Create a SaaS migration
         * @summary Create a SaaS migration
         * @param {SaasMigrationApiCreateSaasMigrationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSaasMigration: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createSaasMigration(requestParameters.saasMigrationCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create a SaaS migration setting
         * @summary Create a SaaS migration setting
         * @param {SaasMigrationApiCreateSaasMigrationSettingRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSaasMigrationSetting: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createSaasMigrationSetting(requestParameters.saasMigrationSettingCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get SaaS migration
         * @summary Get SaaS migration
         * @param {SaasMigrationApiGetSaasMigrationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaasMigration: function (requestParameters, options) {
            return localVarFp.getSaasMigration(requestParameters.limit, requestParameters.id, requestParameters.uuid, requestParameters.saasMigrationSettingId, requestParameters.isDeleted, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get SaaS migration settings
         * @summary Get SaaS migration settings
         * @param {SaasMigrationApiGetSaasMigrationSettingsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaasMigrationSettings: function (requestParameters, options) {
            return localVarFp.getSaasMigrationSettings(requestParameters.limit, requestParameters.id, requestParameters.uuid, requestParameters.accountId, requestParameters.isDeleted, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SaasMigrationApiFactory = SaasMigrationApiFactory;
/**
 * SaasMigrationApi - object-oriented interface
 * @export
 * @class SaasMigrationApi
 * @extends {BaseAPI}
 */
var SaasMigrationApi = /** @class */ (function (_super) {
    __extends(SaasMigrationApi, _super);
    function SaasMigrationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a SaaS migration
     * @summary Create a SaaS migration
     * @param {SaasMigrationApiCreateSaasMigrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SaasMigrationApi
     */
    SaasMigrationApi.prototype.createSaasMigration = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.SaasMigrationApiFp)(this.configuration).createSaasMigration(requestParameters.saasMigrationCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create a SaaS migration setting
     * @summary Create a SaaS migration setting
     * @param {SaasMigrationApiCreateSaasMigrationSettingRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SaasMigrationApi
     */
    SaasMigrationApi.prototype.createSaasMigrationSetting = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.SaasMigrationApiFp)(this.configuration).createSaasMigrationSetting(requestParameters.saasMigrationSettingCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get SaaS migration
     * @summary Get SaaS migration
     * @param {SaasMigrationApiGetSaasMigrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SaasMigrationApi
     */
    SaasMigrationApi.prototype.getSaasMigration = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SaasMigrationApiFp)(this.configuration).getSaasMigration(requestParameters.limit, requestParameters.id, requestParameters.uuid, requestParameters.saasMigrationSettingId, requestParameters.isDeleted, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get SaaS migration settings
     * @summary Get SaaS migration settings
     * @param {SaasMigrationApiGetSaasMigrationSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SaasMigrationApi
     */
    SaasMigrationApi.prototype.getSaasMigrationSettings = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SaasMigrationApiFp)(this.configuration).getSaasMigrationSettings(requestParameters.limit, requestParameters.id, requestParameters.uuid, requestParameters.accountId, requestParameters.isDeleted, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SaasMigrationApi;
}(base_1.BaseAPI));
exports.SaasMigrationApi = SaasMigrationApi;
/**
 * SaasMigrationSettingApi - axios parameter creator
 * @export
 */
var SaasMigrationSettingApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get settings for a migrated user
         * @summary Get settings for a migrated user
         * @param {string} accountUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSetingForMigratedUser: function (accountUuid_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accountUuid_1], args_1, true), void 0, function (accountUuid, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'accountUuid' is not null or undefined
                            (0, common_1.assertParamExists)('getSetingForMigratedUser', 'accountUuid', accountUuid);
                            localVarPath = "/settingForMigratedUsers/{accountUuid}"
                                .replace("{".concat("accountUuid", "}"), encodeURIComponent(String(accountUuid)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SaasMigrationSettingApiAxiosParamCreator = SaasMigrationSettingApiAxiosParamCreator;
/**
 * SaasMigrationSettingApi - functional programming interface
 * @export
 */
var SaasMigrationSettingApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SaasMigrationSettingApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get settings for a migrated user
         * @summary Get settings for a migrated user
         * @param {string} accountUuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSetingForMigratedUser: function (accountUuid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSetingForMigratedUser(accountUuid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SaasMigrationSettingApi.getSetingForMigratedUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.SaasMigrationSettingApiFp = SaasMigrationSettingApiFp;
/**
 * SaasMigrationSettingApi - factory interface
 * @export
 */
var SaasMigrationSettingApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SaasMigrationSettingApiFp)(configuration);
    return {
        /**
         * Get settings for a migrated user
         * @summary Get settings for a migrated user
         * @param {SaasMigrationSettingApiGetSetingForMigratedUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSetingForMigratedUser: function (requestParameters, options) {
            return localVarFp.getSetingForMigratedUser(requestParameters.accountUuid, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SaasMigrationSettingApiFactory = SaasMigrationSettingApiFactory;
/**
 * SaasMigrationSettingApi - object-oriented interface
 * @export
 * @class SaasMigrationSettingApi
 * @extends {BaseAPI}
 */
var SaasMigrationSettingApi = /** @class */ (function (_super) {
    __extends(SaasMigrationSettingApi, _super);
    function SaasMigrationSettingApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get settings for a migrated user
     * @summary Get settings for a migrated user
     * @param {SaasMigrationSettingApiGetSetingForMigratedUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SaasMigrationSettingApi
     */
    SaasMigrationSettingApi.prototype.getSetingForMigratedUser = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SaasMigrationSettingApiFp)(this.configuration).getSetingForMigratedUser(requestParameters.accountUuid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SaasMigrationSettingApi;
}(base_1.BaseAPI));
exports.SaasMigrationSettingApi = SaasMigrationSettingApi;
/**
 * SaasPlanApi - axios parameter creator
 * @export
 */
var SaasPlanApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create a Saas plan
         * @summary Create a Saas plan
         * @param {SaasPlanCreateData} [saasPlanCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSaasPlan: function (saasPlanCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([saasPlanCreateData_1], args_1, true), void 0, function (saasPlanCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/saasPlans";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(saasPlanCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a Saas plan
         * @summary Delete a Saas plan
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSaasPlan: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteSaasPlan', 'id', id);
                            localVarPath = "/saasPlans/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get Saas plans
         * @summary Get Saas plans
         * @param {number} limit
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<string>} [uuid] A comma separated list of uuids
         * @param {Array<AccountTierType>} [tier]
         * @param {number} [customForAccountId]
         * @param {Array<string>} [createdBy] comma separated list of uuids
         * @param {Date} [createdAtMin] earliest bound to look at for creation date
         * @param {Date} [createdAtMax] latest bound to look at for creation date
         * @param {Array<string>} [updatedBy]
         * @param {Date} [updatedAtMin]
         * @param {Date} [updatedAtMax]
         * @param {Array<string>} [deletedBy] comma separated list of uuids
         * @param {Date} [deletedAtMin] earliest bound for deletion date
         * @param {Date} [deletedAtMax] latest bound for deletion date
         * @param {boolean} [includeDeleted]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaasPlans: function (limit_1, id_1, uuid_1, tier_1, customForAccountId_1, createdBy_1, createdAtMin_1, createdAtMax_1, updatedBy_1, updatedAtMin_1, updatedAtMax_1, deletedBy_1, deletedAtMin_1, deletedAtMax_1, includeDeleted_1, offset_1, sortBy_1, order_1) {
            var args_1 = [];
            for (var _i = 18; _i < arguments.length; _i++) {
                args_1[_i - 18] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, uuid_1, tier_1, customForAccountId_1, createdBy_1, createdAtMin_1, createdAtMax_1, updatedBy_1, updatedAtMin_1, updatedAtMax_1, deletedBy_1, deletedAtMin_1, deletedAtMax_1, includeDeleted_1, offset_1, sortBy_1, order_1], args_1, true), void 0, function (limit, id, uuid, tier, customForAccountId, createdBy, createdAtMin, createdAtMax, updatedBy, updatedAtMin, updatedAtMax, deletedBy, deletedAtMin, deletedAtMax, includeDeleted, offset, sortBy, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getSaasPlans', 'limit', limit);
                            localVarPath = "/saasPlans";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (uuid) {
                                localVarQueryParameter['uuid'] = uuid.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (tier) {
                                localVarQueryParameter['tier'] = tier;
                            }
                            if (customForAccountId !== undefined) {
                                localVarQueryParameter['customForAccountId'] = customForAccountId;
                            }
                            if (createdBy) {
                                localVarQueryParameter['createdBy'] = createdBy.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (createdAtMin !== undefined) {
                                localVarQueryParameter['createdAtMin'] = (createdAtMin instanceof Date) ?
                                    createdAtMin.toISOString() :
                                    createdAtMin;
                            }
                            if (createdAtMax !== undefined) {
                                localVarQueryParameter['createdAtMax'] = (createdAtMax instanceof Date) ?
                                    createdAtMax.toISOString() :
                                    createdAtMax;
                            }
                            if (updatedBy) {
                                localVarQueryParameter['updatedBy'] = updatedBy;
                            }
                            if (updatedAtMin !== undefined) {
                                localVarQueryParameter['updatedAtMin'] = (updatedAtMin instanceof Date) ?
                                    updatedAtMin.toISOString() :
                                    updatedAtMin;
                            }
                            if (updatedAtMax !== undefined) {
                                localVarQueryParameter['updatedAtMax'] = (updatedAtMax instanceof Date) ?
                                    updatedAtMax.toISOString() :
                                    updatedAtMax;
                            }
                            if (deletedBy) {
                                localVarQueryParameter['deletedBy'] = deletedBy.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (deletedAtMin !== undefined) {
                                localVarQueryParameter['deletedAtMin'] = (deletedAtMin instanceof Date) ?
                                    deletedAtMin.toISOString() :
                                    deletedAtMin;
                            }
                            if (deletedAtMax !== undefined) {
                                localVarQueryParameter['deletedAtMax'] = (deletedAtMax instanceof Date) ?
                                    deletedAtMax.toISOString() :
                                    deletedAtMax;
                            }
                            if (includeDeleted !== undefined) {
                                localVarQueryParameter['includeDeleted'] = includeDeleted;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SaasPlanApiAxiosParamCreator = SaasPlanApiAxiosParamCreator;
/**
 * SaasPlanApi - functional programming interface
 * @export
 */
var SaasPlanApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SaasPlanApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create a Saas plan
         * @summary Create a Saas plan
         * @param {SaasPlanCreateData} [saasPlanCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSaasPlan: function (saasPlanCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSaasPlan(saasPlanCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SaasPlanApi.createSaasPlan']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete a Saas plan
         * @summary Delete a Saas plan
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSaasPlan: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteSaasPlan(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SaasPlanApi.deleteSaasPlan']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get Saas plans
         * @summary Get Saas plans
         * @param {number} limit
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<string>} [uuid] A comma separated list of uuids
         * @param {Array<AccountTierType>} [tier]
         * @param {number} [customForAccountId]
         * @param {Array<string>} [createdBy] comma separated list of uuids
         * @param {Date} [createdAtMin] earliest bound to look at for creation date
         * @param {Date} [createdAtMax] latest bound to look at for creation date
         * @param {Array<string>} [updatedBy]
         * @param {Date} [updatedAtMin]
         * @param {Date} [updatedAtMax]
         * @param {Array<string>} [deletedBy] comma separated list of uuids
         * @param {Date} [deletedAtMin] earliest bound for deletion date
         * @param {Date} [deletedAtMax] latest bound for deletion date
         * @param {boolean} [includeDeleted]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaasPlans: function (limit, id, uuid, tier, customForAccountId, createdBy, createdAtMin, createdAtMax, updatedBy, updatedAtMin, updatedAtMax, deletedBy, deletedAtMin, deletedAtMax, includeDeleted, offset, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSaasPlans(limit, id, uuid, tier, customForAccountId, createdBy, createdAtMin, createdAtMax, updatedBy, updatedAtMin, updatedAtMax, deletedBy, deletedAtMin, deletedAtMax, includeDeleted, offset, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SaasPlanApi.getSaasPlans']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.SaasPlanApiFp = SaasPlanApiFp;
/**
 * SaasPlanApi - factory interface
 * @export
 */
var SaasPlanApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SaasPlanApiFp)(configuration);
    return {
        /**
         * Create a Saas plan
         * @summary Create a Saas plan
         * @param {SaasPlanApiCreateSaasPlanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSaasPlan: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createSaasPlan(requestParameters.saasPlanCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a Saas plan
         * @summary Delete a Saas plan
         * @param {SaasPlanApiDeleteSaasPlanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSaasPlan: function (requestParameters, options) {
            return localVarFp.deleteSaasPlan(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get Saas plans
         * @summary Get Saas plans
         * @param {SaasPlanApiGetSaasPlansRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaasPlans: function (requestParameters, options) {
            return localVarFp.getSaasPlans(requestParameters.limit, requestParameters.id, requestParameters.uuid, requestParameters.tier, requestParameters.customForAccountId, requestParameters.createdBy, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.updatedBy, requestParameters.updatedAtMin, requestParameters.updatedAtMax, requestParameters.deletedBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.includeDeleted, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SaasPlanApiFactory = SaasPlanApiFactory;
/**
 * SaasPlanApi - object-oriented interface
 * @export
 * @class SaasPlanApi
 * @extends {BaseAPI}
 */
var SaasPlanApi = /** @class */ (function (_super) {
    __extends(SaasPlanApi, _super);
    function SaasPlanApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a Saas plan
     * @summary Create a Saas plan
     * @param {SaasPlanApiCreateSaasPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SaasPlanApi
     */
    SaasPlanApi.prototype.createSaasPlan = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.SaasPlanApiFp)(this.configuration).createSaasPlan(requestParameters.saasPlanCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a Saas plan
     * @summary Delete a Saas plan
     * @param {SaasPlanApiDeleteSaasPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SaasPlanApi
     */
    SaasPlanApi.prototype.deleteSaasPlan = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SaasPlanApiFp)(this.configuration).deleteSaasPlan(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get Saas plans
     * @summary Get Saas plans
     * @param {SaasPlanApiGetSaasPlansRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SaasPlanApi
     */
    SaasPlanApi.prototype.getSaasPlans = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SaasPlanApiFp)(this.configuration).getSaasPlans(requestParameters.limit, requestParameters.id, requestParameters.uuid, requestParameters.tier, requestParameters.customForAccountId, requestParameters.createdBy, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.updatedBy, requestParameters.updatedAtMin, requestParameters.updatedAtMax, requestParameters.deletedBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.includeDeleted, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SaasPlanApi;
}(base_1.BaseAPI));
exports.SaasPlanApi = SaasPlanApi;
/**
 * SaasSubscriptionApi - axios parameter creator
 * @export
 */
var SaasSubscriptionApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create a Saas subscription
         * @summary Create a Saas subscription
         * @param {SaasSubscriptionCreateData} [saasSubscriptionCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSaasSubscription: function (saasSubscriptionCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([saasSubscriptionCreateData_1], args_1, true), void 0, function (saasSubscriptionCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/saasSubscriptions";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(saasSubscriptionCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Create SaaS subscription preview
         * @summary Create SaaS subscription preview
         * @param {SaasSubscriptionCreateData} [saasSubscriptionCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSaasSubscriptionPreview: function (saasSubscriptionCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([saasSubscriptionCreateData_1], args_1, true), void 0, function (saasSubscriptionCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/saasSubscriptionPreviews";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(saasSubscriptionCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a Saas subscription
         * @summary Delete a Saas subscription
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSaasSubscription: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteSaasSubscription', 'id', id);
                            localVarPath = "/saasSubscriptions/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get Saas subscriptions
         * @summary Get Saas subscriptions
         * @param {number} limit
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<string>} [uuid] A comma separated list of uuids
         * @param {Array<number>} [accountId] A comma separated list of account ids
         * @param {Array<string>} [createdBy] comma separated list of uuids
         * @param {Date} [createdAtMin] earliest bound to look at for creation date
         * @param {Date} [createdAtMax] latest bound to look at for creation date
         * @param {Array<string>} [updatedBy]
         * @param {Date} [updatedAtMin]
         * @param {Date} [updatedAtMax]
         * @param {Array<string>} [deletedBy] comma separated list of uuids
         * @param {Date} [deletedAtMin] earliest bound for deletion date
         * @param {Date} [deletedAtMax] latest bound for deletion date
         * @param {boolean} [includeDeleted]
         * @param {Date} [lastPaymentAtMax]
         * @param {Date} [lastPaymentAtMin]
         * @param {string} [subscriptionStatus]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaasSubscriptions: function (limit_1, id_1, uuid_1, accountId_1, createdBy_1, createdAtMin_1, createdAtMax_1, updatedBy_1, updatedAtMin_1, updatedAtMax_1, deletedBy_1, deletedAtMin_1, deletedAtMax_1, includeDeleted_1, lastPaymentAtMax_1, lastPaymentAtMin_1, subscriptionStatus_1, offset_1, sortBy_1, order_1) {
            var args_1 = [];
            for (var _i = 20; _i < arguments.length; _i++) {
                args_1[_i - 20] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, uuid_1, accountId_1, createdBy_1, createdAtMin_1, createdAtMax_1, updatedBy_1, updatedAtMin_1, updatedAtMax_1, deletedBy_1, deletedAtMin_1, deletedAtMax_1, includeDeleted_1, lastPaymentAtMax_1, lastPaymentAtMin_1, subscriptionStatus_1, offset_1, sortBy_1, order_1], args_1, true), void 0, function (limit, id, uuid, accountId, createdBy, createdAtMin, createdAtMax, updatedBy, updatedAtMin, updatedAtMax, deletedBy, deletedAtMin, deletedAtMax, includeDeleted, lastPaymentAtMax, lastPaymentAtMin, subscriptionStatus, offset, sortBy, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getSaasSubscriptions', 'limit', limit);
                            localVarPath = "/saasSubscriptions";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (uuid) {
                                localVarQueryParameter['uuid'] = uuid.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (accountId) {
                                localVarQueryParameter['accountId'] = accountId.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (createdBy) {
                                localVarQueryParameter['createdBy'] = createdBy.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (createdAtMin !== undefined) {
                                localVarQueryParameter['createdAtMin'] = (createdAtMin instanceof Date) ?
                                    createdAtMin.toISOString() :
                                    createdAtMin;
                            }
                            if (createdAtMax !== undefined) {
                                localVarQueryParameter['createdAtMax'] = (createdAtMax instanceof Date) ?
                                    createdAtMax.toISOString() :
                                    createdAtMax;
                            }
                            if (updatedBy) {
                                localVarQueryParameter['updatedBy'] = updatedBy;
                            }
                            if (updatedAtMin !== undefined) {
                                localVarQueryParameter['updatedAtMin'] = (updatedAtMin instanceof Date) ?
                                    updatedAtMin.toISOString() :
                                    updatedAtMin;
                            }
                            if (updatedAtMax !== undefined) {
                                localVarQueryParameter['updatedAtMax'] = (updatedAtMax instanceof Date) ?
                                    updatedAtMax.toISOString() :
                                    updatedAtMax;
                            }
                            if (deletedBy) {
                                localVarQueryParameter['deletedBy'] = deletedBy.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (deletedAtMin !== undefined) {
                                localVarQueryParameter['deletedAtMin'] = (deletedAtMin instanceof Date) ?
                                    deletedAtMin.toISOString() :
                                    deletedAtMin;
                            }
                            if (deletedAtMax !== undefined) {
                                localVarQueryParameter['deletedAtMax'] = (deletedAtMax instanceof Date) ?
                                    deletedAtMax.toISOString() :
                                    deletedAtMax;
                            }
                            if (includeDeleted !== undefined) {
                                localVarQueryParameter['includeDeleted'] = includeDeleted;
                            }
                            if (lastPaymentAtMax !== undefined) {
                                localVarQueryParameter['lastPaymentAtMax'] = (lastPaymentAtMax instanceof Date) ?
                                    lastPaymentAtMax.toISOString() :
                                    lastPaymentAtMax;
                            }
                            if (lastPaymentAtMin !== undefined) {
                                localVarQueryParameter['lastPaymentAtMin'] = (lastPaymentAtMin instanceof Date) ?
                                    lastPaymentAtMin.toISOString() :
                                    lastPaymentAtMin;
                            }
                            if (subscriptionStatus !== undefined) {
                                localVarQueryParameter['subscriptionStatus'] = subscriptionStatus;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Updates the status of a saas subscription based on recurly events
         * @summary Update a saas subscription status
         * @param {SaasSubscriptionUpdateData} [saasSubscriptionUpdateData] Update saas subscription status and lastPayment data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStatusSubscription: function (saasSubscriptionUpdateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([saasSubscriptionUpdateData_1], args_1, true), void 0, function (saasSubscriptionUpdateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/saasSubscriptions";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(saasSubscriptionUpdateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SaasSubscriptionApiAxiosParamCreator = SaasSubscriptionApiAxiosParamCreator;
/**
 * SaasSubscriptionApi - functional programming interface
 * @export
 */
var SaasSubscriptionApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SaasSubscriptionApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create a Saas subscription
         * @summary Create a Saas subscription
         * @param {SaasSubscriptionCreateData} [saasSubscriptionCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSaasSubscription: function (saasSubscriptionCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSaasSubscription(saasSubscriptionCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SaasSubscriptionApi.createSaasSubscription']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Create SaaS subscription preview
         * @summary Create SaaS subscription preview
         * @param {SaasSubscriptionCreateData} [saasSubscriptionCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSaasSubscriptionPreview: function (saasSubscriptionCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSaasSubscriptionPreview(saasSubscriptionCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SaasSubscriptionApi.createSaasSubscriptionPreview']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete a Saas subscription
         * @summary Delete a Saas subscription
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSaasSubscription: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteSaasSubscription(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SaasSubscriptionApi.deleteSaasSubscription']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get Saas subscriptions
         * @summary Get Saas subscriptions
         * @param {number} limit
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<string>} [uuid] A comma separated list of uuids
         * @param {Array<number>} [accountId] A comma separated list of account ids
         * @param {Array<string>} [createdBy] comma separated list of uuids
         * @param {Date} [createdAtMin] earliest bound to look at for creation date
         * @param {Date} [createdAtMax] latest bound to look at for creation date
         * @param {Array<string>} [updatedBy]
         * @param {Date} [updatedAtMin]
         * @param {Date} [updatedAtMax]
         * @param {Array<string>} [deletedBy] comma separated list of uuids
         * @param {Date} [deletedAtMin] earliest bound for deletion date
         * @param {Date} [deletedAtMax] latest bound for deletion date
         * @param {boolean} [includeDeleted]
         * @param {Date} [lastPaymentAtMax]
         * @param {Date} [lastPaymentAtMin]
         * @param {string} [subscriptionStatus]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaasSubscriptions: function (limit, id, uuid, accountId, createdBy, createdAtMin, createdAtMax, updatedBy, updatedAtMin, updatedAtMax, deletedBy, deletedAtMin, deletedAtMax, includeDeleted, lastPaymentAtMax, lastPaymentAtMin, subscriptionStatus, offset, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSaasSubscriptions(limit, id, uuid, accountId, createdBy, createdAtMin, createdAtMax, updatedBy, updatedAtMin, updatedAtMax, deletedBy, deletedAtMin, deletedAtMax, includeDeleted, lastPaymentAtMax, lastPaymentAtMin, subscriptionStatus, offset, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SaasSubscriptionApi.getSaasSubscriptions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Updates the status of a saas subscription based on recurly events
         * @summary Update a saas subscription status
         * @param {SaasSubscriptionUpdateData} [saasSubscriptionUpdateData] Update saas subscription status and lastPayment data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStatusSubscription: function (saasSubscriptionUpdateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateStatusSubscription(saasSubscriptionUpdateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SaasSubscriptionApi.updateStatusSubscription']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.SaasSubscriptionApiFp = SaasSubscriptionApiFp;
/**
 * SaasSubscriptionApi - factory interface
 * @export
 */
var SaasSubscriptionApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SaasSubscriptionApiFp)(configuration);
    return {
        /**
         * Create a Saas subscription
         * @summary Create a Saas subscription
         * @param {SaasSubscriptionApiCreateSaasSubscriptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSaasSubscription: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createSaasSubscription(requestParameters.saasSubscriptionCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Create SaaS subscription preview
         * @summary Create SaaS subscription preview
         * @param {SaasSubscriptionApiCreateSaasSubscriptionPreviewRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSaasSubscriptionPreview: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createSaasSubscriptionPreview(requestParameters.saasSubscriptionCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a Saas subscription
         * @summary Delete a Saas subscription
         * @param {SaasSubscriptionApiDeleteSaasSubscriptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSaasSubscription: function (requestParameters, options) {
            return localVarFp.deleteSaasSubscription(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get Saas subscriptions
         * @summary Get Saas subscriptions
         * @param {SaasSubscriptionApiGetSaasSubscriptionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaasSubscriptions: function (requestParameters, options) {
            return localVarFp.getSaasSubscriptions(requestParameters.limit, requestParameters.id, requestParameters.uuid, requestParameters.accountId, requestParameters.createdBy, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.updatedBy, requestParameters.updatedAtMin, requestParameters.updatedAtMax, requestParameters.deletedBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.includeDeleted, requestParameters.lastPaymentAtMax, requestParameters.lastPaymentAtMin, requestParameters.subscriptionStatus, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates the status of a saas subscription based on recurly events
         * @summary Update a saas subscription status
         * @param {SaasSubscriptionApiUpdateStatusSubscriptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStatusSubscription: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.updateStatusSubscription(requestParameters.saasSubscriptionUpdateData, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SaasSubscriptionApiFactory = SaasSubscriptionApiFactory;
/**
 * SaasSubscriptionApi - object-oriented interface
 * @export
 * @class SaasSubscriptionApi
 * @extends {BaseAPI}
 */
var SaasSubscriptionApi = /** @class */ (function (_super) {
    __extends(SaasSubscriptionApi, _super);
    function SaasSubscriptionApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a Saas subscription
     * @summary Create a Saas subscription
     * @param {SaasSubscriptionApiCreateSaasSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SaasSubscriptionApi
     */
    SaasSubscriptionApi.prototype.createSaasSubscription = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.SaasSubscriptionApiFp)(this.configuration).createSaasSubscription(requestParameters.saasSubscriptionCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Create SaaS subscription preview
     * @summary Create SaaS subscription preview
     * @param {SaasSubscriptionApiCreateSaasSubscriptionPreviewRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SaasSubscriptionApi
     */
    SaasSubscriptionApi.prototype.createSaasSubscriptionPreview = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.SaasSubscriptionApiFp)(this.configuration).createSaasSubscriptionPreview(requestParameters.saasSubscriptionCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a Saas subscription
     * @summary Delete a Saas subscription
     * @param {SaasSubscriptionApiDeleteSaasSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SaasSubscriptionApi
     */
    SaasSubscriptionApi.prototype.deleteSaasSubscription = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SaasSubscriptionApiFp)(this.configuration).deleteSaasSubscription(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get Saas subscriptions
     * @summary Get Saas subscriptions
     * @param {SaasSubscriptionApiGetSaasSubscriptionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SaasSubscriptionApi
     */
    SaasSubscriptionApi.prototype.getSaasSubscriptions = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SaasSubscriptionApiFp)(this.configuration).getSaasSubscriptions(requestParameters.limit, requestParameters.id, requestParameters.uuid, requestParameters.accountId, requestParameters.createdBy, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.updatedBy, requestParameters.updatedAtMin, requestParameters.updatedAtMax, requestParameters.deletedBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.includeDeleted, requestParameters.lastPaymentAtMax, requestParameters.lastPaymentAtMin, requestParameters.subscriptionStatus, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates the status of a saas subscription based on recurly events
     * @summary Update a saas subscription status
     * @param {SaasSubscriptionApiUpdateStatusSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SaasSubscriptionApi
     */
    SaasSubscriptionApi.prototype.updateStatusSubscription = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.SaasSubscriptionApiFp)(this.configuration).updateStatusSubscription(requestParameters.saasSubscriptionUpdateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SaasSubscriptionApi;
}(base_1.BaseAPI));
exports.SaasSubscriptionApi = SaasSubscriptionApi;
/**
 * SaasTrialApi - axios parameter creator
 * @export
 */
var SaasTrialApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create a Saas trial
         * @summary Create a Saas trial
         * @param {SaasTrialCreateData} [saasTrialCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSaasTrial: function (saasTrialCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([saasTrialCreateData_1], args_1, true), void 0, function (saasTrialCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/saasTrials";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(saasTrialCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get Saas trials
         * @summary Get Saas trials
         * @param {number} limit
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<string>} [uuid] A comma separated list of uuids
         * @param {Array<number>} [accountId]
         * @param {Array<AccountTierType>} [expectedTier]
         * @param {Date} [endDateMin]
         * @param {Date} [endDateMax]
         * @param {Array<string>} [createdBy] comma separated list of uuids
         * @param {Date} [createdAtMin] earliest bound to look at for creation date
         * @param {Date} [createdAtMax] latest bound to look at for creation date
         * @param {Array<string>} [updatedBy]
         * @param {Date} [updatedAtMin]
         * @param {Date} [updatedAtMax]
         * @param {Array<string>} [deletedBy] comma separated list of uuids
         * @param {Date} [deletedAtMin] earliest bound for deletion date
         * @param {Date} [deletedAtMax] latest bound for deletion date
         * @param {boolean} [includeDeleted]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaasTrials: function (limit_1, id_1, uuid_1, accountId_1, expectedTier_1, endDateMin_1, endDateMax_1, createdBy_1, createdAtMin_1, createdAtMax_1, updatedBy_1, updatedAtMin_1, updatedAtMax_1, deletedBy_1, deletedAtMin_1, deletedAtMax_1, includeDeleted_1, offset_1, sortBy_1, order_1) {
            var args_1 = [];
            for (var _i = 20; _i < arguments.length; _i++) {
                args_1[_i - 20] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, uuid_1, accountId_1, expectedTier_1, endDateMin_1, endDateMax_1, createdBy_1, createdAtMin_1, createdAtMax_1, updatedBy_1, updatedAtMin_1, updatedAtMax_1, deletedBy_1, deletedAtMin_1, deletedAtMax_1, includeDeleted_1, offset_1, sortBy_1, order_1], args_1, true), void 0, function (limit, id, uuid, accountId, expectedTier, endDateMin, endDateMax, createdBy, createdAtMin, createdAtMax, updatedBy, updatedAtMin, updatedAtMax, deletedBy, deletedAtMin, deletedAtMax, includeDeleted, offset, sortBy, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getSaasTrials', 'limit', limit);
                            localVarPath = "/saasTrials";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (uuid) {
                                localVarQueryParameter['uuid'] = uuid.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (accountId) {
                                localVarQueryParameter['accountId'] = accountId;
                            }
                            if (expectedTier) {
                                localVarQueryParameter['expectedTier'] = expectedTier;
                            }
                            if (endDateMin !== undefined) {
                                localVarQueryParameter['endDateMin'] = (endDateMin instanceof Date) ?
                                    endDateMin.toISOString() :
                                    endDateMin;
                            }
                            if (endDateMax !== undefined) {
                                localVarQueryParameter['endDateMax'] = (endDateMax instanceof Date) ?
                                    endDateMax.toISOString() :
                                    endDateMax;
                            }
                            if (createdBy) {
                                localVarQueryParameter['createdBy'] = createdBy.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (createdAtMin !== undefined) {
                                localVarQueryParameter['createdAtMin'] = (createdAtMin instanceof Date) ?
                                    createdAtMin.toISOString() :
                                    createdAtMin;
                            }
                            if (createdAtMax !== undefined) {
                                localVarQueryParameter['createdAtMax'] = (createdAtMax instanceof Date) ?
                                    createdAtMax.toISOString() :
                                    createdAtMax;
                            }
                            if (updatedBy) {
                                localVarQueryParameter['updatedBy'] = updatedBy;
                            }
                            if (updatedAtMin !== undefined) {
                                localVarQueryParameter['updatedAtMin'] = (updatedAtMin instanceof Date) ?
                                    updatedAtMin.toISOString() :
                                    updatedAtMin;
                            }
                            if (updatedAtMax !== undefined) {
                                localVarQueryParameter['updatedAtMax'] = (updatedAtMax instanceof Date) ?
                                    updatedAtMax.toISOString() :
                                    updatedAtMax;
                            }
                            if (deletedBy) {
                                localVarQueryParameter['deletedBy'] = deletedBy.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (deletedAtMin !== undefined) {
                                localVarQueryParameter['deletedAtMin'] = (deletedAtMin instanceof Date) ?
                                    deletedAtMin.toISOString() :
                                    deletedAtMin;
                            }
                            if (deletedAtMax !== undefined) {
                                localVarQueryParameter['deletedAtMax'] = (deletedAtMax instanceof Date) ?
                                    deletedAtMax.toISOString() :
                                    deletedAtMax;
                            }
                            if (includeDeleted !== undefined) {
                                localVarQueryParameter['includeDeleted'] = includeDeleted;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SaasTrialApiAxiosParamCreator = SaasTrialApiAxiosParamCreator;
/**
 * SaasTrialApi - functional programming interface
 * @export
 */
var SaasTrialApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SaasTrialApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create a Saas trial
         * @summary Create a Saas trial
         * @param {SaasTrialCreateData} [saasTrialCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSaasTrial: function (saasTrialCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSaasTrial(saasTrialCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SaasTrialApi.createSaasTrial']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get Saas trials
         * @summary Get Saas trials
         * @param {number} limit
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<string>} [uuid] A comma separated list of uuids
         * @param {Array<number>} [accountId]
         * @param {Array<AccountTierType>} [expectedTier]
         * @param {Date} [endDateMin]
         * @param {Date} [endDateMax]
         * @param {Array<string>} [createdBy] comma separated list of uuids
         * @param {Date} [createdAtMin] earliest bound to look at for creation date
         * @param {Date} [createdAtMax] latest bound to look at for creation date
         * @param {Array<string>} [updatedBy]
         * @param {Date} [updatedAtMin]
         * @param {Date} [updatedAtMax]
         * @param {Array<string>} [deletedBy] comma separated list of uuids
         * @param {Date} [deletedAtMin] earliest bound for deletion date
         * @param {Date} [deletedAtMax] latest bound for deletion date
         * @param {boolean} [includeDeleted]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaasTrials: function (limit, id, uuid, accountId, expectedTier, endDateMin, endDateMax, createdBy, createdAtMin, createdAtMax, updatedBy, updatedAtMin, updatedAtMax, deletedBy, deletedAtMin, deletedAtMax, includeDeleted, offset, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSaasTrials(limit, id, uuid, accountId, expectedTier, endDateMin, endDateMax, createdBy, createdAtMin, createdAtMax, updatedBy, updatedAtMin, updatedAtMax, deletedBy, deletedAtMin, deletedAtMax, includeDeleted, offset, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SaasTrialApi.getSaasTrials']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.SaasTrialApiFp = SaasTrialApiFp;
/**
 * SaasTrialApi - factory interface
 * @export
 */
var SaasTrialApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SaasTrialApiFp)(configuration);
    return {
        /**
         * Create a Saas trial
         * @summary Create a Saas trial
         * @param {SaasTrialApiCreateSaasTrialRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSaasTrial: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createSaasTrial(requestParameters.saasTrialCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get Saas trials
         * @summary Get Saas trials
         * @param {SaasTrialApiGetSaasTrialsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSaasTrials: function (requestParameters, options) {
            return localVarFp.getSaasTrials(requestParameters.limit, requestParameters.id, requestParameters.uuid, requestParameters.accountId, requestParameters.expectedTier, requestParameters.endDateMin, requestParameters.endDateMax, requestParameters.createdBy, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.updatedBy, requestParameters.updatedAtMin, requestParameters.updatedAtMax, requestParameters.deletedBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.includeDeleted, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SaasTrialApiFactory = SaasTrialApiFactory;
/**
 * SaasTrialApi - object-oriented interface
 * @export
 * @class SaasTrialApi
 * @extends {BaseAPI}
 */
var SaasTrialApi = /** @class */ (function (_super) {
    __extends(SaasTrialApi, _super);
    function SaasTrialApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a Saas trial
     * @summary Create a Saas trial
     * @param {SaasTrialApiCreateSaasTrialRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SaasTrialApi
     */
    SaasTrialApi.prototype.createSaasTrial = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.SaasTrialApiFp)(this.configuration).createSaasTrial(requestParameters.saasTrialCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get Saas trials
     * @summary Get Saas trials
     * @param {SaasTrialApiGetSaasTrialsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SaasTrialApi
     */
    SaasTrialApi.prototype.getSaasTrials = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SaasTrialApiFp)(this.configuration).getSaasTrials(requestParameters.limit, requestParameters.id, requestParameters.uuid, requestParameters.accountId, requestParameters.expectedTier, requestParameters.endDateMin, requestParameters.endDateMax, requestParameters.createdBy, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.updatedBy, requestParameters.updatedAtMin, requestParameters.updatedAtMax, requestParameters.deletedBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.includeDeleted, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SaasTrialApi;
}(base_1.BaseAPI));
exports.SaasTrialApi = SaasTrialApi;
/**
 * SubAccountApi - axios parameter creator
 * @export
 */
var SubAccountApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create a sub-account based on the request
         * @summary Create a sub-account
         * @param {LegacySubAccountCreateData} legacySubAccountCreateData Sub-account creation fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubAccount: function (legacySubAccountCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([legacySubAccountCreateData_1], args_1, true), void 0, function (legacySubAccountCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'legacySubAccountCreateData' is not null or undefined
                            (0, common_1.assertParamExists)('createSubAccount', 'legacySubAccountCreateData', legacySubAccountCreateData);
                            localVarPath = "/subAccounts";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(legacySubAccountCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Soft delete the sub-account corresponding to the ID in URL path, if one exists
         * @summary Delete a sub-account
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubAccount: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteSubAccount', 'id', id);
                            localVarPath = "/subAccounts/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get a list of sub-account owners filtered by relevant query parameters
         * @summary Get sub-account owners
         * @param {Array<number>} [subAccountOwnerId] comma separated list of sub account owner ids
         * @param {Array<string>} [subAccountOwnerDemandPartnerManager] comma separated list of demand partner manager uuids
         * @param {Array<string>} [subAccountOwnerDemandYieldManager] comma separated list of demand yield manager uuids
         * @param {Array<string>} [subAccountOwnerSupplydPartnerManager] comma separated list of supply partner manager uuids
         * @param {Array<string>} [subAccountOwnerSupplyYieldManager] comma separated list of supply yield manager uuids
         * @param {Array<string>} [subAccountOwnerCreatedBy] comma separated list of uuids
         * @param {Date} [subAccountOwnerCreatedAtMin] earliest bound to look at for creation date
         * @param {Date} [subAccountOwnerCreatedAtMax] latest bound to look at for creation date
         * @param {Array<string>} [subAccountOwnerDeletedBy] comma separated list of uuids
         * @param {Date} [subAccountOwnerDeletedAtMin] earliest bound for deletion date
         * @param {Date} [subAccountOwnerDeletedAtMax] latest time for deletion date
         * @param {boolean} [subAccountOwnerIsDeleted] include deleted Sub Account Owners, true/false
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubAccountOwners: function (subAccountOwnerId_1, subAccountOwnerDemandPartnerManager_1, subAccountOwnerDemandYieldManager_1, subAccountOwnerSupplydPartnerManager_1, subAccountOwnerSupplyYieldManager_1, subAccountOwnerCreatedBy_1, subAccountOwnerCreatedAtMin_1, subAccountOwnerCreatedAtMax_1, subAccountOwnerDeletedBy_1, subAccountOwnerDeletedAtMin_1, subAccountOwnerDeletedAtMax_1, subAccountOwnerIsDeleted_1) {
            var args_1 = [];
            for (var _i = 12; _i < arguments.length; _i++) {
                args_1[_i - 12] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([subAccountOwnerId_1, subAccountOwnerDemandPartnerManager_1, subAccountOwnerDemandYieldManager_1, subAccountOwnerSupplydPartnerManager_1, subAccountOwnerSupplyYieldManager_1, subAccountOwnerCreatedBy_1, subAccountOwnerCreatedAtMin_1, subAccountOwnerCreatedAtMax_1, subAccountOwnerDeletedBy_1, subAccountOwnerDeletedAtMin_1, subAccountOwnerDeletedAtMax_1, subAccountOwnerIsDeleted_1], args_1, true), void 0, function (subAccountOwnerId, subAccountOwnerDemandPartnerManager, subAccountOwnerDemandYieldManager, subAccountOwnerSupplydPartnerManager, subAccountOwnerSupplyYieldManager, subAccountOwnerCreatedBy, subAccountOwnerCreatedAtMin, subAccountOwnerCreatedAtMax, subAccountOwnerDeletedBy, subAccountOwnerDeletedAtMin, subAccountOwnerDeletedAtMax, subAccountOwnerIsDeleted, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/subAccounts/owners";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (subAccountOwnerId) {
                                localVarQueryParameter['subAccountOwnerId'] = subAccountOwnerId.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (subAccountOwnerDemandPartnerManager) {
                                localVarQueryParameter['subAccountOwnerDemandPartnerManager'] = subAccountOwnerDemandPartnerManager.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (subAccountOwnerDemandYieldManager) {
                                localVarQueryParameter['subAccountOwnerDemandYieldManager'] = subAccountOwnerDemandYieldManager.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (subAccountOwnerSupplydPartnerManager) {
                                localVarQueryParameter['subAccountOwnerSupplydPartnerManager'] = subAccountOwnerSupplydPartnerManager.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (subAccountOwnerSupplyYieldManager) {
                                localVarQueryParameter['subAccountOwnerSupplyYieldManager'] = subAccountOwnerSupplyYieldManager.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (subAccountOwnerCreatedBy) {
                                localVarQueryParameter['subAccountOwnerCreatedBy'] = subAccountOwnerCreatedBy.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (subAccountOwnerCreatedAtMin !== undefined) {
                                localVarQueryParameter['subAccountOwnerCreatedAtMin'] = (subAccountOwnerCreatedAtMin instanceof Date) ?
                                    subAccountOwnerCreatedAtMin.toISOString() :
                                    subAccountOwnerCreatedAtMin;
                            }
                            if (subAccountOwnerCreatedAtMax !== undefined) {
                                localVarQueryParameter['subAccountOwnerCreatedAtMax'] = (subAccountOwnerCreatedAtMax instanceof Date) ?
                                    subAccountOwnerCreatedAtMax.toISOString() :
                                    subAccountOwnerCreatedAtMax;
                            }
                            if (subAccountOwnerDeletedBy) {
                                localVarQueryParameter['subAccountOwnerDeletedBy'] = subAccountOwnerDeletedBy.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (subAccountOwnerDeletedAtMin !== undefined) {
                                localVarQueryParameter['subAccountOwnerDeletedAtMin'] = (subAccountOwnerDeletedAtMin instanceof Date) ?
                                    subAccountOwnerDeletedAtMin.toISOString() :
                                    subAccountOwnerDeletedAtMin;
                            }
                            if (subAccountOwnerDeletedAtMax !== undefined) {
                                localVarQueryParameter['subAccountOwnerDeletedAtMax'] = (subAccountOwnerDeletedAtMax instanceof Date) ?
                                    subAccountOwnerDeletedAtMax.toISOString() :
                                    subAccountOwnerDeletedAtMax;
                            }
                            if (subAccountOwnerIsDeleted !== undefined) {
                                localVarQueryParameter['subAccountOwnerIsDeleted'] = subAccountOwnerIsDeleted;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get sub-account types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubAccountTypes: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/subAccounts/types";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get sub-accounts
         * @summary Get sub-accounts
         * @param {number} limit limit results
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<string>} [uuid] A comma separated list of uuids
         * @param {Array<number>} [accountId] A comma separated list of account ids
         * @param {Array<string>} [name] A comma separated list of names
         * @param {Array<string>} [companyUuid] A comma separated list of company uuids
         * @param {Array<string>} [displayName] A comma separated list of sub account display names
         * @param {string} [subAccountTypeKey] sub account type key
         * @param {Array<string>} [createdBy] comma separated list of uuids
         * @param {Date} [createdAt] creation date of object
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {boolean} [excludeDeleted] ignored deleted items, default true
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubAccounts: function (limit_1, id_1, uuid_1, accountId_1, name_1, companyUuid_1, displayName_1, subAccountTypeKey_1, createdBy_1, createdAt_1, offset_1, sortBy_1, order_1, excludeDeleted_1) {
            var args_1 = [];
            for (var _i = 14; _i < arguments.length; _i++) {
                args_1[_i - 14] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, uuid_1, accountId_1, name_1, companyUuid_1, displayName_1, subAccountTypeKey_1, createdBy_1, createdAt_1, offset_1, sortBy_1, order_1, excludeDeleted_1], args_1, true), void 0, function (limit, id, uuid, accountId, name, companyUuid, displayName, subAccountTypeKey, createdBy, createdAt, offset, sortBy, order, excludeDeleted, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getSubAccounts', 'limit', limit);
                            localVarPath = "/subAccounts";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (uuid) {
                                localVarQueryParameter['uuid'] = uuid.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (accountId) {
                                localVarQueryParameter['accountId'] = accountId.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (name) {
                                localVarQueryParameter['name'] = name.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (companyUuid) {
                                localVarQueryParameter['companyUuid'] = companyUuid.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (displayName) {
                                localVarQueryParameter['displayName'] = displayName.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (subAccountTypeKey !== undefined) {
                                localVarQueryParameter['subAccountTypeKey'] = subAccountTypeKey;
                            }
                            if (createdBy) {
                                localVarQueryParameter['createdBy'] = createdBy.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (createdAt !== undefined) {
                                localVarQueryParameter['createdAt'] = (createdAt instanceof Date) ?
                                    createdAt.toISOString() :
                                    createdAt;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (excludeDeleted !== undefined) {
                                localVarQueryParameter['excludeDeleted'] = excludeDeleted;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get a list of sub-accounts based off search parameters sent in request body
         * @summary Search for sub-accounts
         * @param {LegacySubAccountCriteria} [legacySubAccountCriteria]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSubAccounts: function (legacySubAccountCriteria_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([legacySubAccountCriteria_1], args_1, true), void 0, function (legacySubAccountCriteria, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/subAccounts/search";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(legacySubAccountCriteria, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Updates the fields of a sub-account that corresponds to the ID in the URL path, if on exists
         * @summary Update a sub-account
         * @param {number} id
         * @param {LegacySubAccountUpdateData} legacySubAccountUpdateData Update fields for sub-account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubAccount: function (id_1, legacySubAccountUpdateData_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, legacySubAccountUpdateData_1], args_1, true), void 0, function (id, legacySubAccountUpdateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('updateSubAccount', 'id', id);
                            // verify required parameter 'legacySubAccountUpdateData' is not null or undefined
                            (0, common_1.assertParamExists)('updateSubAccount', 'legacySubAccountUpdateData', legacySubAccountUpdateData);
                            localVarPath = "/subAccounts/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(legacySubAccountUpdateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SubAccountApiAxiosParamCreator = SubAccountApiAxiosParamCreator;
/**
 * SubAccountApi - functional programming interface
 * @export
 */
var SubAccountApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SubAccountApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create a sub-account based on the request
         * @summary Create a sub-account
         * @param {LegacySubAccountCreateData} legacySubAccountCreateData Sub-account creation fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubAccount: function (legacySubAccountCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSubAccount(legacySubAccountCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SubAccountApi.createSubAccount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Soft delete the sub-account corresponding to the ID in URL path, if one exists
         * @summary Delete a sub-account
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubAccount: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteSubAccount(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SubAccountApi.deleteSubAccount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get a list of sub-account owners filtered by relevant query parameters
         * @summary Get sub-account owners
         * @param {Array<number>} [subAccountOwnerId] comma separated list of sub account owner ids
         * @param {Array<string>} [subAccountOwnerDemandPartnerManager] comma separated list of demand partner manager uuids
         * @param {Array<string>} [subAccountOwnerDemandYieldManager] comma separated list of demand yield manager uuids
         * @param {Array<string>} [subAccountOwnerSupplydPartnerManager] comma separated list of supply partner manager uuids
         * @param {Array<string>} [subAccountOwnerSupplyYieldManager] comma separated list of supply yield manager uuids
         * @param {Array<string>} [subAccountOwnerCreatedBy] comma separated list of uuids
         * @param {Date} [subAccountOwnerCreatedAtMin] earliest bound to look at for creation date
         * @param {Date} [subAccountOwnerCreatedAtMax] latest bound to look at for creation date
         * @param {Array<string>} [subAccountOwnerDeletedBy] comma separated list of uuids
         * @param {Date} [subAccountOwnerDeletedAtMin] earliest bound for deletion date
         * @param {Date} [subAccountOwnerDeletedAtMax] latest time for deletion date
         * @param {boolean} [subAccountOwnerIsDeleted] include deleted Sub Account Owners, true/false
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubAccountOwners: function (subAccountOwnerId, subAccountOwnerDemandPartnerManager, subAccountOwnerDemandYieldManager, subAccountOwnerSupplydPartnerManager, subAccountOwnerSupplyYieldManager, subAccountOwnerCreatedBy, subAccountOwnerCreatedAtMin, subAccountOwnerCreatedAtMax, subAccountOwnerDeletedBy, subAccountOwnerDeletedAtMin, subAccountOwnerDeletedAtMax, subAccountOwnerIsDeleted, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSubAccountOwners(subAccountOwnerId, subAccountOwnerDemandPartnerManager, subAccountOwnerDemandYieldManager, subAccountOwnerSupplydPartnerManager, subAccountOwnerSupplyYieldManager, subAccountOwnerCreatedBy, subAccountOwnerCreatedAtMin, subAccountOwnerCreatedAtMax, subAccountOwnerDeletedBy, subAccountOwnerDeletedAtMin, subAccountOwnerDeletedAtMax, subAccountOwnerIsDeleted, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SubAccountApi.getSubAccountOwners']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get sub-account types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubAccountTypes: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSubAccountTypes(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SubAccountApi.getSubAccountTypes']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get sub-accounts
         * @summary Get sub-accounts
         * @param {number} limit limit results
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<string>} [uuid] A comma separated list of uuids
         * @param {Array<number>} [accountId] A comma separated list of account ids
         * @param {Array<string>} [name] A comma separated list of names
         * @param {Array<string>} [companyUuid] A comma separated list of company uuids
         * @param {Array<string>} [displayName] A comma separated list of sub account display names
         * @param {string} [subAccountTypeKey] sub account type key
         * @param {Array<string>} [createdBy] comma separated list of uuids
         * @param {Date} [createdAt] creation date of object
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {boolean} [excludeDeleted] ignored deleted items, default true
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubAccounts: function (limit, id, uuid, accountId, name, companyUuid, displayName, subAccountTypeKey, createdBy, createdAt, offset, sortBy, order, excludeDeleted, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSubAccounts(limit, id, uuid, accountId, name, companyUuid, displayName, subAccountTypeKey, createdBy, createdAt, offset, sortBy, order, excludeDeleted, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SubAccountApi.getSubAccounts']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get a list of sub-accounts based off search parameters sent in request body
         * @summary Search for sub-accounts
         * @param {LegacySubAccountCriteria} [legacySubAccountCriteria]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSubAccounts: function (legacySubAccountCriteria, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.searchSubAccounts(legacySubAccountCriteria, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SubAccountApi.searchSubAccounts']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Updates the fields of a sub-account that corresponds to the ID in the URL path, if on exists
         * @summary Update a sub-account
         * @param {number} id
         * @param {LegacySubAccountUpdateData} legacySubAccountUpdateData Update fields for sub-account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubAccount: function (id, legacySubAccountUpdateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateSubAccount(id, legacySubAccountUpdateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SubAccountApi.updateSubAccount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.SubAccountApiFp = SubAccountApiFp;
/**
 * SubAccountApi - factory interface
 * @export
 */
var SubAccountApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SubAccountApiFp)(configuration);
    return {
        /**
         * Create a sub-account based on the request
         * @summary Create a sub-account
         * @param {SubAccountApiCreateSubAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubAccount: function (requestParameters, options) {
            return localVarFp.createSubAccount(requestParameters.legacySubAccountCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Soft delete the sub-account corresponding to the ID in URL path, if one exists
         * @summary Delete a sub-account
         * @param {SubAccountApiDeleteSubAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubAccount: function (requestParameters, options) {
            return localVarFp.deleteSubAccount(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a list of sub-account owners filtered by relevant query parameters
         * @summary Get sub-account owners
         * @param {SubAccountApiGetSubAccountOwnersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubAccountOwners: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.getSubAccountOwners(requestParameters.subAccountOwnerId, requestParameters.subAccountOwnerDemandPartnerManager, requestParameters.subAccountOwnerDemandYieldManager, requestParameters.subAccountOwnerSupplydPartnerManager, requestParameters.subAccountOwnerSupplyYieldManager, requestParameters.subAccountOwnerCreatedBy, requestParameters.subAccountOwnerCreatedAtMin, requestParameters.subAccountOwnerCreatedAtMax, requestParameters.subAccountOwnerDeletedBy, requestParameters.subAccountOwnerDeletedAtMin, requestParameters.subAccountOwnerDeletedAtMax, requestParameters.subAccountOwnerIsDeleted, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get sub-account types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubAccountTypes: function (options) {
            return localVarFp.getSubAccountTypes(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get sub-accounts
         * @summary Get sub-accounts
         * @param {SubAccountApiGetSubAccountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubAccounts: function (requestParameters, options) {
            return localVarFp.getSubAccounts(requestParameters.limit, requestParameters.id, requestParameters.uuid, requestParameters.accountId, requestParameters.name, requestParameters.companyUuid, requestParameters.displayName, requestParameters.subAccountTypeKey, requestParameters.createdBy, requestParameters.createdAt, requestParameters.offset, requestParameters.sortBy, requestParameters.order, requestParameters.excludeDeleted, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a list of sub-accounts based off search parameters sent in request body
         * @summary Search for sub-accounts
         * @param {SubAccountApiSearchSubAccountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSubAccounts: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.searchSubAccounts(requestParameters.legacySubAccountCriteria, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates the fields of a sub-account that corresponds to the ID in the URL path, if on exists
         * @summary Update a sub-account
         * @param {SubAccountApiUpdateSubAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubAccount: function (requestParameters, options) {
            return localVarFp.updateSubAccount(requestParameters.id, requestParameters.legacySubAccountUpdateData, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SubAccountApiFactory = SubAccountApiFactory;
/**
 * SubAccountApi - object-oriented interface
 * @export
 * @class SubAccountApi
 * @extends {BaseAPI}
 */
var SubAccountApi = /** @class */ (function (_super) {
    __extends(SubAccountApi, _super);
    function SubAccountApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a sub-account based on the request
     * @summary Create a sub-account
     * @param {SubAccountApiCreateSubAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubAccountApi
     */
    SubAccountApi.prototype.createSubAccount = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SubAccountApiFp)(this.configuration).createSubAccount(requestParameters.legacySubAccountCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Soft delete the sub-account corresponding to the ID in URL path, if one exists
     * @summary Delete a sub-account
     * @param {SubAccountApiDeleteSubAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubAccountApi
     */
    SubAccountApi.prototype.deleteSubAccount = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SubAccountApiFp)(this.configuration).deleteSubAccount(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a list of sub-account owners filtered by relevant query parameters
     * @summary Get sub-account owners
     * @param {SubAccountApiGetSubAccountOwnersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubAccountApi
     */
    SubAccountApi.prototype.getSubAccountOwners = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.SubAccountApiFp)(this.configuration).getSubAccountOwners(requestParameters.subAccountOwnerId, requestParameters.subAccountOwnerDemandPartnerManager, requestParameters.subAccountOwnerDemandYieldManager, requestParameters.subAccountOwnerSupplydPartnerManager, requestParameters.subAccountOwnerSupplyYieldManager, requestParameters.subAccountOwnerCreatedBy, requestParameters.subAccountOwnerCreatedAtMin, requestParameters.subAccountOwnerCreatedAtMax, requestParameters.subAccountOwnerDeletedBy, requestParameters.subAccountOwnerDeletedAtMin, requestParameters.subAccountOwnerDeletedAtMax, requestParameters.subAccountOwnerIsDeleted, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get sub-account types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubAccountApi
     */
    SubAccountApi.prototype.getSubAccountTypes = function (options) {
        var _this = this;
        return (0, exports.SubAccountApiFp)(this.configuration).getSubAccountTypes(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get sub-accounts
     * @summary Get sub-accounts
     * @param {SubAccountApiGetSubAccountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubAccountApi
     */
    SubAccountApi.prototype.getSubAccounts = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SubAccountApiFp)(this.configuration).getSubAccounts(requestParameters.limit, requestParameters.id, requestParameters.uuid, requestParameters.accountId, requestParameters.name, requestParameters.companyUuid, requestParameters.displayName, requestParameters.subAccountTypeKey, requestParameters.createdBy, requestParameters.createdAt, requestParameters.offset, requestParameters.sortBy, requestParameters.order, requestParameters.excludeDeleted, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a list of sub-accounts based off search parameters sent in request body
     * @summary Search for sub-accounts
     * @param {SubAccountApiSearchSubAccountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubAccountApi
     */
    SubAccountApi.prototype.searchSubAccounts = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.SubAccountApiFp)(this.configuration).searchSubAccounts(requestParameters.legacySubAccountCriteria, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates the fields of a sub-account that corresponds to the ID in the URL path, if on exists
     * @summary Update a sub-account
     * @param {SubAccountApiUpdateSubAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubAccountApi
     */
    SubAccountApi.prototype.updateSubAccount = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SubAccountApiFp)(this.configuration).updateSubAccount(requestParameters.id, requestParameters.legacySubAccountUpdateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SubAccountApi;
}(base_1.BaseAPI));
exports.SubAccountApi = SubAccountApi;
/**
 * SubAccountExternalDemandEventApi - axios parameter creator
 * @export
 */
var SubAccountExternalDemandEventApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create a sub account external demand event
         * @summary Create a sub-account external demand event
         * @param {SubAccountExternalDemandEventCreateData} [subAccountExternalDemandEventCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubAccountExternalDemandEvent: function (subAccountExternalDemandEventCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([subAccountExternalDemandEventCreateData_1], args_1, true), void 0, function (subAccountExternalDemandEventCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/subAccountExternalDemandEvents";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(subAccountExternalDemandEventCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete an expected earnings share override
         * @summary Delete an expected earnings share override
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExpectedEarningsShareOverride: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteExpectedEarningsShareOverride', 'id', id);
                            localVarPath = "/expectedEarningsShareOverrides/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a sub-account external demand event
         * @summary Delete a sub-account external demand event
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubAccountExternalDemandEvent: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteSubAccountExternalDemandEvent', 'id', id);
                            localVarPath = "/subAccountExternalDemandEvents/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get sub-account external demand events.
         * @summary Get sub-account external demand events
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id]
         * @param {Array<number>} [supplySubAccountId]
         * @param {Array<number>} [demandSubAccountId]
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {Array<string>} [createdBy]
         * @param {Date} [deletedAtMin]
         * @param {Date} [deletedAtMax]
         * @param {boolean} [isDeleted]
         * @param {Array<string>} [deletedBy]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {string} [sortBy] The attribute with which to sort the resources.
         * @param {string} [order] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubAccountExternalDemandEvents: function (limit_1, id_1, supplySubAccountId_1, demandSubAccountId_1, createdAtMin_1, createdAtMax_1, createdBy_1, deletedAtMin_1, deletedAtMax_1, isDeleted_1, deletedBy_1, offset_1, sortBy_1, order_1) {
            var args_1 = [];
            for (var _i = 14; _i < arguments.length; _i++) {
                args_1[_i - 14] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, supplySubAccountId_1, demandSubAccountId_1, createdAtMin_1, createdAtMax_1, createdBy_1, deletedAtMin_1, deletedAtMax_1, isDeleted_1, deletedBy_1, offset_1, sortBy_1, order_1], args_1, true), void 0, function (limit, id, supplySubAccountId, demandSubAccountId, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, deletedBy, offset, sortBy, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getSubAccountExternalDemandEvents', 'limit', limit);
                            localVarPath = "/subAccountExternalDemandEvents";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (supplySubAccountId) {
                                localVarQueryParameter['supplySubAccountId'] = supplySubAccountId;
                            }
                            if (demandSubAccountId) {
                                localVarQueryParameter['demandSubAccountId'] = demandSubAccountId;
                            }
                            if (createdAtMin !== undefined) {
                                localVarQueryParameter['createdAtMin'] = (createdAtMin instanceof Date) ?
                                    createdAtMin.toISOString() :
                                    createdAtMin;
                            }
                            if (createdAtMax !== undefined) {
                                localVarQueryParameter['createdAtMax'] = (createdAtMax instanceof Date) ?
                                    createdAtMax.toISOString() :
                                    createdAtMax;
                            }
                            if (createdBy) {
                                localVarQueryParameter['createdBy'] = createdBy;
                            }
                            if (deletedAtMin !== undefined) {
                                localVarQueryParameter['deletedAtMin'] = (deletedAtMin instanceof Date) ?
                                    deletedAtMin.toISOString() :
                                    deletedAtMin;
                            }
                            if (deletedAtMax !== undefined) {
                                localVarQueryParameter['deletedAtMax'] = (deletedAtMax instanceof Date) ?
                                    deletedAtMax.toISOString() :
                                    deletedAtMax;
                            }
                            if (isDeleted !== undefined) {
                                localVarQueryParameter['isDeleted'] = isDeleted;
                            }
                            if (deletedBy) {
                                localVarQueryParameter['deletedBy'] = deletedBy;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SubAccountExternalDemandEventApiAxiosParamCreator = SubAccountExternalDemandEventApiAxiosParamCreator;
/**
 * SubAccountExternalDemandEventApi - functional programming interface
 * @export
 */
var SubAccountExternalDemandEventApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SubAccountExternalDemandEventApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create a sub account external demand event
         * @summary Create a sub-account external demand event
         * @param {SubAccountExternalDemandEventCreateData} [subAccountExternalDemandEventCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubAccountExternalDemandEvent: function (subAccountExternalDemandEventCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSubAccountExternalDemandEvent(subAccountExternalDemandEventCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SubAccountExternalDemandEventApi.createSubAccountExternalDemandEvent']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete an expected earnings share override
         * @summary Delete an expected earnings share override
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExpectedEarningsShareOverride: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteExpectedEarningsShareOverride(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SubAccountExternalDemandEventApi.deleteExpectedEarningsShareOverride']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete a sub-account external demand event
         * @summary Delete a sub-account external demand event
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubAccountExternalDemandEvent: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteSubAccountExternalDemandEvent(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SubAccountExternalDemandEventApi.deleteSubAccountExternalDemandEvent']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get sub-account external demand events.
         * @summary Get sub-account external demand events
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id]
         * @param {Array<number>} [supplySubAccountId]
         * @param {Array<number>} [demandSubAccountId]
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {Array<string>} [createdBy]
         * @param {Date} [deletedAtMin]
         * @param {Date} [deletedAtMax]
         * @param {boolean} [isDeleted]
         * @param {Array<string>} [deletedBy]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {string} [sortBy] The attribute with which to sort the resources.
         * @param {string} [order] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubAccountExternalDemandEvents: function (limit, id, supplySubAccountId, demandSubAccountId, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, deletedBy, offset, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSubAccountExternalDemandEvents(limit, id, supplySubAccountId, demandSubAccountId, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, deletedBy, offset, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SubAccountExternalDemandEventApi.getSubAccountExternalDemandEvents']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.SubAccountExternalDemandEventApiFp = SubAccountExternalDemandEventApiFp;
/**
 * SubAccountExternalDemandEventApi - factory interface
 * @export
 */
var SubAccountExternalDemandEventApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SubAccountExternalDemandEventApiFp)(configuration);
    return {
        /**
         * Create a sub account external demand event
         * @summary Create a sub-account external demand event
         * @param {SubAccountExternalDemandEventApiCreateSubAccountExternalDemandEventRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSubAccountExternalDemandEvent: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createSubAccountExternalDemandEvent(requestParameters.subAccountExternalDemandEventCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete an expected earnings share override
         * @summary Delete an expected earnings share override
         * @param {SubAccountExternalDemandEventApiDeleteExpectedEarningsShareOverrideRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteExpectedEarningsShareOverride: function (requestParameters, options) {
            return localVarFp.deleteExpectedEarningsShareOverride(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a sub-account external demand event
         * @summary Delete a sub-account external demand event
         * @param {SubAccountExternalDemandEventApiDeleteSubAccountExternalDemandEventRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubAccountExternalDemandEvent: function (requestParameters, options) {
            return localVarFp.deleteSubAccountExternalDemandEvent(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get sub-account external demand events.
         * @summary Get sub-account external demand events
         * @param {SubAccountExternalDemandEventApiGetSubAccountExternalDemandEventsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubAccountExternalDemandEvents: function (requestParameters, options) {
            return localVarFp.getSubAccountExternalDemandEvents(requestParameters.limit, requestParameters.id, requestParameters.supplySubAccountId, requestParameters.demandSubAccountId, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.isDeleted, requestParameters.deletedBy, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SubAccountExternalDemandEventApiFactory = SubAccountExternalDemandEventApiFactory;
/**
 * SubAccountExternalDemandEventApi - object-oriented interface
 * @export
 * @class SubAccountExternalDemandEventApi
 * @extends {BaseAPI}
 */
var SubAccountExternalDemandEventApi = /** @class */ (function (_super) {
    __extends(SubAccountExternalDemandEventApi, _super);
    function SubAccountExternalDemandEventApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a sub account external demand event
     * @summary Create a sub-account external demand event
     * @param {SubAccountExternalDemandEventApiCreateSubAccountExternalDemandEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubAccountExternalDemandEventApi
     */
    SubAccountExternalDemandEventApi.prototype.createSubAccountExternalDemandEvent = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.SubAccountExternalDemandEventApiFp)(this.configuration).createSubAccountExternalDemandEvent(requestParameters.subAccountExternalDemandEventCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete an expected earnings share override
     * @summary Delete an expected earnings share override
     * @param {SubAccountExternalDemandEventApiDeleteExpectedEarningsShareOverrideRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubAccountExternalDemandEventApi
     */
    SubAccountExternalDemandEventApi.prototype.deleteExpectedEarningsShareOverride = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SubAccountExternalDemandEventApiFp)(this.configuration).deleteExpectedEarningsShareOverride(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a sub-account external demand event
     * @summary Delete a sub-account external demand event
     * @param {SubAccountExternalDemandEventApiDeleteSubAccountExternalDemandEventRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubAccountExternalDemandEventApi
     */
    SubAccountExternalDemandEventApi.prototype.deleteSubAccountExternalDemandEvent = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SubAccountExternalDemandEventApiFp)(this.configuration).deleteSubAccountExternalDemandEvent(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get sub-account external demand events.
     * @summary Get sub-account external demand events
     * @param {SubAccountExternalDemandEventApiGetSubAccountExternalDemandEventsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubAccountExternalDemandEventApi
     */
    SubAccountExternalDemandEventApi.prototype.getSubAccountExternalDemandEvents = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SubAccountExternalDemandEventApiFp)(this.configuration).getSubAccountExternalDemandEvents(requestParameters.limit, requestParameters.id, requestParameters.supplySubAccountId, requestParameters.demandSubAccountId, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.isDeleted, requestParameters.deletedBy, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SubAccountExternalDemandEventApi;
}(base_1.BaseAPI));
exports.SubAccountExternalDemandEventApi = SubAccountExternalDemandEventApi;
/**
 * SubAccountOwnerApi - axios parameter creator
 * @export
 */
var SubAccountOwnerApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Delete a sub account owner
         * @summary Delete a sub account owner
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubAccountOwner: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteSubAccountOwner', 'id', id);
                            localVarPath = "/subAccounts/owners/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SubAccountOwnerApiAxiosParamCreator = SubAccountOwnerApiAxiosParamCreator;
/**
 * SubAccountOwnerApi - functional programming interface
 * @export
 */
var SubAccountOwnerApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SubAccountOwnerApiAxiosParamCreator)(configuration);
    return {
        /**
         * Delete a sub account owner
         * @summary Delete a sub account owner
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubAccountOwner: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteSubAccountOwner(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SubAccountOwnerApi.deleteSubAccountOwner']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.SubAccountOwnerApiFp = SubAccountOwnerApiFp;
/**
 * SubAccountOwnerApi - factory interface
 * @export
 */
var SubAccountOwnerApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SubAccountOwnerApiFp)(configuration);
    return {
        /**
         * Delete a sub account owner
         * @summary Delete a sub account owner
         * @param {SubAccountOwnerApiDeleteSubAccountOwnerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSubAccountOwner: function (requestParameters, options) {
            return localVarFp.deleteSubAccountOwner(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SubAccountOwnerApiFactory = SubAccountOwnerApiFactory;
/**
 * SubAccountOwnerApi - object-oriented interface
 * @export
 * @class SubAccountOwnerApi
 * @extends {BaseAPI}
 */
var SubAccountOwnerApi = /** @class */ (function (_super) {
    __extends(SubAccountOwnerApi, _super);
    function SubAccountOwnerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Delete a sub account owner
     * @summary Delete a sub account owner
     * @param {SubAccountOwnerApiDeleteSubAccountOwnerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubAccountOwnerApi
     */
    SubAccountOwnerApi.prototype.deleteSubAccountOwner = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SubAccountOwnerApiFp)(this.configuration).deleteSubAccountOwner(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SubAccountOwnerApi;
}(base_1.BaseAPI));
exports.SubAccountOwnerApi = SubAccountOwnerApi;
/**
 * SupplyEmbedDomainApi - axios parameter creator
 * @export
 */
var SupplyEmbedDomainApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create supply embed domain
         * @summary Create supply embed domain
         * @param {SupplyEmbedDomainCreateData} [supplyEmbedDomainCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplyEmbedDomain: function (supplyEmbedDomainCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([supplyEmbedDomainCreateData_1], args_1, true), void 0, function (supplyEmbedDomainCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/supplyEmbedDomains";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(supplyEmbedDomainCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a supply embed domain
         * @summary Delete a supply embed domain
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplyEmbedDomain: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteSupplyEmbedDomain', 'id', id);
                            localVarPath = "/supplyEmbedDomains/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get supply embed domains
         * @summary Get supply embed domains
         * @param {number} limit limit results
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {number} [subAccountId]
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplyEmbedDomains: function (limit_1, id_1, subAccountId_1, sortBy_1, order_1, offset_1) {
            var args_1 = [];
            for (var _i = 6; _i < arguments.length; _i++) {
                args_1[_i - 6] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, subAccountId_1, sortBy_1, order_1, offset_1], args_1, true), void 0, function (limit, id, subAccountId, sortBy, order, offset, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getSupplyEmbedDomains', 'limit', limit);
                            localVarPath = "/supplyEmbedDomains";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (subAccountId !== undefined) {
                                localVarQueryParameter['subAccountId'] = subAccountId;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SupplyEmbedDomainApiAxiosParamCreator = SupplyEmbedDomainApiAxiosParamCreator;
/**
 * SupplyEmbedDomainApi - functional programming interface
 * @export
 */
var SupplyEmbedDomainApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SupplyEmbedDomainApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create supply embed domain
         * @summary Create supply embed domain
         * @param {SupplyEmbedDomainCreateData} [supplyEmbedDomainCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplyEmbedDomain: function (supplyEmbedDomainCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSupplyEmbedDomain(supplyEmbedDomainCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupplyEmbedDomainApi.createSupplyEmbedDomain']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete a supply embed domain
         * @summary Delete a supply embed domain
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplyEmbedDomain: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteSupplyEmbedDomain(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupplyEmbedDomainApi.deleteSupplyEmbedDomain']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get supply embed domains
         * @summary Get supply embed domains
         * @param {number} limit limit results
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {number} [subAccountId]
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplyEmbedDomains: function (limit, id, subAccountId, sortBy, order, offset, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSupplyEmbedDomains(limit, id, subAccountId, sortBy, order, offset, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupplyEmbedDomainApi.getSupplyEmbedDomains']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.SupplyEmbedDomainApiFp = SupplyEmbedDomainApiFp;
/**
 * SupplyEmbedDomainApi - factory interface
 * @export
 */
var SupplyEmbedDomainApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SupplyEmbedDomainApiFp)(configuration);
    return {
        /**
         * Create supply embed domain
         * @summary Create supply embed domain
         * @param {SupplyEmbedDomainApiCreateSupplyEmbedDomainRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplyEmbedDomain: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createSupplyEmbedDomain(requestParameters.supplyEmbedDomainCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a supply embed domain
         * @summary Delete a supply embed domain
         * @param {SupplyEmbedDomainApiDeleteSupplyEmbedDomainRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplyEmbedDomain: function (requestParameters, options) {
            return localVarFp.deleteSupplyEmbedDomain(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get supply embed domains
         * @summary Get supply embed domains
         * @param {SupplyEmbedDomainApiGetSupplyEmbedDomainsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplyEmbedDomains: function (requestParameters, options) {
            return localVarFp.getSupplyEmbedDomains(requestParameters.limit, requestParameters.id, requestParameters.subAccountId, requestParameters.sortBy, requestParameters.order, requestParameters.offset, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SupplyEmbedDomainApiFactory = SupplyEmbedDomainApiFactory;
/**
 * SupplyEmbedDomainApi - object-oriented interface
 * @export
 * @class SupplyEmbedDomainApi
 * @extends {BaseAPI}
 */
var SupplyEmbedDomainApi = /** @class */ (function (_super) {
    __extends(SupplyEmbedDomainApi, _super);
    function SupplyEmbedDomainApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create supply embed domain
     * @summary Create supply embed domain
     * @param {SupplyEmbedDomainApiCreateSupplyEmbedDomainRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplyEmbedDomainApi
     */
    SupplyEmbedDomainApi.prototype.createSupplyEmbedDomain = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.SupplyEmbedDomainApiFp)(this.configuration).createSupplyEmbedDomain(requestParameters.supplyEmbedDomainCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a supply embed domain
     * @summary Delete a supply embed domain
     * @param {SupplyEmbedDomainApiDeleteSupplyEmbedDomainRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplyEmbedDomainApi
     */
    SupplyEmbedDomainApi.prototype.deleteSupplyEmbedDomain = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SupplyEmbedDomainApiFp)(this.configuration).deleteSupplyEmbedDomain(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get supply embed domains
     * @summary Get supply embed domains
     * @param {SupplyEmbedDomainApiGetSupplyEmbedDomainsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplyEmbedDomainApi
     */
    SupplyEmbedDomainApi.prototype.getSupplyEmbedDomains = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SupplyEmbedDomainApiFp)(this.configuration).getSupplyEmbedDomains(requestParameters.limit, requestParameters.id, requestParameters.subAccountId, requestParameters.sortBy, requestParameters.order, requestParameters.offset, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SupplyEmbedDomainApi;
}(base_1.BaseAPI));
exports.SupplyEmbedDomainApi = SupplyEmbedDomainApi;
/**
 * SupplyEmbedUrlApi - axios parameter creator
 * @export
 */
var SupplyEmbedUrlApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create supply embed url
         * @summary Create supply embed url
         * @param {SupplyEmbedUrlCreateData} [supplyEmbedUrlCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplyEmbedUrl: function (supplyEmbedUrlCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([supplyEmbedUrlCreateData_1], args_1, true), void 0, function (supplyEmbedUrlCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/supplyEmbedUrls";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(supplyEmbedUrlCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a supply embed url
         * @summary Delete a supply embed url
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplyEmbedUrl: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteSupplyEmbedUrl', 'id', id);
                            localVarPath = "/supplyEmbedUrls/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get supply embed urls
         * @summary Get supply embed urls
         * @param {number} limit limit results
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {number} [subAccountId]
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplyEmbedUrls: function (limit_1, id_1, subAccountId_1, sortBy_1, order_1, offset_1) {
            var args_1 = [];
            for (var _i = 6; _i < arguments.length; _i++) {
                args_1[_i - 6] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, subAccountId_1, sortBy_1, order_1, offset_1], args_1, true), void 0, function (limit, id, subAccountId, sortBy, order, offset, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getSupplyEmbedUrls', 'limit', limit);
                            localVarPath = "/supplyEmbedUrls";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (subAccountId !== undefined) {
                                localVarQueryParameter['subAccountId'] = subAccountId;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SupplyEmbedUrlApiAxiosParamCreator = SupplyEmbedUrlApiAxiosParamCreator;
/**
 * SupplyEmbedUrlApi - functional programming interface
 * @export
 */
var SupplyEmbedUrlApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SupplyEmbedUrlApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create supply embed url
         * @summary Create supply embed url
         * @param {SupplyEmbedUrlCreateData} [supplyEmbedUrlCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplyEmbedUrl: function (supplyEmbedUrlCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSupplyEmbedUrl(supplyEmbedUrlCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupplyEmbedUrlApi.createSupplyEmbedUrl']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete a supply embed url
         * @summary Delete a supply embed url
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplyEmbedUrl: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteSupplyEmbedUrl(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupplyEmbedUrlApi.deleteSupplyEmbedUrl']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get supply embed urls
         * @summary Get supply embed urls
         * @param {number} limit limit results
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {number} [subAccountId]
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplyEmbedUrls: function (limit, id, subAccountId, sortBy, order, offset, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSupplyEmbedUrls(limit, id, subAccountId, sortBy, order, offset, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupplyEmbedUrlApi.getSupplyEmbedUrls']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.SupplyEmbedUrlApiFp = SupplyEmbedUrlApiFp;
/**
 * SupplyEmbedUrlApi - factory interface
 * @export
 */
var SupplyEmbedUrlApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SupplyEmbedUrlApiFp)(configuration);
    return {
        /**
         * Create supply embed url
         * @summary Create supply embed url
         * @param {SupplyEmbedUrlApiCreateSupplyEmbedUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplyEmbedUrl: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createSupplyEmbedUrl(requestParameters.supplyEmbedUrlCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a supply embed url
         * @summary Delete a supply embed url
         * @param {SupplyEmbedUrlApiDeleteSupplyEmbedUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplyEmbedUrl: function (requestParameters, options) {
            return localVarFp.deleteSupplyEmbedUrl(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get supply embed urls
         * @summary Get supply embed urls
         * @param {SupplyEmbedUrlApiGetSupplyEmbedUrlsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplyEmbedUrls: function (requestParameters, options) {
            return localVarFp.getSupplyEmbedUrls(requestParameters.limit, requestParameters.id, requestParameters.subAccountId, requestParameters.sortBy, requestParameters.order, requestParameters.offset, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SupplyEmbedUrlApiFactory = SupplyEmbedUrlApiFactory;
/**
 * SupplyEmbedUrlApi - object-oriented interface
 * @export
 * @class SupplyEmbedUrlApi
 * @extends {BaseAPI}
 */
var SupplyEmbedUrlApi = /** @class */ (function (_super) {
    __extends(SupplyEmbedUrlApi, _super);
    function SupplyEmbedUrlApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create supply embed url
     * @summary Create supply embed url
     * @param {SupplyEmbedUrlApiCreateSupplyEmbedUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplyEmbedUrlApi
     */
    SupplyEmbedUrlApi.prototype.createSupplyEmbedUrl = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.SupplyEmbedUrlApiFp)(this.configuration).createSupplyEmbedUrl(requestParameters.supplyEmbedUrlCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a supply embed url
     * @summary Delete a supply embed url
     * @param {SupplyEmbedUrlApiDeleteSupplyEmbedUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplyEmbedUrlApi
     */
    SupplyEmbedUrlApi.prototype.deleteSupplyEmbedUrl = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SupplyEmbedUrlApiFp)(this.configuration).deleteSupplyEmbedUrl(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get supply embed urls
     * @summary Get supply embed urls
     * @param {SupplyEmbedUrlApiGetSupplyEmbedUrlsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplyEmbedUrlApi
     */
    SupplyEmbedUrlApi.prototype.getSupplyEmbedUrls = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SupplyEmbedUrlApiFp)(this.configuration).getSupplyEmbedUrls(requestParameters.limit, requestParameters.id, requestParameters.subAccountId, requestParameters.sortBy, requestParameters.order, requestParameters.offset, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SupplyEmbedUrlApi;
}(base_1.BaseAPI));
exports.SupplyEmbedUrlApi = SupplyEmbedUrlApi;
/**
 * SupplySubAccountApi - axios parameter creator
 * @export
 */
var SupplySubAccountApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create a supply sub-account
         * @summary Create a supply sub-account
         * @param {SupplySubAccountCreateData} supplySubAccountCreateData Supply sub-account creation fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplySubAccount: function (supplySubAccountCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([supplySubAccountCreateData_1], args_1, true), void 0, function (supplySubAccountCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'supplySubAccountCreateData' is not null or undefined
                            (0, common_1.assertParamExists)('createSupplySubAccount', 'supplySubAccountCreateData', supplySubAccountCreateData);
                            localVarPath = "/supplySubAccounts";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(supplySubAccountCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Soft delete the supply sub-account corresponding to the Id in URL path, if one exists
         * @summary Delete a supply sub-account
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplySubAccount: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteSupplySubAccount', 'id', id);
                            localVarPath = "/supplySubAccounts/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get a list of Sub Account Owners filtered by relevant query parameters
         * @summary get a supply sub-account owner
         * @param {Array<number>} [subAccountOwnerId] comma separated list of sub account owner ids
         * @param {Array<string>} [subAccountOwnerDemandPartnerManager] comma separated list of demand partner manager uuids
         * @param {Array<string>} [subAccountOwnerDemandYieldManager] comma separated list of demand yield manager uuids
         * @param {Array<string>} [subAccountOwnerSupplydPartnerManager] comma separated list of supply partner manager uuids
         * @param {Array<string>} [subAccountOwnerSupplyYieldManager] comma separated list of supply yield manager uuids
         * @param {Array<string>} [subAccountOwnerCreatedBy] comma separated list of uuids
         * @param {Date} [subAccountOwnerCreatedAtMin] earliest bound to look at for creation date
         * @param {Date} [subAccountOwnerCreatedAtMax] latest bound to look at for creation date
         * @param {Array<string>} [subAccountOwnerDeletedBy] comma separated list of uuids
         * @param {Date} [subAccountOwnerDeletedAtMin] earliest bound for deletion date
         * @param {Date} [subAccountOwnerDeletedAtMax] latest time for deletion date
         * @param {boolean} [subAccountOwnerIsDeleted] include deleted Sub Account Owners, true/false
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplySubAccountOwners: function (subAccountOwnerId_1, subAccountOwnerDemandPartnerManager_1, subAccountOwnerDemandYieldManager_1, subAccountOwnerSupplydPartnerManager_1, subAccountOwnerSupplyYieldManager_1, subAccountOwnerCreatedBy_1, subAccountOwnerCreatedAtMin_1, subAccountOwnerCreatedAtMax_1, subAccountOwnerDeletedBy_1, subAccountOwnerDeletedAtMin_1, subAccountOwnerDeletedAtMax_1, subAccountOwnerIsDeleted_1) {
            var args_1 = [];
            for (var _i = 12; _i < arguments.length; _i++) {
                args_1[_i - 12] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([subAccountOwnerId_1, subAccountOwnerDemandPartnerManager_1, subAccountOwnerDemandYieldManager_1, subAccountOwnerSupplydPartnerManager_1, subAccountOwnerSupplyYieldManager_1, subAccountOwnerCreatedBy_1, subAccountOwnerCreatedAtMin_1, subAccountOwnerCreatedAtMax_1, subAccountOwnerDeletedBy_1, subAccountOwnerDeletedAtMin_1, subAccountOwnerDeletedAtMax_1, subAccountOwnerIsDeleted_1], args_1, true), void 0, function (subAccountOwnerId, subAccountOwnerDemandPartnerManager, subAccountOwnerDemandYieldManager, subAccountOwnerSupplydPartnerManager, subAccountOwnerSupplyYieldManager, subAccountOwnerCreatedBy, subAccountOwnerCreatedAtMin, subAccountOwnerCreatedAtMax, subAccountOwnerDeletedBy, subAccountOwnerDeletedAtMin, subAccountOwnerDeletedAtMax, subAccountOwnerIsDeleted, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/supplySubAccounts/owners";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (subAccountOwnerId) {
                                localVarQueryParameter['subAccountOwnerId'] = subAccountOwnerId.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (subAccountOwnerDemandPartnerManager) {
                                localVarQueryParameter['subAccountOwnerDemandPartnerManager'] = subAccountOwnerDemandPartnerManager.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (subAccountOwnerDemandYieldManager) {
                                localVarQueryParameter['subAccountOwnerDemandYieldManager'] = subAccountOwnerDemandYieldManager.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (subAccountOwnerSupplydPartnerManager) {
                                localVarQueryParameter['subAccountOwnerSupplydPartnerManager'] = subAccountOwnerSupplydPartnerManager.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (subAccountOwnerSupplyYieldManager) {
                                localVarQueryParameter['subAccountOwnerSupplyYieldManager'] = subAccountOwnerSupplyYieldManager.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (subAccountOwnerCreatedBy) {
                                localVarQueryParameter['subAccountOwnerCreatedBy'] = subAccountOwnerCreatedBy.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (subAccountOwnerCreatedAtMin !== undefined) {
                                localVarQueryParameter['subAccountOwnerCreatedAtMin'] = (subAccountOwnerCreatedAtMin instanceof Date) ?
                                    subAccountOwnerCreatedAtMin.toISOString() :
                                    subAccountOwnerCreatedAtMin;
                            }
                            if (subAccountOwnerCreatedAtMax !== undefined) {
                                localVarQueryParameter['subAccountOwnerCreatedAtMax'] = (subAccountOwnerCreatedAtMax instanceof Date) ?
                                    subAccountOwnerCreatedAtMax.toISOString() :
                                    subAccountOwnerCreatedAtMax;
                            }
                            if (subAccountOwnerDeletedBy) {
                                localVarQueryParameter['subAccountOwnerDeletedBy'] = subAccountOwnerDeletedBy.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (subAccountOwnerDeletedAtMin !== undefined) {
                                localVarQueryParameter['subAccountOwnerDeletedAtMin'] = (subAccountOwnerDeletedAtMin instanceof Date) ?
                                    subAccountOwnerDeletedAtMin.toISOString() :
                                    subAccountOwnerDeletedAtMin;
                            }
                            if (subAccountOwnerDeletedAtMax !== undefined) {
                                localVarQueryParameter['subAccountOwnerDeletedAtMax'] = (subAccountOwnerDeletedAtMax instanceof Date) ?
                                    subAccountOwnerDeletedAtMax.toISOString() :
                                    subAccountOwnerDeletedAtMax;
                            }
                            if (subAccountOwnerIsDeleted !== undefined) {
                                localVarQueryParameter['subAccountOwnerIsDeleted'] = subAccountOwnerIsDeleted;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get a list of supply sub-accounts filtered by relevant query parameters
         * @summary Get supply sub-accounts
         * @param {number} limit limit results
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<string>} [uuid] A comma separated list of uuids
         * @param {Array<number>} [accountId] A comma separated list of account ids
         * @param {Array<string>} [name] A comma separated list of names
         * @param {Array<string>} [companyUuid] A comma separated list of company uuids
         * @param {Array<string>} [displayName] A comma separated list of sub account display names
         * @param {Array<string>} [createdBy] comma separated list of uuids
         * @param {Date} [createdAt] creation date of object
         * @param {boolean} [excludeDeleted] ignored deleted items, default true
         * @param {boolean} [includeDeactivated] include deactivated items, default false
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplySubAccounts: function (limit_1, id_1, uuid_1, accountId_1, name_1, companyUuid_1, displayName_1, createdBy_1, createdAt_1, excludeDeleted_1, includeDeactivated_1, offset_1, sortBy_1, order_1) {
            var args_1 = [];
            for (var _i = 14; _i < arguments.length; _i++) {
                args_1[_i - 14] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, uuid_1, accountId_1, name_1, companyUuid_1, displayName_1, createdBy_1, createdAt_1, excludeDeleted_1, includeDeactivated_1, offset_1, sortBy_1, order_1], args_1, true), void 0, function (limit, id, uuid, accountId, name, companyUuid, displayName, createdBy, createdAt, excludeDeleted, includeDeactivated, offset, sortBy, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getSupplySubAccounts', 'limit', limit);
                            localVarPath = "/supplySubAccounts";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (uuid) {
                                localVarQueryParameter['uuid'] = uuid.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (accountId) {
                                localVarQueryParameter['accountId'] = accountId.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (name) {
                                localVarQueryParameter['name'] = name.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (companyUuid) {
                                localVarQueryParameter['companyUuid'] = companyUuid.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (displayName) {
                                localVarQueryParameter['displayName'] = displayName.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (createdBy) {
                                localVarQueryParameter['createdBy'] = createdBy.join(base_1.COLLECTION_FORMATS.csv);
                            }
                            if (createdAt !== undefined) {
                                localVarQueryParameter['createdAt'] = (createdAt instanceof Date) ?
                                    createdAt.toISOString() :
                                    createdAt;
                            }
                            if (excludeDeleted !== undefined) {
                                localVarQueryParameter['excludeDeleted'] = excludeDeleted;
                            }
                            if (includeDeactivated !== undefined) {
                                localVarQueryParameter['includeDeactivated'] = includeDeactivated;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Get a list of supply sub-accounts based off search parameters sent in request body
         * @summary Search for supply sub-accounts
         * @param {SupplySubAccountCriteria} [supplySubAccountCriteria]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSupplySubAccounts: function (supplySubAccountCriteria_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([supplySubAccountCriteria_1], args_1, true), void 0, function (supplySubAccountCriteria, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/supplySubAccounts/search";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(supplySubAccountCriteria, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Updates the fields of a supply sub-account that corresponds to the ID in the URL path, if on exists
         * @summary Update a supply sub-account
         * @param {number} id
         * @param {SupplySubAccountUpdateData} supplySubAccountUpdateData Update fields for supply sub-account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSupplySubAccount: function (id_1, supplySubAccountUpdateData_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1, supplySubAccountUpdateData_1], args_1, true), void 0, function (id, supplySubAccountUpdateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('updateSupplySubAccount', 'id', id);
                            // verify required parameter 'supplySubAccountUpdateData' is not null or undefined
                            (0, common_1.assertParamExists)('updateSupplySubAccount', 'supplySubAccountUpdateData', supplySubAccountUpdateData);
                            localVarPath = "/supplySubAccounts/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(supplySubAccountUpdateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SupplySubAccountApiAxiosParamCreator = SupplySubAccountApiAxiosParamCreator;
/**
 * SupplySubAccountApi - functional programming interface
 * @export
 */
var SupplySubAccountApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SupplySubAccountApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create a supply sub-account
         * @summary Create a supply sub-account
         * @param {SupplySubAccountCreateData} supplySubAccountCreateData Supply sub-account creation fields
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplySubAccount: function (supplySubAccountCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSupplySubAccount(supplySubAccountCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupplySubAccountApi.createSupplySubAccount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Soft delete the supply sub-account corresponding to the Id in URL path, if one exists
         * @summary Delete a supply sub-account
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplySubAccount: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteSupplySubAccount(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupplySubAccountApi.deleteSupplySubAccount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get a list of Sub Account Owners filtered by relevant query parameters
         * @summary get a supply sub-account owner
         * @param {Array<number>} [subAccountOwnerId] comma separated list of sub account owner ids
         * @param {Array<string>} [subAccountOwnerDemandPartnerManager] comma separated list of demand partner manager uuids
         * @param {Array<string>} [subAccountOwnerDemandYieldManager] comma separated list of demand yield manager uuids
         * @param {Array<string>} [subAccountOwnerSupplydPartnerManager] comma separated list of supply partner manager uuids
         * @param {Array<string>} [subAccountOwnerSupplyYieldManager] comma separated list of supply yield manager uuids
         * @param {Array<string>} [subAccountOwnerCreatedBy] comma separated list of uuids
         * @param {Date} [subAccountOwnerCreatedAtMin] earliest bound to look at for creation date
         * @param {Date} [subAccountOwnerCreatedAtMax] latest bound to look at for creation date
         * @param {Array<string>} [subAccountOwnerDeletedBy] comma separated list of uuids
         * @param {Date} [subAccountOwnerDeletedAtMin] earliest bound for deletion date
         * @param {Date} [subAccountOwnerDeletedAtMax] latest time for deletion date
         * @param {boolean} [subAccountOwnerIsDeleted] include deleted Sub Account Owners, true/false
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplySubAccountOwners: function (subAccountOwnerId, subAccountOwnerDemandPartnerManager, subAccountOwnerDemandYieldManager, subAccountOwnerSupplydPartnerManager, subAccountOwnerSupplyYieldManager, subAccountOwnerCreatedBy, subAccountOwnerCreatedAtMin, subAccountOwnerCreatedAtMax, subAccountOwnerDeletedBy, subAccountOwnerDeletedAtMin, subAccountOwnerDeletedAtMax, subAccountOwnerIsDeleted, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSupplySubAccountOwners(subAccountOwnerId, subAccountOwnerDemandPartnerManager, subAccountOwnerDemandYieldManager, subAccountOwnerSupplydPartnerManager, subAccountOwnerSupplyYieldManager, subAccountOwnerCreatedBy, subAccountOwnerCreatedAtMin, subAccountOwnerCreatedAtMax, subAccountOwnerDeletedBy, subAccountOwnerDeletedAtMin, subAccountOwnerDeletedAtMax, subAccountOwnerIsDeleted, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupplySubAccountApi.getSupplySubAccountOwners']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get a list of supply sub-accounts filtered by relevant query parameters
         * @summary Get supply sub-accounts
         * @param {number} limit limit results
         * @param {Array<number>} [id] A comma separated list of ids
         * @param {Array<string>} [uuid] A comma separated list of uuids
         * @param {Array<number>} [accountId] A comma separated list of account ids
         * @param {Array<string>} [name] A comma separated list of names
         * @param {Array<string>} [companyUuid] A comma separated list of company uuids
         * @param {Array<string>} [displayName] A comma separated list of sub account display names
         * @param {Array<string>} [createdBy] comma separated list of uuids
         * @param {Date} [createdAt] creation date of object
         * @param {boolean} [excludeDeleted] ignored deleted items, default true
         * @param {boolean} [includeDeactivated] include deactivated items, default false
         * @param {number} [offset] at what offset do you want to start looking at, default 0
         * @param {string} [sortBy] how do you want to sort, default created_at
         * @param {Order} [order]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplySubAccounts: function (limit, id, uuid, accountId, name, companyUuid, displayName, createdBy, createdAt, excludeDeleted, includeDeactivated, offset, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSupplySubAccounts(limit, id, uuid, accountId, name, companyUuid, displayName, createdBy, createdAt, excludeDeleted, includeDeactivated, offset, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupplySubAccountApi.getSupplySubAccounts']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get a list of supply sub-accounts based off search parameters sent in request body
         * @summary Search for supply sub-accounts
         * @param {SupplySubAccountCriteria} [supplySubAccountCriteria]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSupplySubAccounts: function (supplySubAccountCriteria, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.searchSupplySubAccounts(supplySubAccountCriteria, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupplySubAccountApi.searchSupplySubAccounts']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Updates the fields of a supply sub-account that corresponds to the ID in the URL path, if on exists
         * @summary Update a supply sub-account
         * @param {number} id
         * @param {SupplySubAccountUpdateData} supplySubAccountUpdateData Update fields for supply sub-account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSupplySubAccount: function (id, supplySubAccountUpdateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateSupplySubAccount(id, supplySubAccountUpdateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupplySubAccountApi.updateSupplySubAccount']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.SupplySubAccountApiFp = SupplySubAccountApiFp;
/**
 * SupplySubAccountApi - factory interface
 * @export
 */
var SupplySubAccountApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SupplySubAccountApiFp)(configuration);
    return {
        /**
         * Create a supply sub-account
         * @summary Create a supply sub-account
         * @param {SupplySubAccountApiCreateSupplySubAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplySubAccount: function (requestParameters, options) {
            return localVarFp.createSupplySubAccount(requestParameters.supplySubAccountCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Soft delete the supply sub-account corresponding to the Id in URL path, if one exists
         * @summary Delete a supply sub-account
         * @param {SupplySubAccountApiDeleteSupplySubAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplySubAccount: function (requestParameters, options) {
            return localVarFp.deleteSupplySubAccount(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a list of Sub Account Owners filtered by relevant query parameters
         * @summary get a supply sub-account owner
         * @param {SupplySubAccountApiGetSupplySubAccountOwnersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplySubAccountOwners: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.getSupplySubAccountOwners(requestParameters.subAccountOwnerId, requestParameters.subAccountOwnerDemandPartnerManager, requestParameters.subAccountOwnerDemandYieldManager, requestParameters.subAccountOwnerSupplydPartnerManager, requestParameters.subAccountOwnerSupplyYieldManager, requestParameters.subAccountOwnerCreatedBy, requestParameters.subAccountOwnerCreatedAtMin, requestParameters.subAccountOwnerCreatedAtMax, requestParameters.subAccountOwnerDeletedBy, requestParameters.subAccountOwnerDeletedAtMin, requestParameters.subAccountOwnerDeletedAtMax, requestParameters.subAccountOwnerIsDeleted, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a list of supply sub-accounts filtered by relevant query parameters
         * @summary Get supply sub-accounts
         * @param {SupplySubAccountApiGetSupplySubAccountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplySubAccounts: function (requestParameters, options) {
            return localVarFp.getSupplySubAccounts(requestParameters.limit, requestParameters.id, requestParameters.uuid, requestParameters.accountId, requestParameters.name, requestParameters.companyUuid, requestParameters.displayName, requestParameters.createdBy, requestParameters.createdAt, requestParameters.excludeDeleted, requestParameters.includeDeactivated, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a list of supply sub-accounts based off search parameters sent in request body
         * @summary Search for supply sub-accounts
         * @param {SupplySubAccountApiSearchSupplySubAccountsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchSupplySubAccounts: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.searchSupplySubAccounts(requestParameters.supplySubAccountCriteria, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Updates the fields of a supply sub-account that corresponds to the ID in the URL path, if on exists
         * @summary Update a supply sub-account
         * @param {SupplySubAccountApiUpdateSupplySubAccountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSupplySubAccount: function (requestParameters, options) {
            return localVarFp.updateSupplySubAccount(requestParameters.id, requestParameters.supplySubAccountUpdateData, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SupplySubAccountApiFactory = SupplySubAccountApiFactory;
/**
 * SupplySubAccountApi - object-oriented interface
 * @export
 * @class SupplySubAccountApi
 * @extends {BaseAPI}
 */
var SupplySubAccountApi = /** @class */ (function (_super) {
    __extends(SupplySubAccountApi, _super);
    function SupplySubAccountApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a supply sub-account
     * @summary Create a supply sub-account
     * @param {SupplySubAccountApiCreateSupplySubAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplySubAccountApi
     */
    SupplySubAccountApi.prototype.createSupplySubAccount = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SupplySubAccountApiFp)(this.configuration).createSupplySubAccount(requestParameters.supplySubAccountCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Soft delete the supply sub-account corresponding to the Id in URL path, if one exists
     * @summary Delete a supply sub-account
     * @param {SupplySubAccountApiDeleteSupplySubAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplySubAccountApi
     */
    SupplySubAccountApi.prototype.deleteSupplySubAccount = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SupplySubAccountApiFp)(this.configuration).deleteSupplySubAccount(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a list of Sub Account Owners filtered by relevant query parameters
     * @summary get a supply sub-account owner
     * @param {SupplySubAccountApiGetSupplySubAccountOwnersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplySubAccountApi
     */
    SupplySubAccountApi.prototype.getSupplySubAccountOwners = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.SupplySubAccountApiFp)(this.configuration).getSupplySubAccountOwners(requestParameters.subAccountOwnerId, requestParameters.subAccountOwnerDemandPartnerManager, requestParameters.subAccountOwnerDemandYieldManager, requestParameters.subAccountOwnerSupplydPartnerManager, requestParameters.subAccountOwnerSupplyYieldManager, requestParameters.subAccountOwnerCreatedBy, requestParameters.subAccountOwnerCreatedAtMin, requestParameters.subAccountOwnerCreatedAtMax, requestParameters.subAccountOwnerDeletedBy, requestParameters.subAccountOwnerDeletedAtMin, requestParameters.subAccountOwnerDeletedAtMax, requestParameters.subAccountOwnerIsDeleted, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a list of supply sub-accounts filtered by relevant query parameters
     * @summary Get supply sub-accounts
     * @param {SupplySubAccountApiGetSupplySubAccountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplySubAccountApi
     */
    SupplySubAccountApi.prototype.getSupplySubAccounts = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SupplySubAccountApiFp)(this.configuration).getSupplySubAccounts(requestParameters.limit, requestParameters.id, requestParameters.uuid, requestParameters.accountId, requestParameters.name, requestParameters.companyUuid, requestParameters.displayName, requestParameters.createdBy, requestParameters.createdAt, requestParameters.excludeDeleted, requestParameters.includeDeactivated, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a list of supply sub-accounts based off search parameters sent in request body
     * @summary Search for supply sub-accounts
     * @param {SupplySubAccountApiSearchSupplySubAccountsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplySubAccountApi
     */
    SupplySubAccountApi.prototype.searchSupplySubAccounts = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.SupplySubAccountApiFp)(this.configuration).searchSupplySubAccounts(requestParameters.supplySubAccountCriteria, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Updates the fields of a supply sub-account that corresponds to the ID in the URL path, if on exists
     * @summary Update a supply sub-account
     * @param {SupplySubAccountApiUpdateSupplySubAccountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplySubAccountApi
     */
    SupplySubAccountApi.prototype.updateSupplySubAccount = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SupplySubAccountApiFp)(this.configuration).updateSupplySubAccount(requestParameters.id, requestParameters.supplySubAccountUpdateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SupplySubAccountApi;
}(base_1.BaseAPI));
exports.SupplySubAccountApi = SupplySubAccountApi;
/**
 * SupplySubAccountDeactivationApi - axios parameter creator
 * @export
 */
var SupplySubAccountDeactivationApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create supply sub-account deactivations
         * @summary Create supply sub-account deactivations
         * @param {SupplySubAccountDeactivationCreateData} [supplySubAccountDeactivationCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplySubAccountDeactivation: function (supplySubAccountDeactivationCreateData_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([supplySubAccountDeactivationCreateData_1], args_1, true), void 0, function (supplySubAccountDeactivationCreateData, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/supplySubAccountDeactivations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(supplySubAccountDeactivationCreateData, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Delete a supply sub-account deactivation
         * @summary Delete a supply sub-account deactivation
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplySubAccountDeactivation: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteSupplySubAccountDeactivation', 'id', id);
                            localVarPath = "/supplySubAccountDeactivations/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         * Return supply sub-account deactivations based upon request parameters
         * @summary Get supply sub-account deactivations
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id]
         * @param {Array<number>} [supplySubAccountId]
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {Array<string>} [createdBy]
         * @param {Date} [deletedAtMin]
         * @param {Date} [deletedAtMax]
         * @param {boolean} [isDeleted]
         * @param {Array<string>} [deletedBy]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {string} [sortBy] The attribute with which to sort the resources.
         * @param {string} [order] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplySubAccountDeactivations: function (limit_1, id_1, supplySubAccountId_1, createdAtMin_1, createdAtMax_1, createdBy_1, deletedAtMin_1, deletedAtMax_1, isDeleted_1, deletedBy_1, offset_1, sortBy_1, order_1) {
            var args_1 = [];
            for (var _i = 13; _i < arguments.length; _i++) {
                args_1[_i - 13] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([limit_1, id_1, supplySubAccountId_1, createdAtMin_1, createdAtMax_1, createdBy_1, deletedAtMin_1, deletedAtMax_1, isDeleted_1, deletedBy_1, offset_1, sortBy_1, order_1], args_1, true), void 0, function (limit, id, supplySubAccountId, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, deletedBy, offset, sortBy, order, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'limit' is not null or undefined
                            (0, common_1.assertParamExists)('getSupplySubAccountDeactivations', 'limit', limit);
                            localVarPath = "/supplySubAccountDeactivations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:read"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            if (id) {
                                localVarQueryParameter['id'] = id;
                            }
                            if (supplySubAccountId) {
                                localVarQueryParameter['supplySubAccountId'] = supplySubAccountId;
                            }
                            if (createdAtMin !== undefined) {
                                localVarQueryParameter['createdAtMin'] = (createdAtMin instanceof Date) ?
                                    createdAtMin.toISOString() :
                                    createdAtMin;
                            }
                            if (createdAtMax !== undefined) {
                                localVarQueryParameter['createdAtMax'] = (createdAtMax instanceof Date) ?
                                    createdAtMax.toISOString() :
                                    createdAtMax;
                            }
                            if (createdBy) {
                                localVarQueryParameter['createdBy'] = createdBy;
                            }
                            if (deletedAtMin !== undefined) {
                                localVarQueryParameter['deletedAtMin'] = (deletedAtMin instanceof Date) ?
                                    deletedAtMin.toISOString() :
                                    deletedAtMin;
                            }
                            if (deletedAtMax !== undefined) {
                                localVarQueryParameter['deletedAtMax'] = (deletedAtMax instanceof Date) ?
                                    deletedAtMax.toISOString() :
                                    deletedAtMax;
                            }
                            if (isDeleted !== undefined) {
                                localVarQueryParameter['isDeleted'] = isDeleted;
                            }
                            if (deletedBy) {
                                localVarQueryParameter['deletedBy'] = deletedBy;
                            }
                            if (offset !== undefined) {
                                localVarQueryParameter['offset'] = offset;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            if (sortBy !== undefined) {
                                localVarQueryParameter['sortBy'] = sortBy;
                            }
                            if (order !== undefined) {
                                localVarQueryParameter['order'] = order;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SupplySubAccountDeactivationApiAxiosParamCreator = SupplySubAccountDeactivationApiAxiosParamCreator;
/**
 * SupplySubAccountDeactivationApi - functional programming interface
 * @export
 */
var SupplySubAccountDeactivationApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SupplySubAccountDeactivationApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create supply sub-account deactivations
         * @summary Create supply sub-account deactivations
         * @param {SupplySubAccountDeactivationCreateData} [supplySubAccountDeactivationCreateData]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplySubAccountDeactivation: function (supplySubAccountDeactivationCreateData, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createSupplySubAccountDeactivation(supplySubAccountDeactivationCreateData, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupplySubAccountDeactivationApi.createSupplySubAccountDeactivation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Delete a supply sub-account deactivation
         * @summary Delete a supply sub-account deactivation
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplySubAccountDeactivation: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteSupplySubAccountDeactivation(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupplySubAccountDeactivationApi.deleteSupplySubAccountDeactivation']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Return supply sub-account deactivations based upon request parameters
         * @summary Get supply sub-account deactivations
         * @param {number} limit The maximum number of resources to include in the results.
         * @param {Array<number>} [id]
         * @param {Array<number>} [supplySubAccountId]
         * @param {Date} [createdAtMin]
         * @param {Date} [createdAtMax]
         * @param {Array<string>} [createdBy]
         * @param {Date} [deletedAtMin]
         * @param {Date} [deletedAtMax]
         * @param {boolean} [isDeleted]
         * @param {Array<string>} [deletedBy]
         * @param {number} [offset] The number of resources to skip before the first resource in the results.
         * @param {string} [sortBy] The attribute with which to sort the resources.
         * @param {string} [order] The direction to use for ordering resources.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplySubAccountDeactivations: function (limit, id, supplySubAccountId, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, deletedBy, offset, sortBy, order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSupplySubAccountDeactivations(limit, id, supplySubAccountId, createdAtMin, createdAtMax, createdBy, deletedAtMin, deletedAtMax, isDeleted, deletedBy, offset, sortBy, order, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupplySubAccountDeactivationApi.getSupplySubAccountDeactivations']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.SupplySubAccountDeactivationApiFp = SupplySubAccountDeactivationApiFp;
/**
 * SupplySubAccountDeactivationApi - factory interface
 * @export
 */
var SupplySubAccountDeactivationApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SupplySubAccountDeactivationApiFp)(configuration);
    return {
        /**
         * Create supply sub-account deactivations
         * @summary Create supply sub-account deactivations
         * @param {SupplySubAccountDeactivationApiCreateSupplySubAccountDeactivationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSupplySubAccountDeactivation: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.createSupplySubAccountDeactivation(requestParameters.supplySubAccountDeactivationCreateData, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Delete a supply sub-account deactivation
         * @summary Delete a supply sub-account deactivation
         * @param {SupplySubAccountDeactivationApiDeleteSupplySubAccountDeactivationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplySubAccountDeactivation: function (requestParameters, options) {
            return localVarFp.deleteSupplySubAccountDeactivation(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Return supply sub-account deactivations based upon request parameters
         * @summary Get supply sub-account deactivations
         * @param {SupplySubAccountDeactivationApiGetSupplySubAccountDeactivationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSupplySubAccountDeactivations: function (requestParameters, options) {
            return localVarFp.getSupplySubAccountDeactivations(requestParameters.limit, requestParameters.id, requestParameters.supplySubAccountId, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.isDeleted, requestParameters.deletedBy, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SupplySubAccountDeactivationApiFactory = SupplySubAccountDeactivationApiFactory;
/**
 * SupplySubAccountDeactivationApi - object-oriented interface
 * @export
 * @class SupplySubAccountDeactivationApi
 * @extends {BaseAPI}
 */
var SupplySubAccountDeactivationApi = /** @class */ (function (_super) {
    __extends(SupplySubAccountDeactivationApi, _super);
    function SupplySubAccountDeactivationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create supply sub-account deactivations
     * @summary Create supply sub-account deactivations
     * @param {SupplySubAccountDeactivationApiCreateSupplySubAccountDeactivationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplySubAccountDeactivationApi
     */
    SupplySubAccountDeactivationApi.prototype.createSupplySubAccountDeactivation = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.SupplySubAccountDeactivationApiFp)(this.configuration).createSupplySubAccountDeactivation(requestParameters.supplySubAccountDeactivationCreateData, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Delete a supply sub-account deactivation
     * @summary Delete a supply sub-account deactivation
     * @param {SupplySubAccountDeactivationApiDeleteSupplySubAccountDeactivationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplySubAccountDeactivationApi
     */
    SupplySubAccountDeactivationApi.prototype.deleteSupplySubAccountDeactivation = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SupplySubAccountDeactivationApiFp)(this.configuration).deleteSupplySubAccountDeactivation(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Return supply sub-account deactivations based upon request parameters
     * @summary Get supply sub-account deactivations
     * @param {SupplySubAccountDeactivationApiGetSupplySubAccountDeactivationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplySubAccountDeactivationApi
     */
    SupplySubAccountDeactivationApi.prototype.getSupplySubAccountDeactivations = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SupplySubAccountDeactivationApiFp)(this.configuration).getSupplySubAccountDeactivations(requestParameters.limit, requestParameters.id, requestParameters.supplySubAccountId, requestParameters.createdAtMin, requestParameters.createdAtMax, requestParameters.createdBy, requestParameters.deletedAtMin, requestParameters.deletedAtMax, requestParameters.isDeleted, requestParameters.deletedBy, requestParameters.offset, requestParameters.sortBy, requestParameters.order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SupplySubAccountDeactivationApi;
}(base_1.BaseAPI));
exports.SupplySubAccountDeactivationApi = SupplySubAccountDeactivationApi;
/**
 * SupplySubAccountOwnerApi - axios parameter creator
 * @export
 */
var SupplySubAccountOwnerApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Delete a supply sub account owner
         * @summary Delete a supply sub account owner
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplySubAccountOwner: function (id_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([id_1], args_1, true), void 0, function (id, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'id' is not null or undefined
                            (0, common_1.assertParamExists)('deleteSupplySubAccountOwner', 'id', id);
                            localVarPath = "/supplySubAccounts/owners/{id}"
                                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication oauth required
                            // oauth required
                            return [4 /*yield*/, (0, common_1.setOAuthToObject)(localVarHeaderParameter, "oauth", ["finance:write"], configuration)];
                        case 1:
                            // authentication oauth required
                            // oauth required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.SupplySubAccountOwnerApiAxiosParamCreator = SupplySubAccountOwnerApiAxiosParamCreator;
/**
 * SupplySubAccountOwnerApi - functional programming interface
 * @export
 */
var SupplySubAccountOwnerApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.SupplySubAccountOwnerApiAxiosParamCreator)(configuration);
    return {
        /**
         * Delete a supply sub account owner
         * @summary Delete a supply sub account owner
         * @param {number} id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplySubAccountOwner: function (id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteSupplySubAccountOwner(id, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['SupplySubAccountOwnerApi.deleteSupplySubAccountOwner']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.SupplySubAccountOwnerApiFp = SupplySubAccountOwnerApiFp;
/**
 * SupplySubAccountOwnerApi - factory interface
 * @export
 */
var SupplySubAccountOwnerApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.SupplySubAccountOwnerApiFp)(configuration);
    return {
        /**
         * Delete a supply sub account owner
         * @summary Delete a supply sub account owner
         * @param {SupplySubAccountOwnerApiDeleteSupplySubAccountOwnerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSupplySubAccountOwner: function (requestParameters, options) {
            return localVarFp.deleteSupplySubAccountOwner(requestParameters.id, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.SupplySubAccountOwnerApiFactory = SupplySubAccountOwnerApiFactory;
/**
 * SupplySubAccountOwnerApi - object-oriented interface
 * @export
 * @class SupplySubAccountOwnerApi
 * @extends {BaseAPI}
 */
var SupplySubAccountOwnerApi = /** @class */ (function (_super) {
    __extends(SupplySubAccountOwnerApi, _super);
    function SupplySubAccountOwnerApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Delete a supply sub account owner
     * @summary Delete a supply sub account owner
     * @param {SupplySubAccountOwnerApiDeleteSupplySubAccountOwnerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SupplySubAccountOwnerApi
     */
    SupplySubAccountOwnerApi.prototype.deleteSupplySubAccountOwner = function (requestParameters, options) {
        var _this = this;
        return (0, exports.SupplySubAccountOwnerApiFp)(this.configuration).deleteSupplySubAccountOwner(requestParameters.id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return SupplySubAccountOwnerApi;
}(base_1.BaseAPI));
exports.SupplySubAccountOwnerApi = SupplySubAccountOwnerApi;
